var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoginBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 800,
    viewBox: "0 0 1440 800",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_7475_8215)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M716.606 415.234H709.406L705.806 409.063L709.406 402.892H716.606L720.103 409.063L716.606 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 423.052H696.034L692.434 416.777L696.034 410.606H703.131L706.731 416.777L703.131 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 430.766H709.406L705.806 424.595L709.406 418.32H716.606L720.103 424.595L716.606 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 423.052H722.88L719.28 416.777L722.88 410.606H729.977L733.577 416.777L729.977 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 407.52H722.88L719.28 401.349L722.88 395.075H729.977L733.577 401.349L729.977 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 399.806H709.406L705.806 393.532L709.406 387.36H716.606L720.103 393.532L716.606 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 407.52H696.034L692.434 401.349L696.034 395.075H703.131L706.731 401.349L703.131 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 430.766H682.56L678.96 424.595L682.56 418.32H689.76L693.257 424.595L689.76 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 438.48H696.034L692.434 432.308L696.034 426.137H703.131L706.731 432.308L703.131 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 446.297H709.406L705.806 440.023L709.406 433.852H716.606L720.103 440.023L716.606 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 438.48H722.88L719.28 432.308L722.88 426.137H729.977L733.577 432.308L729.977 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 430.766H736.251L732.651 424.595L736.251 418.32H743.451L747.051 424.595L743.451 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 415.234H736.251L732.651 409.063L736.251 402.892H743.451L747.051 409.063L743.451 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 399.806H736.251L732.651 393.532L736.251 387.36H743.451L747.051 393.532L743.451 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 391.989H722.88L719.28 385.817L722.88 379.646H729.977L733.577 385.817L729.977 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 384.274H709.406L705.806 378.103L709.406 371.829H716.606L720.103 378.103L716.606 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 391.989H696.034L692.434 385.817L696.034 379.646H703.131L706.731 385.817L703.131 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 399.806H682.56L678.96 393.532L682.56 387.36H689.76L693.257 393.532L689.76 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 415.234H682.56L678.96 409.063L682.56 402.892H689.76L693.257 409.063L689.76 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 438.48H669.189L665.589 432.308L669.189 426.137H676.286L679.886 432.308L676.286 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 446.297H682.56L678.96 440.023L682.56 433.852H689.76L693.257 440.023L689.76 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 454.011H696.034L692.434 447.84L696.034 441.668H703.131L706.731 447.84L703.131 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 461.726H709.406L705.806 455.554L709.406 449.383H716.606L720.103 455.554L716.606 461.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 454.011H722.88L719.28 447.84L722.88 441.668H729.977L733.577 447.84L729.977 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 446.297H736.251L732.651 440.023L736.251 433.852H743.451L747.051 440.023L743.451 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 438.48H749.726L746.126 432.308L749.726 426.137H756.823L760.423 432.308L756.823 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 423.052H749.726L746.126 416.777L749.726 410.606H756.823L760.423 416.777L756.823 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 407.52H749.726L746.126 401.349L749.726 395.075H756.823L760.423 401.349L756.823 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 391.989H749.726L746.126 385.817L749.726 379.646H756.823L760.423 385.817L756.823 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 384.274H736.251L732.651 378.103L736.251 371.829H743.451L747.051 378.103L743.451 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 376.56H722.88L719.28 370.286L722.88 364.114H729.977L733.577 370.286L729.977 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 368.743H709.406L705.806 362.571L709.406 356.4H716.606L720.103 362.571L716.606 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 376.56H696.034L692.434 370.286L696.034 364.114H703.131L706.731 370.286L703.131 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 384.274H682.56L678.96 378.103L682.56 371.829H689.76L693.257 378.103L689.76 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 391.989H669.189L665.589 385.817L669.189 379.646H676.286L679.886 385.817L676.286 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 407.52H669.189L665.589 401.349L669.189 395.075H676.286L679.886 401.349L676.286 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 423.052H669.189L665.589 416.777L669.189 410.606H676.286L679.886 416.777L676.286 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.914 446.297H655.714L652.114 440.023L655.714 433.852H662.914L666.411 440.023L662.914 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 454.011H669.189L665.589 447.84L669.189 441.668H676.286L679.886 447.84L676.286 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 461.726H682.56L678.96 455.554L682.56 449.383H689.76L693.257 455.554L689.76 461.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 469.543H696.034L692.434 463.371L696.034 457.097H703.131L706.731 463.371L703.131 469.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 477.257H709.406L705.806 471.085L709.406 464.914H716.606L720.103 471.085L716.606 477.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 469.543H722.88L719.28 463.371L722.88 457.097H729.977L733.577 463.371L729.977 469.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 461.726H736.251L732.651 455.554L736.251 449.383H743.451L747.051 455.554L743.451 461.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 454.011H749.726L746.126 447.84L749.726 441.668H756.823L760.423 447.84L756.823 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 446.297H763.097L759.497 440.023L763.097 433.852H770.297L773.897 440.023L770.297 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 430.766H763.097L759.497 424.595L763.097 418.32H770.297L773.897 424.595L770.297 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 415.234H763.097L759.497 409.063L763.097 402.892H770.297L773.897 409.063L770.297 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 399.806H763.097L759.497 393.532L763.097 387.36H770.297L773.897 393.532L770.297 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 384.274H763.097L759.497 378.103L763.097 371.829H770.297L773.897 378.103L770.297 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 376.56H749.726L746.126 370.286L749.726 364.114H756.823L760.423 370.286L756.823 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 368.743H736.251L732.754 362.571L736.251 356.4H743.451L746.949 362.571L743.451 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 360.926H722.88L719.383 354.857L722.88 348.686H729.977L733.474 354.857L729.977 360.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 353.212H709.406L705.806 347.04L709.406 340.869H716.606L720.103 347.04L716.606 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 361.029H696.034L692.434 354.857L696.034 348.583H703.131L706.731 354.857L703.131 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 368.743H682.56L678.96 362.571L682.56 356.4H689.76L693.257 362.571L689.76 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 376.56H669.189L665.589 370.286L669.189 364.114H676.286L679.886 370.286L676.286 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.914 384.274H655.714L652.114 378.103L655.714 371.829H662.914L666.411 378.103L662.914 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.914 399.806H655.714L652.114 393.532L655.714 387.36H662.914L666.411 393.532L662.914 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.914 415.234H655.714L652.114 409.063L655.714 402.892H662.914L666.411 409.063L662.914 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.914 430.766H655.714L652.114 424.595L655.714 418.32H662.914L666.411 424.595L662.914 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.44 454.011H642.24L638.743 447.84L642.24 441.668H649.44L653.04 447.84L649.44 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.914 461.726H655.714L652.114 455.554L655.714 449.383H662.914L666.411 455.554L662.914 461.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 469.543H669.189L665.589 463.371L669.189 457.097H676.286L679.886 463.371L676.286 469.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 477.257H682.56L678.96 471.085L682.56 464.914H689.76L693.257 471.085L689.76 477.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 485.074H696.034L692.434 478.8L696.034 472.628H703.131L706.731 478.8L703.131 485.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 492.789H709.406L705.806 486.618L709.406 480.343H716.606L720.103 486.618L716.606 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 485.074H722.88L719.28 478.8L722.88 472.628H729.977L733.577 478.8L729.977 485.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 477.257H736.251L732.651 471.085L736.251 464.914H743.451L747.051 471.085L743.451 477.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 469.543H749.726L746.126 463.371L749.726 457.097H756.823L760.423 463.371L756.823 469.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 461.726H763.097L759.497 455.554L763.097 449.383H770.297L773.897 455.554L770.297 461.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 454.011H776.571L772.971 447.84L776.571 441.668H783.669L787.269 447.84L783.669 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 438.48H776.571L772.971 432.308L776.571 426.137H783.669L787.269 432.308L783.669 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 423.052H776.571L772.971 416.777L776.571 410.606H783.669L787.269 416.777L783.669 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 407.52H776.571L772.971 401.349L776.571 395.075H783.669L787.269 401.349L783.669 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 391.989H776.571L772.971 385.817L776.571 379.646H783.669L787.269 385.817L783.669 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 376.56H776.571L772.971 370.286L776.571 364.114H783.669L787.269 370.286L783.669 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.886 368.229H763.406L760.217 362.572L763.406 356.915H769.886L773.177 362.572L769.886 368.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.406 341.074H725.452L724.423 339.326L725.452 337.577H727.406L728.434 339.326L727.406 341.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.166 335.417H710.743L708.583 331.612L710.743 327.703H715.166L717.429 331.612L715.166 335.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.029 345.291H696.137L692.64 339.326L696.137 333.36H703.029L706.423 339.326L703.029 345.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 353.212H682.56L678.96 347.04L682.56 340.869H689.76L693.257 347.04L689.76 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 361.029H669.189L665.589 354.857L669.189 348.583H676.286L679.886 354.857L676.286 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.914 368.743H655.714L652.114 362.571L655.714 356.4H662.914L666.411 362.571L662.914 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.44 376.56H642.24L638.743 370.286L642.24 364.114H649.44L653.04 370.286L649.44 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.44 391.989H642.24L638.743 385.817L642.24 379.646H649.44L653.04 385.817L649.44 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.44 407.52H642.24L638.743 401.349L642.24 395.075H649.44L653.04 401.349L649.44 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.44 423.052H642.24L638.743 416.777L642.24 410.606H649.44L653.04 416.777L649.44 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.44 438.48H642.24L638.743 432.308L642.24 426.137H649.44L653.04 432.308L649.44 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.069 461.726H628.869L625.269 455.554L628.869 449.383H636.069L639.566 455.554L636.069 461.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.44 469.543H642.24L638.743 463.371L642.24 457.097H649.44L653.04 463.371L649.44 469.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.914 477.257H655.714L652.114 471.085L655.714 464.914H662.914L666.411 471.085L662.914 477.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 485.074H669.189L665.589 478.8L669.189 472.628H676.286L679.886 478.8L676.286 485.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 492.789H682.56L678.96 486.618L682.56 480.343H689.76L693.257 486.618L689.76 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 500.503H696.034L692.434 494.332L696.034 488.16H703.131L706.731 494.332L703.131 500.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.651 504.926H711.36L709.714 502.046L711.36 499.166H714.651L716.297 502.046L714.651 504.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 500.503H722.88L719.28 494.332L722.88 488.16H729.977L733.577 494.332L729.977 500.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 492.789H736.251L732.651 486.618L736.251 480.343H743.451L747.051 486.618L743.451 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 485.074H749.726L746.126 478.8L749.726 472.628H756.823L760.423 478.8L756.823 485.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 477.257H763.097L759.497 471.085L763.097 464.914H770.297L773.897 471.085L770.297 477.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 469.543H776.571L772.971 463.371L776.571 457.097H783.669L787.269 463.371L783.669 469.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 461.726H789.943L786.343 455.554L789.943 449.383H797.143L800.743 455.554L797.143 461.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 446.297H789.943L786.343 440.023L789.943 433.852H797.143L800.743 440.023L797.143 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 430.766H789.943L786.343 424.595L789.943 418.32H797.143L800.743 424.595L797.143 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 415.234H789.943L786.343 409.063L789.943 402.892H797.143L800.743 409.063L797.143 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 399.806H789.943L786.343 393.532L789.943 387.36H797.143L800.743 393.532L797.143 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 384.274H789.943L786.343 378.103L789.943 371.829H797.143L800.743 378.103L797.143 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.937 368.435H790.149L786.754 362.572L790.149 356.606H796.937L800.331 362.572L796.937 368.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.714 357.634H778.526L776.88 354.857L778.526 351.977H781.714L783.36 354.857L781.714 357.634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.777 333.257H738.926L737.897 331.611L738.926 329.863H740.777L741.703 331.611L740.777 333.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.96 319.474H711.051L709.097 316.08L711.051 312.686H714.96L716.914 316.08L714.96 319.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.669 344.366H669.806L666.926 339.326L669.806 334.286H675.669L678.549 339.326L675.669 344.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.811 353.212H655.714L652.217 347.04L655.714 340.972H662.811L666.411 347.04L662.811 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.44 361.029H642.24L638.743 354.857L642.24 348.583H649.44L653.04 354.857L649.44 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.628 366.274H630.308L628.148 362.572L630.308 358.869H634.628L636.686 362.572L634.628 366.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M635.966 384.069H628.972L625.474 378.103L628.972 372.035H635.966L639.36 378.103L635.966 384.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.069 399.806H628.869L625.269 393.532L628.869 387.36H636.069L639.566 393.532L636.069 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.069 415.234H628.869L625.269 409.063L628.869 402.892H636.069L639.566 409.063L636.069 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.069 430.766H628.869L625.269 424.595L628.869 418.32H636.069L639.566 424.595L636.069 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.069 446.297H628.869L625.269 440.023L628.869 433.852H636.069L639.566 440.023L636.069 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.594 469.543H615.394L611.897 463.371L615.394 457.097H622.594L626.194 463.371L622.594 469.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.069 477.257H628.869L625.269 471.085L628.869 464.914H636.069L639.566 471.085L636.069 477.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.44 485.074H642.24L638.743 478.8L642.24 472.628H649.44L653.04 478.8L649.44 485.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.914 492.789H655.714L652.114 486.618L655.714 480.343H662.914L666.411 486.618L662.914 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.874 499.783H669.497L666.412 494.331L669.497 488.88H675.874L679.063 494.331L675.874 499.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M687.188 503.897H685.131L684.103 502.046L685.131 500.297H687.188L688.217 502.046L687.188 503.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.343 519.84H711.669L710.331 517.577L711.669 515.314H714.343L715.68 517.577L714.343 519.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 516.035H722.88L719.28 509.863L722.88 503.589H729.977L733.577 509.863L729.977 516.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 508.32H736.251L732.651 502.046L736.251 495.875H743.451L747.051 502.046L743.451 508.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 500.503H749.726L746.126 494.332L749.726 488.16H756.823L760.423 494.332L756.823 500.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 492.789H763.097L759.497 486.618L763.097 480.343H770.297L773.897 486.618L770.297 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 485.074H776.571L772.971 478.8L776.571 472.628H783.669L787.269 478.8L783.669 485.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 477.257H789.943L786.343 471.085L789.943 464.914H797.143L800.743 471.085L797.143 477.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 469.543H803.417L799.817 463.371L803.417 457.097H810.514L814.114 463.371L810.514 469.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 454.011H803.417L799.817 447.84L803.417 441.668H810.514L814.114 447.84L810.514 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 438.48H803.417L799.817 432.308L803.417 426.137H810.514L814.114 432.308L810.514 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 423.052H803.417L799.817 416.777L803.417 410.606H810.514L814.114 416.777L810.514 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 407.52H803.417L799.817 401.349L803.417 395.075H810.514L814.114 401.349L810.514 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 391.989H803.417L799.817 385.817L803.417 379.646H810.514L814.114 385.817L810.514 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 376.56H803.417L799.817 370.286L803.417 364.114H810.514L814.114 370.286L810.514 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.331 343.235H777.909L775.646 339.326L777.909 335.417H782.331L784.594 339.326L782.331 343.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.857 335.417H764.537L762.274 331.612L764.537 327.703H768.857L771.12 331.612L768.857 335.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M740.983 317.931H738.72L737.691 316.08L738.72 314.125H740.983L742.011 316.08L740.983 317.931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.406 310.115H725.348L724.32 308.263L725.348 306.515H727.406L728.537 308.263L727.406 310.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.577 304.971H710.434L707.863 300.548L710.434 296.125H715.577L718.149 300.548L715.577 304.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.08 329.658H669.394L666 323.795L669.394 318.035H676.08L679.474 323.795L676.08 329.658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.988 336.24H656.537L653.863 331.611L656.537 326.88H661.988L664.766 331.611L661.988 336.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.56 340.56H645.12L644.503 339.326L645.12 338.092H646.56L647.28 339.326L646.56 340.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M621.051 389.315H617.04L614.983 385.817L617.04 382.32H621.051L623.006 385.817L621.051 389.315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.594 407.52H615.394L611.897 401.349L615.394 395.075H622.594L626.194 401.349L622.594 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.594 423.052H615.394L611.897 416.777L615.394 410.606H622.594L626.194 416.777L622.594 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.594 438.48H615.394L611.897 432.308L615.394 426.137H622.594L626.194 432.308L622.594 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.594 454.011H615.394L611.897 447.84L615.394 441.668H622.594L626.194 447.84L622.594 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.343 472.32H604.903L604.183 471.086L604.903 469.852H606.343L606.96 471.086L606.343 472.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.594 484.971H615.497L612 478.8L615.497 472.731H622.594L626.091 478.8L622.594 484.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636.069 492.789H628.869L625.269 486.618L628.869 480.343H636.069L639.566 486.618L636.069 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.44 500.503H642.24L638.743 494.332L642.24 488.16H649.44L653.04 494.332L649.44 500.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.783 506.366H656.846L654.274 502.046L656.846 497.726H661.783L664.251 502.046L661.783 506.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.989 538.252H710.023L707.04 533.109L710.023 527.966H715.989L718.971 533.109L715.989 538.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 531.566H722.88L719.28 525.292L722.88 519.12H729.977L733.577 525.292L729.977 531.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 523.749H736.251L732.651 517.577L736.251 511.406H743.451L747.051 517.577L743.451 523.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 516.035H749.726L746.126 509.863L749.726 503.589H756.823L760.423 509.863L756.823 516.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 508.32H763.097L759.497 502.046L763.097 495.875H770.297L773.897 502.046L770.297 508.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 500.503H776.571L772.971 494.332L776.571 488.16H783.669L787.269 494.332L783.669 500.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 492.789H789.943L786.343 486.618L789.943 480.343H797.143L800.743 486.618L797.143 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 485.074H803.417L799.817 478.8L803.417 472.628H810.514L814.114 478.8L810.514 485.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 477.257H816.789L813.189 471.085L816.789 464.914H823.989L827.589 471.085L823.989 477.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 461.726H816.789L813.189 455.554L816.789 449.383H823.989L827.589 455.554L823.989 461.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 446.297H816.789L813.189 440.023L816.789 433.852H823.989L827.589 440.023L823.989 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 430.766H816.789L813.189 424.595L816.789 418.32H823.989L827.589 424.595L823.989 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 415.234H816.789L813.189 409.063L816.789 402.892H823.989L827.589 409.063L823.989 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 399.806H816.789L813.189 393.532L816.789 387.36H823.989L827.589 393.532L823.989 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 384.274H816.789L813.189 378.103L816.789 371.829H823.989L827.589 378.103L823.989 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M822.857 366.891H817.92L815.349 362.571L817.92 358.251H822.857L825.429 362.571L822.857 366.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.006 348.069H819.771L819.257 347.04L819.771 346.012H821.006L821.52 347.04L821.006 348.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M808.869 342.515H805.063L803.211 339.326L805.063 336.035H808.869L810.72 339.326L808.869 342.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.937 337.474H790.149L786.754 331.611L790.149 325.646H796.937L800.331 331.611L796.937 337.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M781.406 326.057H778.834L777.497 323.794L778.834 321.531H781.406L782.743 323.794L781.406 326.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.194 322.046H763.2L759.806 316.08L763.2 310.012H770.194L773.588 316.08L770.194 322.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.383 311.966H751.166L749.006 308.263L751.166 304.663H755.383L757.44 308.263L755.383 311.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.6 303.531H738.103L736.354 300.548L738.103 297.565H741.6L743.246 300.548L741.6 303.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 299.006H722.88L719.28 292.834L722.88 286.56H729.977L733.577 292.834L729.977 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 291.291H709.406L705.806 285.017L709.406 278.846H716.606L720.103 285.017L716.606 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.514 297.874H696.651L693.771 292.834L696.651 287.794H702.514L705.394 292.834L702.514 297.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M688.834 305.178H683.486L680.812 300.549L683.486 295.92H688.834L691.406 300.549L688.834 305.178Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 314.537H669.189L665.589 308.263L669.189 302.092H676.286L679.886 308.263L676.286 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.914 322.251H655.714L652.114 316.08L655.714 309.908H662.914L666.411 316.08L662.914 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.44 329.965H642.24L638.743 323.794L642.24 317.623H649.44L653.04 323.794L649.44 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.063 411.635H604.08L602.64 409.063L604.08 406.492H607.063L608.606 409.063L607.063 411.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.811 430.251H602.331L599.04 424.594L602.331 418.937H608.811L612.103 424.594L608.811 430.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.811 445.68H602.331L599.04 440.023L602.331 434.469H608.811L612.103 440.023L608.811 445.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.811 461.212H602.331L599.04 455.555L602.331 449.897H608.811L612.103 455.555L608.811 461.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.611 495.36H618.48L617.863 494.332L618.48 493.303H619.611L620.228 494.332L619.611 495.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.703 504.206H631.234L630 502.046L631.234 499.886H633.703L634.937 502.046L633.703 504.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 546.994H722.88L719.28 540.823L722.88 534.651H729.977L733.577 540.823L729.977 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 539.28H736.251L732.651 533.109L736.251 526.834H743.451L747.051 533.109L743.451 539.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 531.566H749.726L746.126 525.292L749.726 519.12H756.823L760.423 525.292L756.823 531.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 523.749H763.097L759.497 517.577L763.097 511.406H770.297L773.897 517.577L770.297 523.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 516.035H776.571L772.971 509.863L776.571 503.589H783.669L787.269 509.863L783.669 516.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 508.32H789.943L786.343 502.046L789.943 495.875H797.143L800.743 502.046L797.143 508.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 500.503H803.417L799.817 494.332L803.417 488.16H810.514L814.114 494.332L810.514 500.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 492.789H816.789L813.189 486.618L816.789 480.343H823.989L827.589 486.618L823.989 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 485.074H830.263L826.663 478.8L830.263 472.628H837.36L840.96 478.8L837.36 485.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 469.543H830.263L826.663 463.371L830.263 457.097H837.36L840.96 463.371L837.36 469.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 454.011H830.263L826.663 447.84L830.263 441.668H837.36L840.96 447.84L837.36 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 438.48H830.263L826.663 432.308L830.263 426.137H837.36L840.96 432.308L837.36 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 422.845H830.263L826.766 416.777L830.263 410.708H837.36L840.857 416.777L837.36 422.845Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.994 403.303H832.629L831.497 401.349L832.629 399.292H834.994L836.126 401.349L834.994 403.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 391.989H830.263L826.663 385.817L830.263 379.646H837.36L840.96 385.817L837.36 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 376.56H830.263L826.663 370.286L830.263 364.114H837.36L840.96 370.286L837.36 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 361.029H830.263L826.663 354.857L830.263 348.583H837.36L840.96 354.857L837.36 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 345.497H830.263L826.663 339.326L830.263 333.154H837.36L840.96 339.326L837.36 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.886 337.68H816.891L813.394 331.611L816.891 325.44H823.886L827.383 331.611L823.886 337.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 329.965H803.417L799.817 323.794L803.417 317.623H810.514L814.114 323.794L810.514 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 322.251H789.943L786.343 316.08L789.943 309.908H797.143L800.743 316.08L797.143 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.566 314.331H776.674L773.177 308.263L776.674 302.297H783.566L787.063 308.263L783.566 314.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 306.72H763.097L759.497 300.549L763.097 294.377H770.297L773.897 300.549L770.297 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 299.006H749.726L746.126 292.834L749.726 286.56H756.823L760.423 292.834L756.823 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.246 290.983H736.354L732.96 285.017L736.354 279.051H743.246L746.743 285.017L743.246 290.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 283.474H722.88L719.28 277.303L722.88 271.131H729.977L733.577 277.303L729.977 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 275.76H709.406L705.806 269.589L709.406 263.314H716.606L720.103 269.589L716.606 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 283.474H696.034L692.434 277.303L696.034 271.131H703.131L706.731 277.303L703.131 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 291.291H682.56L678.96 285.017L682.56 278.846H689.76L693.257 285.017L689.76 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.977 298.491H669.394L666.103 292.834L669.394 287.074H675.977L679.269 292.834L675.977 298.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.914 306.72H655.714L652.114 300.549L655.714 294.377H662.914L666.411 300.549L662.914 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M649.44 314.537H642.24L638.743 308.263L642.24 302.092H649.44L653.04 308.263L649.44 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.669 562.012H723.189L719.897 556.354L723.189 550.697H729.669L732.96 556.354L729.669 562.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 554.811H736.251L732.651 548.537L736.251 542.366H743.451L747.051 548.537L743.451 554.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 546.994H749.726L746.126 540.823L749.726 534.651H756.823L760.423 540.823L756.823 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 539.28H763.097L759.497 533.109L763.097 526.834H770.297L773.897 533.109L770.297 539.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 531.566H776.571L772.971 525.292L776.571 519.12H783.669L787.269 525.292L783.669 531.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 523.749H789.943L786.343 517.577L789.943 511.406H797.143L800.743 517.577L797.143 523.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 516.035H803.417L799.817 509.863L803.417 503.589H810.514L814.114 509.863L810.514 516.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 508.32H816.789L813.189 502.046L816.789 495.875H823.989L827.589 502.046L823.989 508.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 500.503H830.263L826.663 494.332L830.263 488.16H837.36L840.96 494.332L837.36 500.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 492.789H843.634L840.034 486.618L843.634 480.343H850.834L854.434 486.618L850.834 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 477.257H843.634L840.034 471.085L843.634 464.914H850.834L854.434 471.085L850.834 477.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 461.726H843.634L840.034 455.554L843.634 449.383H850.834L854.434 455.554L850.834 461.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M849.703 444.343H844.766L842.297 440.023L844.766 435.806H849.703L852.172 440.023L849.703 444.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M847.954 425.726H846.514L845.897 424.595L846.514 423.36H847.954L848.571 424.595L847.954 425.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 415.234H843.634L840.137 409.063L843.634 402.892H850.834L854.331 409.063L850.834 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 399.806H843.634L840.034 393.532L843.634 387.36H850.834L854.434 393.532L850.834 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 384.274H843.634L840.034 378.103L843.634 371.829H850.834L854.434 378.103L850.834 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 368.743H843.634L840.034 362.571L843.634 356.4H850.834L854.434 362.571L850.834 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 353.212H843.634L840.034 347.04L843.634 340.869H850.834L854.434 347.04L850.834 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 337.783H843.634L840.034 331.611L843.634 325.337H850.834L854.434 331.611L850.834 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 329.965H830.263L826.663 323.794L830.263 317.623H837.36L840.96 323.794L837.36 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 322.251H816.789L813.189 316.08L816.789 309.908H823.989L827.589 316.08L823.989 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 314.537H803.417L799.817 308.263L803.417 302.092H810.514L814.114 308.263L810.514 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 306.72H789.943L786.343 300.549L789.943 294.377H797.143L800.743 300.549L797.143 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 299.006H776.571L772.971 292.834L776.571 286.56H783.669L787.269 292.834L783.669 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 291.291H763.097L759.497 285.017L763.097 278.846H770.297L773.897 285.017L770.297 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 283.474H749.726L746.126 277.303L749.726 271.131H756.823L760.423 277.303L756.823 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 275.76H736.251L732.651 269.589L736.251 263.314H743.451L747.051 269.589L743.451 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 268.046H722.88L719.28 261.772L722.88 255.6H729.977L733.577 261.772L729.977 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 260.229H709.406L705.806 254.057L709.406 247.886H716.606L720.103 254.057L716.606 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 268.046H696.034L692.434 261.772L696.034 255.6H703.131L706.731 261.772L703.131 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 275.76H682.56L678.96 269.589L682.56 263.314H689.76L693.257 269.589L689.76 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.183 283.268H669.291L665.794 277.303L669.291 271.337H676.183L679.577 277.303L676.183 283.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.869 294.48H644.914L643.886 292.835L644.914 291.086H646.869L647.794 292.835L646.869 294.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M579.394 441.154H578.16L577.543 440.023L578.16 438.994H579.394L580.011 440.023L579.394 441.154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.743 575.897H724.114L721.749 571.783L724.114 567.771H728.743L731.109 571.783L728.743 575.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 570.24H736.251L732.651 564.068L736.251 557.897H743.451L747.051 564.068L743.451 570.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 562.526H749.726L746.126 556.354L749.726 550.08H756.823L760.423 556.354L756.823 562.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 554.811H763.097L759.497 548.537L763.097 542.366H770.297L773.897 548.537L770.297 554.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 546.994H776.571L772.971 540.823L776.571 534.651H783.669L787.269 540.823L783.669 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 539.28H789.943L786.343 533.109L789.943 526.834H797.143L800.743 533.109L797.143 539.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 531.566H803.417L799.817 525.292L803.417 519.12H810.514L814.114 525.292L810.514 531.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 523.749H816.789L813.189 517.577L816.789 511.406H823.989L827.589 517.577L823.989 523.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 516.035H830.263L826.663 509.863L830.263 503.589H837.36L840.96 509.863L837.36 516.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 508.32H843.634L840.034 502.046L843.634 495.875H850.834L854.434 502.046L850.834 508.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 500.503H857.109L853.509 494.332L857.109 488.16H864.206L867.806 494.332L864.206 500.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 485.074H857.109L853.509 478.8L857.109 472.628H864.206L867.806 478.8L864.206 485.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 469.44H857.109L853.612 463.371L857.109 457.2H864.206L867.703 463.371L864.206 469.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.84 449.897H859.474L858.24 447.84L859.474 445.68H861.84L863.074 447.84L861.84 449.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M863.897 437.862H857.52L854.331 432.308L857.52 426.754H863.897L867.086 432.308L863.897 437.862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 423.052H857.109L853.509 416.777L857.109 410.606H864.206L867.806 416.777L864.206 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 407.52H857.109L853.509 401.349L857.109 395.075H864.206L867.806 401.349L864.206 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 391.989H857.109L853.509 385.817L857.109 379.646H864.206L867.806 385.817L864.206 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 376.56H857.109L853.509 370.286L857.109 364.114H864.206L867.806 370.286L864.206 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 361.029H857.109L853.509 354.857L857.109 348.583H864.206L867.806 354.857L864.206 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 345.497H857.109L853.509 339.326L857.109 333.154H864.206L867.806 339.326L864.206 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 329.965H857.109L853.509 323.794L857.109 317.623H864.206L867.806 323.794L864.206 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 322.251H843.634L840.034 316.08L843.634 309.908H850.834L854.434 316.08L850.834 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 314.537H830.263L826.663 308.263L830.263 302.092H837.36L840.96 308.263L837.36 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 306.72H816.789L813.189 300.549L816.789 294.377H823.989L827.589 300.549L823.989 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 299.006H803.417L799.817 292.834L803.417 286.56H810.514L814.114 292.834L810.514 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 291.291H789.943L786.343 285.017L789.943 278.846H797.143L800.743 285.017L797.143 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 283.474H776.571L772.971 277.303L776.571 271.131H783.669L787.269 277.303L783.669 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 275.76H763.097L759.497 269.589L763.097 263.314H770.297L773.897 269.589L770.297 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 268.046H749.726L746.126 261.772L749.726 255.6H756.823L760.423 261.772L756.823 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 260.229H736.251L732.651 254.057L736.251 247.886H743.451L747.051 254.057L743.451 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 252.514H722.88L719.28 246.343L722.88 240.068H729.977L733.577 246.343L729.977 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 244.8H709.406L705.806 238.525L709.406 232.354H716.606L720.103 238.525L716.606 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M703.131 252.514H696.034L692.434 246.343L696.034 240.068H703.131L706.731 246.343L703.131 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M689.76 260.229H682.56L678.96 254.057L682.56 247.886H689.76L693.257 254.057L689.76 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 267.943H669.189L665.589 261.772L669.189 255.703H676.286L679.783 261.772L676.286 267.943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.4 274.937H656.229L653.143 269.589L656.229 264.24H662.4L665.486 269.589L662.4 274.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 585.772H736.251L732.651 579.6L736.251 573.429H743.451L747.051 579.6L743.451 585.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 578.057H749.726L746.126 571.783L749.726 565.611H756.823L760.423 571.783L756.823 578.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 570.24H763.097L759.497 564.068L763.097 557.897H770.297L773.897 564.068L770.297 570.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 562.526H776.571L772.971 556.354L776.571 550.08H783.669L787.269 556.354L783.669 562.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 554.811H789.943L786.343 548.537L789.943 542.366H797.143L800.743 548.537L797.143 554.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 546.994H803.417L799.817 540.823L803.417 534.651H810.514L814.114 540.823L810.514 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 539.28H816.789L813.189 533.109L816.789 526.834H823.989L827.589 533.109L823.989 539.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 531.566H830.263L826.663 525.292L830.263 519.12H837.36L840.96 525.292L837.36 531.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 523.749H843.634L840.034 517.577L843.634 511.406H850.834L854.434 517.577L850.834 523.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 516.035H857.109L853.509 509.863L857.109 503.589H864.206L867.806 509.863L864.206 516.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 508.32H870.48L866.88 502.046L870.48 495.875H877.68L881.28 502.046L877.68 508.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 492.789H870.48L866.88 486.618L870.48 480.343H877.68L881.28 486.618L877.68 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 477.257H870.48L866.983 471.085L870.48 464.914H877.68L881.177 471.085L877.68 477.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.371 461.314H870.789L867.394 455.554L870.789 449.794H877.371L880.766 455.554L877.371 461.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 446.297H870.48L866.88 440.023L870.48 433.852H877.68L881.28 440.023L877.68 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 430.766H870.48L866.88 424.595L870.48 418.32H877.68L881.28 424.595L877.68 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 415.234H870.48L866.88 409.063L870.48 402.892H877.68L881.28 409.063L877.68 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 399.806H870.48L866.88 393.532L870.48 387.36H877.68L881.28 393.532L877.68 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 384.274H870.48L866.88 378.103L870.48 371.829H877.68L881.28 378.103L877.68 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 368.743H870.48L866.88 362.571L870.48 356.4H877.68L881.28 362.571L877.68 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 353.212H870.48L866.88 347.04L870.48 340.869H877.68L881.28 347.04L877.68 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 337.783H870.48L866.88 331.611L870.48 325.337H877.68L881.28 331.611L877.68 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 322.251H870.48L866.88 316.08L870.48 309.908H877.68L881.28 316.08L877.68 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 314.537H857.109L853.509 308.263L857.109 302.092H864.206L867.806 308.263L864.206 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 306.72H843.634L840.034 300.549L843.634 294.377H850.834L854.434 300.549L850.834 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 299.006H830.263L826.663 292.834L830.263 286.56H837.36L840.96 292.834L837.36 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 291.291H816.789L813.189 285.017L816.789 278.846H823.989L827.589 285.017L823.989 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 283.474H803.417L799.817 277.303L803.417 271.131H810.514L814.114 277.303L810.514 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 275.76H789.943L786.343 269.589L789.943 263.314H797.143L800.743 269.589L797.143 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 268.046H776.571L772.971 261.772L776.571 255.6H783.669L787.269 261.772L783.669 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 260.229H763.097L759.497 254.057L763.097 247.886H770.297L773.897 254.057L770.297 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 252.514H749.726L746.126 246.343L749.726 240.068H756.823L760.423 246.343L756.823 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 244.8H736.251L732.651 238.525L736.251 232.354H743.451L747.051 238.525L743.451 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 236.983H722.88L719.28 230.811L722.88 224.64H729.977L733.577 230.811L729.977 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.297 228.754H709.714L706.32 223.097L709.714 217.337H716.297L719.588 223.097L716.297 228.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M701.486 234.206H697.68L695.726 230.812L697.68 227.417H701.486L703.44 230.812L701.486 234.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M686.674 239.554H685.543L685.029 238.526L685.543 237.6H686.674L687.291 238.526L686.674 239.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 252.411H669.189L665.589 246.343L669.189 240.171H676.286L679.783 246.343L676.286 252.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.034 255.292H658.594L657.771 254.057L658.594 252.72H660.034L660.754 254.057L660.034 255.292Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.537 606.549H724.32L722.16 602.846L724.32 599.143H728.537L730.697 602.846L728.537 606.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 601.303H736.251L732.651 595.132L736.251 588.857H743.451L747.051 595.132L743.451 601.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 593.486H749.726L746.126 587.314L749.726 581.143H756.823L760.423 587.314L756.823 593.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 585.772H763.097L759.497 579.6L763.097 573.429H770.297L773.897 579.6L770.297 585.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 578.057H776.571L772.971 571.783L776.571 565.611H783.669L787.269 571.783L783.669 578.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 570.24H789.943L786.343 564.068L789.943 557.897H797.143L800.743 564.068L797.143 570.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 562.526H803.417L799.817 556.354L803.417 550.08H810.514L814.114 556.354L810.514 562.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 554.811H816.789L813.189 548.537L816.789 542.366H823.989L827.589 548.537L823.989 554.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 546.994H830.263L826.663 540.823L830.263 534.651H837.36L840.96 540.823L837.36 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 539.28H843.634L840.034 533.109L843.634 526.834H850.834L854.434 533.109L850.834 539.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864 531.155H857.314L854.023 525.292L857.314 519.532H864L867.394 525.292L864 531.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.034 521.074H872.126L870.069 517.577L872.126 514.08H876.034L878.091 517.577L876.034 521.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.64 499.68H884.469L881.383 494.331L884.469 488.982H890.64L893.726 494.331L890.64 499.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 485.074H883.954L880.354 478.8L883.954 472.628H891.051L894.651 478.8L891.051 485.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.097 466.046H885.909L884.366 463.371L885.909 460.594H889.097L890.64 463.371L889.097 466.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 454.011H883.954L880.457 447.84L883.954 441.668H891.051L894.651 447.84L891.051 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 438.48H883.954L880.354 432.308L883.954 426.137H891.051L894.651 432.308L891.051 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 423.052H883.954L880.354 416.777L883.954 410.606H891.051L894.651 416.777L891.051 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 407.52H883.954L880.354 401.349L883.954 395.075H891.051L894.651 401.349L891.051 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 391.989H883.954L880.354 385.817L883.954 379.646H891.051L894.651 385.817L891.051 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 376.56H883.954L880.354 370.286L883.954 364.114H891.051L894.651 370.286L891.051 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 361.029H883.954L880.354 354.857L883.954 348.583H891.051L894.651 354.857L891.051 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 345.497H883.954L880.354 339.326L883.954 333.154H891.051L894.651 339.326L891.051 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 329.965H883.954L880.354 323.794L883.954 317.623H891.051L894.651 323.794L891.051 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 314.537H883.954L880.354 308.263L883.954 302.092H891.051L894.651 308.263L891.051 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 306.72H870.48L866.88 300.549L870.48 294.377H877.68L881.28 300.549L877.68 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 299.006H857.109L853.509 292.834L857.109 286.56H864.206L867.806 292.834L864.206 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 291.291H843.634L840.034 285.017L843.634 278.846H850.834L854.434 285.017L850.834 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 283.474H830.263L826.663 277.303L830.263 271.131H837.36L840.96 277.303L837.36 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 275.76H816.789L813.189 269.589L816.789 263.314H823.989L827.589 269.589L823.989 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 268.046H803.417L799.817 261.772L803.417 255.6H810.514L814.114 261.772L810.514 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 260.229H789.943L786.343 254.057L789.943 247.886H797.143L800.743 254.057L797.143 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 252.514H776.571L772.971 246.343L776.571 240.068H783.669L787.269 246.343L783.669 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 244.8H763.097L759.497 238.525L763.097 232.354H770.297L773.897 238.525L770.297 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 236.983H749.726L746.126 230.811L749.726 224.64H756.823L760.423 230.811L756.823 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.217 227.211H737.486L735.017 223.097L737.486 218.88H742.217L744.686 223.097L742.217 227.211Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.229 218.468H724.526L722.674 215.28L724.526 212.091H728.229L730.08 215.28L728.229 218.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.269 211.372H710.743L708.48 207.566L710.743 203.657H715.269L717.429 207.566L715.269 211.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M676.286 236.983H669.189L665.589 230.811L669.189 224.64H676.286L679.886 230.811L676.286 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.914 244.8H655.714L652.114 238.525L655.714 232.354H662.914L666.411 238.525L662.914 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.669 623.931H723.189L720 618.377L723.189 612.822H729.669L732.857 618.377L729.669 623.931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 616.834H736.251L732.651 610.56L736.251 604.389H743.451L747.051 610.56L743.451 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 609.017H749.726L746.126 602.846L749.726 596.674H756.823L760.423 602.846L756.823 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 601.303H763.097L759.497 595.132L763.097 588.857H770.297L773.897 595.132L770.297 601.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 593.486H776.571L772.971 587.314L776.571 581.143H783.669L787.269 587.314L783.669 593.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 585.772H789.943L786.343 579.6L789.943 573.429H797.143L800.743 579.6L797.143 585.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 578.057H803.417L799.817 571.783L803.417 565.611H810.514L814.114 571.783L810.514 578.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 570.24H816.789L813.189 564.068L816.789 557.897H823.989L827.589 564.068L823.989 570.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 562.526H830.263L826.663 556.354L830.263 550.08H837.36L840.96 556.354L837.36 562.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.731 554.708H843.737L840.24 548.537L843.737 542.468H850.731L854.331 548.537L850.731 554.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.674 474.068H899.177L897.531 471.085L899.177 468.103H902.674L904.423 471.085L902.674 474.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 446.297H897.326L893.829 440.023L897.326 433.852H904.526L908.126 440.023L904.526 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 430.766H897.326L893.829 424.595L897.326 418.32H904.526L908.126 424.595L904.526 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 415.234H897.326L893.829 409.063L897.326 402.892H904.526L908.126 409.063L904.526 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 399.703H897.326L893.829 393.532L897.326 387.36H904.526L908.023 393.532L904.526 399.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.954 379.748H900L898.971 378.103L900 376.354H901.954L902.88 378.103L901.954 379.748Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 368.743H897.326L893.829 362.571L897.326 356.4H904.526L908.126 362.571L904.526 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 353.212H897.326L893.829 347.04L897.326 340.869H904.526L908.126 347.04L904.526 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 337.783H897.326L893.829 331.611L897.326 325.337H904.526L908.126 331.611L904.526 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 322.251H897.326L893.829 316.08L897.326 309.908H904.526L908.126 316.08L904.526 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 306.72H897.326L893.829 300.549L897.326 294.377H904.526L908.126 300.549L904.526 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 299.006H883.954L880.354 292.834L883.954 286.56H891.051L894.651 292.834L891.051 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 291.291H870.48L866.88 285.017L870.48 278.846H877.68L881.28 285.017L877.68 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 283.474H857.109L853.509 277.303L857.109 271.131H864.206L867.806 277.303L864.206 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 275.76H843.634L840.034 269.589L843.634 263.314H850.834L854.434 269.589L850.834 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 268.046H830.263L826.663 261.772L830.263 255.6H837.36L840.96 261.772L837.36 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 260.229H816.789L813.189 254.057L816.789 247.886H823.989L827.589 254.057L823.989 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 252.514H803.417L799.817 246.343L803.417 240.068H810.514L814.114 246.343L810.514 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 244.8H789.943L786.343 238.525L789.943 232.354H797.143L800.743 238.525L797.143 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 236.983H776.571L772.971 230.811L776.571 224.64H783.669L787.269 230.811L783.669 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 229.268H763.097L759.497 223.097L763.097 216.823H770.297L773.897 223.097L770.297 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 213.737H736.251L732.754 207.565L736.251 201.394H743.451L746.949 207.565L743.451 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 205.92H722.88L719.383 199.748L722.88 193.68H729.977L733.474 199.748L729.977 205.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 198.206H709.406L705.806 192.034L709.406 185.863H716.606L720.103 192.034L716.606 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.868 202.012H698.297L697.063 199.749L698.297 197.589H700.868L702.103 199.749L700.868 202.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M674.846 219.086H670.526L668.366 215.281L670.526 211.578H674.846L677.006 215.281L674.846 219.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.269 226.492H657.36L655.303 223.097L657.36 219.6H661.269L663.223 223.097L661.269 226.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.926 236.057H642.857L639.874 230.811L642.857 225.565H648.926L651.909 230.811L648.926 236.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633.909 241.097H631.029L629.589 238.526L631.029 236.057H633.909L635.349 238.526L633.909 241.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 632.263H736.251L732.651 626.092L736.251 619.92H743.451L747.051 626.092L743.451 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 624.549H749.726L746.126 618.377L749.726 612.103H756.823L760.423 618.377L756.823 624.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 616.834H763.097L759.497 610.56L763.097 604.389H770.297L773.897 610.56L770.297 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 609.017H776.571L772.971 602.846L776.571 596.674H783.669L787.269 602.846L783.669 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 601.303H789.943L786.343 595.132L789.943 588.857H797.143L800.743 595.132L797.143 601.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 593.486H803.417L799.817 587.314L803.417 581.143H810.514L814.114 587.314L810.514 593.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 585.772H816.789L813.189 579.6L816.789 573.429H823.989L827.589 579.6L823.989 585.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 578.057H830.263L826.663 571.783L830.263 565.611H837.36L840.96 571.783L837.36 578.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.731 570.24H843.737L840.137 564.069L843.737 558H850.731L854.331 564.069L850.731 570.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.794 438.377H910.903L907.406 432.309L910.903 426.24H917.794L921.291 432.309L917.794 438.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 423.052H910.8L907.2 416.777L910.8 410.606H917.897L921.497 416.777L917.897 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.794 407.314H910.903L907.406 401.348L910.903 395.28H917.794L921.291 401.348L917.794 407.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.28 390.857H911.417L908.537 385.817L911.417 380.777H917.28L920.16 385.817L917.28 390.857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 376.56H910.8L907.2 370.286L910.8 364.114H917.897L921.497 370.286L917.897 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 361.029H910.8L907.2 354.857L910.8 348.583H917.897L921.497 354.857L917.897 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 345.497H910.8L907.2 339.326L910.8 333.154H917.897L921.497 339.326L917.897 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 329.965H910.8L907.2 323.794L910.8 317.623H917.897L921.497 323.794L917.897 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 314.537H910.8L907.2 308.263L910.8 302.092H917.897L921.497 308.263L917.897 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 299.006H910.8L907.2 292.834L910.8 286.56H917.897L921.497 292.834L917.897 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 291.291H897.326L893.829 285.017L897.326 278.846H904.526L908.126 285.017L904.526 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 283.474H883.954L880.354 277.303L883.954 271.131H891.051L894.651 277.303L891.051 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 275.76H870.48L866.88 269.589L870.48 263.314H877.68L881.28 269.589L877.68 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 268.046H857.109L853.509 261.772L857.109 255.6H864.206L867.806 261.772L864.206 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 260.229H843.634L840.034 254.057L843.634 247.886H850.834L854.434 254.057L850.834 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 252.514H830.263L826.663 246.343L830.263 240.068H837.36L840.96 246.343L837.36 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 244.8H816.789L813.189 238.525L816.789 232.354H823.989L827.589 238.525L823.989 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 236.983H803.417L799.817 230.811L803.417 224.64H810.514L814.114 230.811L810.514 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 229.268H789.943L786.343 223.097L789.943 216.823H797.143L800.743 223.097L797.143 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 221.451H776.571L772.971 215.28L776.571 209.108H783.669L787.269 215.28L783.669 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.091 213.429H763.303L759.909 207.566L763.303 201.703H770.091L773.486 207.566L770.091 213.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M753.943 200.983H752.606L751.886 199.749L752.606 198.617H753.943L754.663 199.749L753.943 200.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 198.206H736.251L732.651 192.034L736.251 185.863H743.451L747.051 192.034L743.451 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 190.492H722.88L719.28 184.32L722.88 178.046H729.977L733.577 184.32L729.977 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 182.777H709.406L705.806 176.503L709.406 170.332H716.606L720.103 176.503L716.606 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M702.617 189.566H696.549L693.463 184.32L696.549 179.074H702.617L705.6 184.32L702.617 189.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.811 213.634H655.714L652.217 207.565L655.714 201.394H662.811L666.411 207.565L662.811 213.634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.949 543.086H510.274L509.04 540.823L510.274 538.56H512.949L514.286 540.823L512.949 543.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.349 647.691H736.354L732.857 641.623L736.354 635.554H743.349L746.846 641.623L743.349 647.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 640.08H749.726L746.126 633.806L749.726 627.635H756.823L760.423 633.806L756.823 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 632.263H763.097L759.497 626.092L763.097 619.92H770.297L773.897 626.092L770.297 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 624.549H776.571L772.971 618.377L776.571 612.103H783.669L787.269 618.377L783.669 624.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 616.834H789.943L786.343 610.56L789.943 604.389H797.143L800.743 610.56L797.143 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 609.017H803.417L799.817 602.846L803.417 596.674H810.514L814.114 602.846L810.514 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 601.303H816.789L813.189 595.132L816.789 588.857H823.989L827.589 595.132L823.989 601.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 593.486H830.263L826.663 587.314L830.263 581.143H837.36L840.96 587.314L837.36 593.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 585.772H843.634L840.034 579.6L843.634 573.429H850.834L854.434 579.6L850.834 585.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.063 430.148H924.583L921.292 424.594L924.583 418.937H931.063L934.251 424.594L931.063 430.148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.96 414.617H924.583L921.394 409.063L924.583 403.508H930.96L934.149 409.063L930.96 414.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.651 398.571H924.891L922.011 393.531L924.891 388.594H930.651L933.531 393.531L930.651 398.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 384.274H924.171L920.674 378.103L924.171 371.829H931.371L934.971 378.103L931.371 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 368.743H924.171L920.674 362.571L924.171 356.4H931.371L934.971 362.571L931.371 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 353.212H924.171L920.674 347.04L924.171 340.869H931.371L934.971 347.04L931.371 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 337.783H924.171L920.674 331.611L924.171 325.337H931.371L934.971 331.611L931.371 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 322.251H924.171L920.674 316.08L924.171 309.908H931.371L934.971 316.08L931.371 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 306.72H924.171L920.674 300.549L924.171 294.377H931.371L934.971 300.549L931.371 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 291.291H924.171L920.674 285.017L924.171 278.846H931.371L934.971 285.017L931.371 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 283.474H910.8L907.2 277.303L910.8 271.131H917.897L921.497 277.303L917.897 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 275.76H897.326L893.829 269.589L897.326 263.314H904.526L908.126 269.589L904.526 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 268.046H883.954L880.354 261.772L883.954 255.6H891.051L894.651 261.772L891.051 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 260.229H870.48L866.88 254.057L870.48 247.886H877.68L881.28 254.057L877.68 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 252.514H857.109L853.509 246.343L857.109 240.068H864.206L867.806 246.343L864.206 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 244.8H843.634L840.034 238.525L843.634 232.354H850.834L854.434 238.525L850.834 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 236.983H830.263L826.663 230.811L830.263 224.64H837.36L840.96 230.811L837.36 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 229.268H816.789L813.189 223.097L816.789 216.823H823.989L827.589 223.097L823.989 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 221.451H803.417L799.817 215.28L803.417 209.108H810.514L814.114 215.28L810.514 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 213.737H789.943L786.343 207.565L789.943 201.394H797.143L800.743 207.565L797.143 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 206.023H776.571L772.971 199.749L776.571 193.578H783.669L787.269 199.749L783.669 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 182.777H736.251L732.651 176.503L736.251 170.332H743.451L747.051 176.503L743.451 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 174.96H722.88L719.28 168.789L722.88 162.617H729.977L733.577 168.789L729.977 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M715.577 165.6H710.331L707.76 161.075L710.331 156.549H715.577L718.251 161.075L715.577 165.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M700.251 170.023H698.914L698.194 168.788L698.914 167.554H700.251L700.971 168.788L700.251 170.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.034 193.269H658.594L657.874 192.035L658.594 190.8H660.034L660.651 192.035L660.034 193.269Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 546.994H481.166L477.566 540.823L481.166 534.651H488.366L491.966 540.823L488.366 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 554.811H494.64L491.04 548.537L494.64 542.366H501.737L505.337 548.537L501.737 554.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.212 562.526H508.012L504.514 556.354L508.012 550.08H515.212L518.812 556.354L515.212 562.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.629 661.989H736.971L734.194 657.052L736.971 652.217H742.629L745.509 657.052L742.629 661.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 655.508H749.726L746.126 649.337L749.726 643.166H756.823L760.423 649.337L756.823 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 647.794H763.097L759.497 641.623L763.097 635.349H770.297L773.897 641.623L770.297 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 640.08H776.571L772.971 633.806L776.571 627.635H783.669L787.269 633.806L783.669 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 632.263H789.943L786.343 626.092L789.943 619.92H797.143L800.743 626.092L797.143 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 624.549H803.417L799.817 618.377L803.417 612.103H810.514L814.114 618.377L810.514 624.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 616.834H816.789L813.189 610.56L816.789 604.389H823.989L827.589 610.56L823.989 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 609.017H830.263L826.663 602.846L830.263 596.674H837.36L840.96 602.846L837.36 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 601.2H843.737L840.137 595.131L843.737 588.96H850.834L854.331 595.131L850.834 601.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M942.274 403.097H940.217L939.086 401.349L940.217 399.497H942.274L943.303 401.349L942.274 403.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 391.989H937.646L934.046 385.817L937.646 379.646H944.743L948.343 385.817L944.743 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 376.56H937.646L934.046 370.286L937.646 364.114H944.743L948.343 370.286L944.743 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 361.029H937.646L934.046 354.857L937.646 348.583H944.743L948.343 354.857L944.743 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 345.497H937.646L934.046 339.326L937.646 333.154H944.743L948.343 339.326L944.743 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 329.965H937.646L934.046 323.794L937.646 317.623H944.743L948.343 323.794L944.743 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 314.537H937.646L934.046 308.263L937.646 302.092H944.743L948.343 308.263L944.743 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 299.006H937.646L934.046 292.834L937.646 286.56H944.743L948.343 292.834L944.743 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 283.474H937.646L934.046 277.303L937.646 271.131H944.743L948.343 277.303L944.743 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 275.76H924.171L920.674 269.589L924.171 263.314H931.371L934.971 269.589L931.371 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 268.046H910.8L907.2 261.772L910.8 255.6H917.897L921.497 261.772L917.897 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 260.229H897.326L893.829 254.057L897.326 247.886H904.526L908.126 254.057L904.526 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 252.514H883.954L880.354 246.343L883.954 240.068H891.051L894.651 246.343L891.051 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 244.8H870.48L866.88 238.525L870.48 232.354H877.68L881.28 238.525L877.68 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 236.983H857.109L853.509 230.811L857.109 224.64H864.206L867.806 230.811L864.206 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 229.268H843.634L840.034 223.097L843.634 216.823H850.834L854.434 223.097L850.834 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 221.451H830.263L826.663 215.28L830.263 209.108H837.36L840.96 215.28L837.36 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 213.737H816.789L813.189 207.565L816.789 201.394H823.989L827.589 207.565L823.989 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 206.023H803.417L799.817 199.749L803.417 193.578H810.514L814.114 199.749L810.514 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.04 198.103H790.046L786.446 192.034L790.046 185.966H797.04L800.537 192.034L797.04 198.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 190.388H776.571L773.074 184.32L776.571 178.148H783.669L787.166 184.32L783.669 190.388Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 182.777H763.097L759.497 176.503L763.097 170.332H770.297L773.897 176.503L770.297 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.28 172.286H751.269L749.211 168.789L751.269 165.292H755.28L757.337 168.789L755.28 172.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 167.246H736.251L732.651 161.075L736.251 154.8H743.451L747.051 161.075L743.451 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.771 159.223H722.983L719.589 153.257L722.983 147.395H729.771L733.166 153.257L729.771 159.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.892 554.811H467.794L464.194 548.537L467.794 542.366H474.892L478.492 548.537L474.892 554.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 562.526H481.166L477.566 556.354L481.166 550.08H488.366L491.966 556.354L488.366 562.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 570.24H494.64L491.04 564.068L494.64 557.897H501.737L505.337 564.068L501.737 570.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.903 577.646H508.32L504.926 571.783L508.32 566.023H514.903L518.297 571.783L514.903 577.646Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.086 674.846H738.514L737.28 672.583L738.514 670.423H741.086L742.423 672.583L741.086 674.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 671.04H749.726L746.126 664.868L749.726 658.594H756.823L760.423 664.868L756.823 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 663.326H763.097L759.497 657.051L763.097 650.88H770.297L773.897 657.051L770.297 663.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 655.508H776.571L772.971 649.337L776.571 643.166H783.669L787.269 649.337L783.669 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 647.794H789.943L786.343 641.623L789.943 635.349H797.143L800.743 641.623L797.143 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 640.08H803.417L799.817 633.806L803.417 627.635H810.514L814.114 633.806L810.514 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 632.263H816.789L813.189 626.092L816.789 619.92H823.989L827.589 626.092L823.989 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M836.743 623.314H830.983L828.103 618.377L830.983 613.337H836.743L839.52 618.377L836.743 623.314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M848.263 612.309H846.206L845.177 610.56L846.206 608.812H848.263L849.291 610.56L848.263 612.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.537 592.56H884.469L881.383 587.315L884.469 582.069H890.537L893.623 587.315L890.537 592.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 399.703H951.12L947.52 393.532L951.12 387.36H958.217L961.817 393.532L958.217 399.703Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 384.274H951.017L947.52 378.103L951.017 371.829H958.217L961.817 378.103L958.217 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 368.743H951.017L947.52 362.571L951.017 356.4H958.217L961.817 362.571L958.217 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 353.212H951.017L947.52 347.04L951.017 340.869H958.217L961.817 347.04L958.217 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 337.783H951.017L947.52 331.611L951.017 325.337H958.217L961.817 331.611L958.217 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 322.251H951.017L947.52 316.08L951.017 309.908H958.217L961.817 316.08L958.217 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 306.72H951.017L947.52 300.549L951.017 294.377H958.217L961.817 300.549L958.217 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 291.291H951.017L947.52 285.017L951.017 278.846H958.217L961.817 285.017L958.217 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 275.76H951.017L947.52 269.589L951.017 263.314H958.217L961.817 269.589L958.217 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 268.046H937.646L934.046 261.772L937.646 255.6H944.743L948.343 261.772L944.743 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 260.229H924.171L920.674 254.057L924.171 247.886H931.371L934.971 254.057L931.371 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 252.103H910.8L907.2 245.932L910.8 239.657H917.897L921.497 245.932L917.897 252.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 244.8H897.326L893.829 238.525L897.326 232.354H904.526L908.126 238.525L904.526 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 236.983H883.954L880.354 230.811L883.954 224.64H891.051L894.651 230.811L891.051 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 229.268H870.48L866.88 223.097L870.48 216.823H877.68L881.28 223.097L877.68 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 221.451H857.109L853.509 215.28L857.109 209.108H864.206L867.806 215.28L864.206 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 213.737H843.634L840.034 207.565L843.634 201.394H850.834L854.434 207.565L850.834 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 206.023H830.263L826.663 199.749L830.263 193.578H837.36L840.96 199.749L837.36 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 198.206H816.789L813.189 192.034L816.789 185.863H823.989L827.589 192.034L823.989 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 190.492H803.417L799.817 184.32L803.417 178.046H810.514L814.114 184.32L810.514 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 182.777H789.943L786.343 176.503L789.943 170.332H797.143L800.743 176.503L797.143 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 174.96H776.571L772.971 168.789L776.571 162.617H783.669L787.269 168.789L783.669 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.446 164.16H764.846L763.097 161.074L764.846 157.886H768.446L770.297 161.074L768.446 164.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 159.532H749.726L746.126 153.257L749.726 147.086H756.823L760.423 153.257L756.823 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 151.714H736.251L732.651 145.543L736.251 139.371H743.451L747.051 145.543L743.451 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.274 538.148H468.411L465.531 533.108L468.411 528.068H474.274L477.154 533.108L474.274 538.148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.52 562.526H454.32L450.72 556.354L454.32 550.08H461.52L465.12 556.354L461.52 562.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.892 570.24H467.794L464.194 564.068L467.794 557.897H474.892L478.492 564.068L474.892 570.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 578.057H481.166L477.566 571.783L481.166 565.611H488.366L491.966 571.783L488.366 578.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 585.772H494.64L491.04 579.6L494.64 573.429H501.737L505.337 579.6L501.737 585.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 686.572H749.726L746.126 680.297L749.726 674.126H756.823L760.423 680.297L756.823 686.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 678.754H763.097L759.497 672.583L763.097 666.412H770.297L773.897 672.583L770.297 678.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 671.04H776.571L772.971 664.868L776.571 658.594H783.669L787.269 664.868L783.669 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 663.326H789.943L786.343 657.051L789.943 650.88H797.143L800.743 657.051L797.143 663.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 655.508H803.417L799.817 649.337L803.417 643.166H810.514L814.114 649.337L810.514 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 647.794H816.789L813.189 641.623L816.789 635.349H823.989L827.589 641.623L823.989 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M834.377 634.834H833.246L832.731 633.806L833.246 632.88H834.377L834.891 633.806L834.377 634.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 616.834H870.48L866.88 610.56L870.48 604.389H877.68L881.28 610.56L877.68 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 609.017H883.954L880.354 602.846L883.954 596.674H891.051L894.651 602.846L891.051 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.354 405.36H965.726L963.36 401.349L965.726 397.234H970.354L972.72 401.349L970.354 405.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 391.989H964.491L960.891 385.817L964.491 379.646H971.691L975.189 385.817L971.691 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 376.56H964.491L960.891 370.286L964.491 364.114H971.691L975.189 370.286L971.691 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 361.029H964.491L960.891 354.857L964.491 348.583H971.691L975.189 354.857L971.691 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 345.497H964.491L960.891 339.326L964.491 333.154H971.691L975.189 339.326L971.691 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 329.965H964.491L960.891 323.794L964.491 317.623H971.691L975.189 323.794L971.691 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 314.537H964.491L960.891 308.263L964.491 302.092H971.691L975.189 308.263L971.691 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 299.006H964.491L960.891 292.834L964.491 286.56H971.691L975.189 292.834L971.691 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 283.474H964.491L960.891 277.303L964.491 271.131H971.691L975.189 277.303L971.691 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 268.046H964.491L960.891 261.772L964.491 255.6H971.691L975.189 261.772L971.691 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 260.229H951.017L947.52 254.057L951.017 247.886H958.217L961.817 254.057L958.217 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 252.514H937.646L934.046 246.343L937.646 240.068H944.743L948.343 246.343L944.743 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 244.8H924.171L920.674 238.525L924.171 232.354H931.371L934.971 238.525L931.371 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 236.983H910.8L907.2 230.811L910.8 224.64H917.897L921.497 230.811L917.897 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 229.268H897.326L893.829 223.097L897.326 216.823H904.526L908.126 223.097L904.526 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 221.451H883.954L880.354 215.28L883.954 209.108H891.051L894.651 215.28L891.051 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 213.737H870.48L866.88 207.565L870.48 201.394H877.68L881.28 207.565L877.68 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 206.023H857.109L853.509 199.749L857.109 193.578H864.206L867.806 199.749L864.206 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 198.206H843.634L840.034 192.034L843.634 185.863H850.834L854.434 192.034L850.834 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 190.492H830.263L826.663 184.32L830.263 178.046H837.36L840.96 184.32L837.36 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.989 182.777H816.789L813.189 176.503L816.789 170.332H823.989L827.589 176.503L823.989 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 174.96H803.417L799.817 168.789L803.417 162.617H810.514L814.114 168.789L810.514 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 167.246H789.943L786.343 161.075L789.943 154.8H797.143L800.743 161.075L797.143 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 159.532H776.571L772.971 153.257L776.571 147.086H783.669L787.269 153.257L783.669 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.194 151.714H763.2L759.6 145.543L763.2 139.371H770.194L773.794 145.543L770.194 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.823 144H749.726L746.126 137.828L749.726 131.554H756.823L760.423 137.828L756.823 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M742.628 134.743H737.074L734.4 130.011L737.074 125.28H742.628L745.303 130.011L742.628 134.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.08 529.097H455.76L453.6 525.292L455.76 521.589H460.08L462.24 525.292L460.08 529.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.52 546.994H454.32L450.72 540.823L454.32 534.651H461.52L465.12 540.823L461.52 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 570.24H440.949L437.349 564.068L440.949 557.897H448.046L451.646 564.068L448.046 570.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.52 578.057H454.32L450.72 571.783L454.32 565.611H461.52L465.12 571.783L461.52 578.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.892 585.772H467.794L464.194 579.6L467.794 573.429H474.892L478.492 579.6L474.892 585.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 593.486H481.166L477.566 587.314L481.166 581.143H488.366L491.966 587.314L488.366 593.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.12 600.171H495.257L492.274 595.131L495.257 589.988H501.12L504.103 595.131L501.12 600.171Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.412 701.177H750.137L747.052 695.829L750.137 690.48H756.412L759.497 695.829L756.412 701.177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 694.286H763.097L759.497 688.114L763.097 681.943H770.297L773.897 688.114L770.297 694.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 686.572H776.571L772.971 680.297L776.571 674.126H783.669L787.269 680.297L783.669 686.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 678.754H789.943L786.343 672.583L789.943 666.412H797.143L800.743 672.583L797.143 678.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 671.04H803.417L799.817 664.868L803.417 658.594H810.514L814.114 664.868L810.514 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M821.006 658.183H819.771L819.051 657.052L819.771 655.92H821.006L821.726 657.052L821.006 658.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.046 636.172H859.269L857.931 633.806L859.269 631.543H862.046L863.383 633.806L862.046 636.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 632.263H870.48L866.88 626.092L870.48 619.92H877.68L881.28 626.092L877.68 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.846 624.137H884.16L880.869 618.378L884.16 612.515H890.846L894.24 618.378L890.846 624.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M984.857 414.926H978.069L974.674 409.063L978.069 403.2H984.857L988.251 409.063L984.857 414.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 399.806H977.863L974.366 393.532L977.863 387.36H985.063L988.663 393.532L985.063 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 384.274H977.863L974.366 378.103L977.863 371.829H985.063L988.663 378.103L985.063 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 368.743H977.863L974.366 362.571L977.863 356.4H985.063L988.663 362.571L985.063 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 353.212H977.863L974.366 347.04L977.863 340.869H985.063L988.663 347.04L985.063 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 337.783H977.863L974.366 331.611L977.863 325.337H985.063L988.663 331.611L985.063 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 322.251H977.863L974.366 316.08L977.863 309.908H985.063L988.663 316.08L985.063 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 306.72H977.863L974.366 300.549L977.863 294.377H985.063L988.663 300.549L985.063 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 291.291H977.863L974.366 285.017L977.863 278.846H985.063L988.663 285.017L985.063 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 275.76H977.863L974.366 269.589L977.863 263.314H985.063L988.663 269.589L985.063 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 260.229H977.863L974.366 254.057L977.863 247.886H985.063L988.663 254.057L985.063 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 252.514H964.491L960.891 246.343L964.491 240.068H971.691L975.189 246.343L971.691 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 244.8H951.017L947.52 238.525L951.017 232.354H958.217L961.817 238.525L958.217 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 236.983H937.646L934.046 230.811L937.646 224.64H944.743L948.343 230.811L944.743 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 229.268H924.171L920.674 223.097L924.171 216.823H931.371L934.971 223.097L931.371 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 221.451H910.8L907.2 215.28L910.8 209.108H917.897L921.497 215.28L917.897 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 213.737H897.326L893.829 207.565L897.326 201.394H904.526L908.126 207.565L904.526 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 206.023H883.954L880.354 199.749L883.954 193.578H891.051L894.651 199.749L891.051 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 198.206H870.48L866.88 192.034L870.48 185.863H877.68L881.28 192.034L877.68 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 190.492H857.109L853.509 184.32L857.109 178.046H864.206L867.806 184.32L864.206 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 182.777H843.634L840.034 176.503L843.634 170.332H850.834L854.434 176.503L850.834 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.36 174.96H830.263L826.663 168.789L830.263 162.617H837.36L840.96 168.789L837.36 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.166 165.909H817.611L814.731 161.074L817.611 156.137H823.166L826.046 161.074L823.166 165.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 159.532H803.417L799.817 153.257L803.417 147.086H810.514L814.114 153.257L810.514 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 151.714H789.943L786.343 145.543L789.943 139.371H797.143L800.743 145.543L797.143 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 144H776.571L772.971 137.828L776.571 131.554H783.669L787.269 137.828L783.669 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M770.297 136.286H763.097L759.497 130.011L763.097 123.84H770.297L773.897 130.011L770.297 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.411 127.749H750.137L746.948 122.297L750.137 116.846H756.411L759.6 122.297L756.411 127.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.08 158.503H616.011L613.029 153.257L616.011 148.114H622.08L625.063 153.257L622.08 158.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.812 166.629H602.331L599.143 161.075L602.331 155.417H608.812L612.103 161.075L608.812 166.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.943 275.555H441.052L437.554 269.589L441.052 263.521H447.943L451.44 269.589L447.943 275.555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.811 506.058H442.183L439.817 502.046L442.183 498.035H446.811L449.177 502.046L446.811 506.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.943 523.543H441.052L437.554 517.577L441.052 511.611H447.943L451.44 517.577L447.943 523.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 539.28H440.949L437.349 533.109L440.949 526.834H448.046L451.646 533.109L448.046 539.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 554.811H440.949L437.349 548.537L440.949 542.366H448.046L451.646 548.537L448.046 554.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 578.057H427.474L423.874 571.783L427.474 565.611H434.674L438.274 571.783L434.674 578.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 585.772H440.949L437.349 579.6L440.949 573.429H448.046L451.646 579.6L448.046 585.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.52 593.486H454.32L450.72 587.314L454.32 581.143H461.52L465.12 587.314L461.52 593.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.892 601.303H467.794L464.194 595.132L467.794 588.857H474.892L478.492 595.132L474.892 601.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 609.017H481.166L477.566 602.846L481.166 596.674H488.366L491.966 602.846L488.366 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.063 612H497.417L496.594 610.56L497.417 609.223H499.063L499.783 610.56L499.063 612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.651 706.937H764.743L762.789 703.542L764.743 700.251H768.651L770.606 703.542L768.651 706.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.949 700.663H777.291L774.514 695.828L777.291 690.994H782.949L785.726 695.828L782.949 700.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.04 694.08H790.046L786.549 688.114L790.046 682.046H797.04L800.537 688.114L797.04 694.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M807.634 681.429H806.297L805.68 680.297L806.297 679.269H807.634L808.251 680.297L807.634 681.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M861.943 651.6H859.371L858.034 649.337L859.371 647.074H861.943L863.28 649.337L861.943 651.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 647.794H870.48L866.88 641.623L870.48 635.349H877.68L881.28 641.623L877.68 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.714 637.714H885.291L883.029 633.806L885.291 630H889.714L891.977 633.806L889.714 637.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M995.966 449.691H993.806L992.674 447.84L993.806 445.886H995.966L997.097 447.84L995.966 449.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.331 438.172H991.543L988.149 432.309L991.543 426.446H998.331L1001.73 432.309L998.331 438.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 423.052H991.337L987.737 416.777L991.337 410.606H998.537L1002.03 416.777L998.537 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 407.52H991.337L987.737 401.349L991.337 395.075H998.537L1002.03 401.349L998.537 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 391.989H991.337L987.737 385.817L991.337 379.646H998.537L1002.03 385.817L998.537 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 376.56H991.337L987.737 370.286L991.337 364.114H998.537L1002.03 370.286L998.537 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 361.029H991.337L987.737 354.857L991.337 348.583H998.537L1002.03 354.857L998.537 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 345.497H991.337L987.737 339.326L991.337 333.154H998.537L1002.03 339.326L998.537 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 329.965H991.337L987.737 323.794L991.337 317.623H998.537L1002.03 323.794L998.537 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 314.537H991.337L987.737 308.263L991.337 302.092H998.537L1002.03 308.263L998.537 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 299.006H991.337L987.737 292.834L991.337 286.56H998.537L1002.03 292.834L998.537 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 283.474H991.337L987.737 277.303L991.337 271.131H998.537L1002.03 277.303L998.537 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 268.046H991.337L987.737 261.772L991.337 255.6H998.537L1002.03 261.772L998.537 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 252.514H991.337L987.737 246.343L991.337 240.068H998.537L1002.03 246.343L998.537 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 244.8H977.863L974.366 238.525L977.863 232.354H985.063L988.663 238.525L985.063 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 236.983H964.491L960.891 230.811L964.491 224.64H971.691L975.189 230.811L971.691 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 229.268H951.017L947.52 223.097L951.017 216.823H958.217L961.817 223.097L958.217 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 221.451H937.646L934.046 215.28L937.646 209.108H944.743L948.343 215.28L944.743 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 213.737H924.171L920.674 207.565L924.171 201.394H931.371L934.971 207.565L931.371 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 206.023H910.8L907.2 199.749L910.8 193.578H917.897L921.497 199.749L917.897 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 198.206H897.326L893.829 192.034L897.326 185.863H904.526L908.126 192.034L904.526 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 190.492H883.954L880.354 184.32L883.954 178.046H891.051L894.651 184.32L891.051 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 182.777H870.48L866.88 176.503L870.48 170.332H877.68L881.28 176.503L877.68 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 174.96H857.109L853.509 168.789L857.109 162.617H864.206L867.806 168.789L864.206 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.834 167.246H843.634L840.034 161.075L843.634 154.8H850.834L854.434 161.075L850.834 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.154 159.12H830.469L827.177 153.257L830.469 147.497H837.154L840.549 153.257L837.154 159.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M810.514 144H803.417L799.817 137.828L803.417 131.657H810.514L814.114 137.828L810.514 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M797.143 136.286H789.943L786.343 130.011L789.943 123.84H797.143L800.743 130.011L797.143 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.669 128.468H776.571L772.971 122.297L776.571 116.125H783.669L787.269 122.297L783.669 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.783 119.931H763.611L760.526 114.583L763.611 109.131H769.783L772.869 114.583L769.783 119.931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.709 150.891H602.537L599.452 145.542L602.537 140.194H608.709L611.794 145.542L608.709 150.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.646 159.429H588.651L585.154 153.258L588.651 147.189H595.646L599.246 153.258L595.646 159.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.263 251.795H427.886L424.697 246.343L427.886 240.789H434.263L437.451 246.343L434.263 251.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.646 266.297H428.503L425.931 261.771L428.503 257.349H433.646L436.217 261.771L433.646 266.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.029 497.623H429.12L427.269 494.331L429.12 491.04H433.029L434.88 494.331L433.029 497.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 516.035H427.474L423.874 509.863L427.474 503.589H434.674L438.274 509.863L434.674 516.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 531.566H427.474L423.874 525.292L427.474 519.12H434.674L438.274 525.292L434.674 531.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 546.994H427.474L423.874 540.823L427.474 534.651H434.674L438.274 540.823L434.674 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 562.526H427.474L423.874 556.354L427.474 550.08H434.674L438.274 556.354L434.674 562.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 585.772H414.103L410.503 579.6L414.103 573.429H421.2L424.8 579.6L421.2 585.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 593.486H427.474L423.874 587.314L427.474 581.143H434.674L438.274 587.314L434.674 593.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 601.303H440.949L437.349 595.132L440.949 588.857H448.046L451.646 595.132L448.046 601.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.52 609.017H454.32L450.72 602.846L454.32 596.674H461.52L465.12 602.846L461.52 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.892 616.834H467.794L464.194 610.56L467.794 604.389H474.892L478.492 610.56L474.892 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 624.549H481.166L477.566 618.377L481.166 612.103H488.366L491.966 618.377L488.366 624.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.726 659.829H872.537L870.891 657.052L872.537 654.377H875.726L877.269 657.052L875.726 659.829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.85 473.658H1006.87L1005.33 471.086L1006.87 468.515H1009.85L1011.29 471.086L1009.85 473.658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 461.726H1004.81L1001.21 455.554L1004.81 449.383H1011.91L1015.51 455.554L1011.91 461.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 446.297H1004.71L1001.21 440.023L1004.71 433.852H1011.91L1015.51 440.023L1011.91 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 430.766H1004.71L1001.21 424.595L1004.71 418.32H1011.91L1015.51 424.595L1011.91 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 415.234H1004.71L1001.21 409.063L1004.71 402.892H1011.91L1015.51 409.063L1011.91 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 399.806H1004.71L1001.21 393.532L1004.71 387.36H1011.91L1015.51 393.532L1011.91 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 384.274H1004.71L1001.21 378.103L1004.71 371.829H1011.91L1015.51 378.103L1011.91 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 368.743H1004.71L1001.21 362.571L1004.71 356.4H1011.91L1015.51 362.571L1011.91 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 353.212H1004.71L1001.21 347.04L1004.71 340.869H1011.91L1015.51 347.04L1011.91 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 337.783H1004.71L1001.21 331.611L1004.71 325.337H1011.91L1015.51 331.611L1011.91 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 322.251H1004.71L1001.21 316.08L1004.71 309.908H1011.91L1015.51 316.08L1011.91 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 306.72H1004.71L1001.21 300.549L1004.71 294.377H1011.91L1015.51 300.549L1011.91 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 291.291H1004.71L1001.21 285.017L1004.71 278.846H1011.91L1015.51 285.017L1011.91 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 275.76H1004.71L1001.21 269.589L1004.71 263.314H1011.91L1015.51 269.589L1011.91 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 260.229H1004.71L1001.21 254.057L1004.71 247.886H1011.91L1015.51 254.057L1011.91 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 244.8H1004.71L1001.21 238.525L1004.71 232.354H1011.91L1015.51 238.525L1011.91 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 236.983H991.337L987.737 230.811L991.337 224.64H998.537L1002.03 230.811L998.537 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 229.268H977.863L974.366 223.097L977.863 216.823H985.063L988.663 223.097L985.063 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 221.451H964.491L960.891 215.28L964.491 209.108H971.691L975.189 215.28L971.691 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 213.737H951.017L947.52 207.565L951.017 201.394H958.217L961.817 207.565L958.217 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 206.023H937.646L934.046 199.749L937.646 193.578H944.743L948.343 199.749L944.743 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 198.206H924.171L920.674 192.034L924.171 185.863H931.371L934.971 192.034L931.371 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 190.492H910.8L907.2 184.32L910.8 178.046H917.897L921.497 184.32L917.897 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 182.777H897.326L893.829 176.503L897.326 170.332H904.526L908.126 176.503L904.526 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 174.96H883.954L880.354 168.789L883.954 162.617H891.051L894.651 168.789L891.051 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 167.246H870.48L866.88 161.075L870.48 154.8H877.68L881.28 161.075L877.68 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M864.206 159.532H857.109L853.509 153.257L857.109 147.086H864.206L867.806 153.257L864.206 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.731 151.612H843.737L840.24 145.543L843.737 139.475H850.731L854.229 145.543L850.731 151.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M837.154 143.588H830.469L827.074 137.828L830.469 131.965H837.154L840.549 137.828L837.154 143.588Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M823.783 135.977H816.994L813.6 130.012L816.994 124.149H823.783L827.177 130.012L823.783 135.977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.794 127.234H804.137L801.257 122.297L804.137 117.257H809.794L812.674 122.297L809.794 127.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M796.423 119.52H790.663L787.783 114.583L790.663 109.543H796.423L799.303 114.583L796.423 119.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.229 110.469H778.012L775.852 106.766L778.012 103.063H782.229L784.389 106.766L782.229 110.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.897 140.811H590.4L588.754 137.829L590.4 134.846H593.897L595.646 137.829L593.897 140.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.783 194.708H496.697L495.154 192.034L496.697 189.36H499.783L501.326 192.034L499.783 194.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.44 235.028H428.709L426.24 230.811L428.709 226.594H433.44L435.909 230.811L433.44 235.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 244.8H414.103L410.503 238.525L414.103 232.354H421.2L424.8 238.525L421.2 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.657 257.554H415.646L413.691 254.057L415.646 250.56H419.657L421.611 254.057L419.657 257.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.937 488.777H416.366L415.131 486.617L416.366 484.354H418.937L420.171 486.617L418.937 488.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 508.32H414.103L410.503 502.046L414.103 495.875H421.2L424.8 502.046L421.2 508.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 523.749H414.103L410.503 517.577L414.103 511.406H421.2L424.8 517.577L421.2 523.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 539.28H414.103L410.503 533.109L414.103 526.834H421.2L424.8 533.109L421.2 539.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 554.811H414.103L410.503 548.537L414.103 542.366H421.2L424.8 548.537L421.2 554.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 570.24H414.103L410.503 564.068L414.103 557.897H421.2L424.8 564.068L421.2 570.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 593.486H400.629L397.029 587.314L400.629 581.143H407.829L411.429 587.314L407.829 593.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 601.303H414.103L410.503 595.132L414.103 588.857H421.2L424.8 595.132L421.2 601.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 609.017H427.474L423.874 602.846L427.474 596.674H434.674L438.274 602.846L434.674 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 616.834H440.949L437.349 610.56L440.949 604.389H448.046L451.646 610.56L448.046 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.52 624.549H454.32L450.72 618.377L454.32 612.103H461.52L465.12 618.377L461.52 624.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.892 632.263H467.794L464.194 626.092L467.794 619.92H474.892L478.492 626.092L474.892 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 640.08H481.166L477.566 633.806L481.166 627.635H488.366L491.966 633.806L488.366 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.35 483.326H1019.11L1016.54 478.8L1019.11 474.274H1024.35L1027.03 478.8L1024.35 483.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 469.543H1018.18L1014.58 463.371L1018.18 457.097H1025.38L1028.88 463.371L1025.38 469.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 454.011H1018.18L1014.58 447.84L1018.18 441.668H1025.38L1028.88 447.84L1025.38 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 438.48H1018.18L1014.58 432.308L1018.18 426.137H1025.38L1028.88 432.308L1025.38 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 423.052H1018.18L1014.58 416.777L1018.18 410.606H1025.38L1028.88 416.777L1025.38 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 407.52H1018.18L1014.58 401.349L1018.18 395.075H1025.38L1028.88 401.349L1025.38 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 391.989H1018.18L1014.58 385.817L1018.18 379.646H1025.38L1028.88 385.817L1025.38 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 376.56H1018.18L1014.58 370.286L1018.18 364.114H1025.38L1028.88 370.286L1025.38 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 361.029H1018.18L1014.58 354.857L1018.18 348.583H1025.38L1028.88 354.857L1025.38 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 345.497H1018.18L1014.58 339.326L1018.18 333.154H1025.38L1028.88 339.326L1025.38 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 329.965H1018.18L1014.58 323.794L1018.18 317.623H1025.38L1028.88 323.794L1025.38 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 314.537H1018.18L1014.58 308.263L1018.18 302.092H1025.38L1028.88 308.263L1025.38 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 299.006H1018.18L1014.58 292.834L1018.18 286.56H1025.38L1028.88 292.834L1025.38 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 283.474H1018.18L1014.58 277.303L1018.18 271.131H1025.38L1028.88 277.303L1025.38 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 268.046H1018.18L1014.58 261.772L1018.18 255.6H1025.38L1028.88 261.772L1025.38 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 252.514H1018.18L1014.58 246.343L1018.18 240.068H1025.38L1028.88 246.343L1025.38 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 236.983H1018.18L1014.58 230.811L1018.18 224.64H1025.38L1028.88 230.811L1025.38 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 229.268H1004.71L1001.21 223.097L1004.71 216.823H1011.91L1015.51 223.097L1011.91 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 221.451H991.337L987.737 215.28L991.337 209.108H998.537L1002.03 215.28L998.537 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 213.737H977.863L974.366 207.565L977.863 201.394H985.063L988.663 207.565L985.063 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 206.023H964.491L960.891 199.749L964.491 193.578H971.691L975.189 199.749L971.691 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 198.206H951.017L947.52 192.034L951.017 185.863H958.217L961.817 192.034L958.217 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 190.492H937.646L934.046 184.32L937.646 178.046H944.743L948.343 184.32L944.743 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 182.777H924.171L920.674 176.503L924.171 170.332H931.371L934.971 176.503L931.371 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 174.96H910.8L907.2 168.789L910.8 162.617H917.897L921.497 168.789L917.897 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 167.246H897.326L893.829 161.075L897.326 154.8H904.526L908.126 161.075L904.526 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 159.532H883.954L880.354 153.257L883.954 147.086H891.051L894.651 153.257L891.051 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M877.68 151.714H870.48L866.88 145.543L870.48 139.371H877.68L881.28 145.543L877.68 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M862.971 141.737H858.343L856.08 137.829L858.343 133.817H862.971L865.234 137.829L862.971 141.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.32 135.36H844.149L841.166 130.011L844.149 124.766H850.32L853.406 130.011L850.32 135.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 74.2631H736.251L732.754 67.9888L736.251 61.8174H743.451L746.949 67.9888L743.451 74.2631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M728.64 64.0797H724.217L721.954 60.274L724.217 56.4683H728.64L730.903 60.274L728.64 64.0797Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M714.548 55.2343H711.463L709.92 52.56L711.463 49.8857H714.548L716.091 52.56L714.548 55.2343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M512.434 170.228H510.789L510.069 168.788L510.789 167.451H512.434L513.257 168.788L512.434 170.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 182.777H494.64L491.04 176.503L494.64 170.332H501.737L505.337 176.503L501.737 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M487.954 189.771H481.577L478.389 184.32L481.577 178.766H487.954L491.143 184.32L487.954 189.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 229.268H414.103L410.503 223.097L414.103 216.823H421.2L424.8 223.097L421.2 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 236.983H400.629L397.029 230.811L400.629 224.64H407.829L411.429 230.811L407.829 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 252.514H400.629L397.029 246.343L400.629 240.068H407.829L411.429 246.343L407.829 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.726 267.943H400.731L397.131 261.772L400.731 255.703H407.726L411.326 261.772L407.726 267.943Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.314 282.651H401.143L398.057 277.303L401.143 271.954H407.314L410.297 277.303L407.314 282.651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.623 484.662H400.834L397.44 478.799L400.834 472.937H407.623L411.017 478.799L407.623 484.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 500.503H400.629L397.029 494.332L400.629 488.16H407.829L411.429 494.332L407.829 500.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 516.035H400.629L397.029 509.863L400.629 503.589H407.829L411.429 509.863L407.829 516.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 531.566H400.629L397.029 525.292L400.629 519.12H407.829L411.429 525.292L407.829 531.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 546.994H400.629L397.029 540.823L400.629 534.651H407.829L411.429 540.823L407.829 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 562.526H400.629L397.029 556.354L400.629 550.08H407.829L411.429 556.354L407.829 562.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 578.057H400.629L397.029 571.783L400.629 565.611H407.829L411.429 571.783L407.829 578.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 601.303H387.257L383.657 595.132L387.257 588.857H394.354L397.954 595.132L394.354 601.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 609.017H400.629L397.029 602.846L400.629 596.674H407.829L411.429 602.846L407.829 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 616.834H414.103L410.503 610.56L414.103 604.389H421.2L424.8 610.56L421.2 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 624.549H427.474L423.874 618.377L427.474 612.103H434.674L438.274 618.377L434.674 624.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 632.263H440.949L437.349 626.092L440.949 619.92H448.046L451.646 626.092L448.046 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.52 640.08H454.32L450.72 633.806L454.32 627.635H461.52L465.12 633.806L461.52 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.892 647.794H467.794L464.194 641.623L467.794 635.451H474.892L478.492 641.623L474.892 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1037.73 490.937H1032.69L1030.11 486.617L1032.69 482.194H1037.73L1040.3 486.617L1037.73 490.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.24 445.372H1032.07L1029.09 440.024L1032.07 434.778H1038.24L1041.33 440.024L1038.24 445.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 430.766H1031.55L1028.06 424.595L1031.55 418.32H1038.75L1042.35 424.595L1038.75 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 415.234H1031.55L1028.06 409.063L1031.55 402.892H1038.75L1042.35 409.063L1038.75 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 399.806H1031.55L1028.06 393.532L1031.55 387.36H1038.75L1042.35 393.532L1038.75 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 384.274H1031.55L1028.06 378.103L1031.55 371.829H1038.75L1042.35 378.103L1038.75 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 368.743H1031.55L1028.06 362.571L1031.55 356.4H1038.75L1042.35 362.571L1038.75 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 353.212H1031.55L1028.06 347.04L1031.55 340.869H1038.75L1042.35 347.04L1038.75 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 337.783H1031.55L1028.06 331.611L1031.55 325.337H1038.75L1042.35 331.611L1038.75 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 322.251H1031.55L1028.06 316.08L1031.55 309.908H1038.75L1042.35 316.08L1038.75 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 306.72H1031.55L1028.06 300.549L1031.55 294.377H1038.75L1042.35 300.549L1038.75 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 291.291H1031.55L1028.06 285.017L1031.55 278.846H1038.75L1042.35 285.017L1038.75 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 275.76H1031.55L1028.06 269.589L1031.55 263.314H1038.75L1042.35 269.589L1038.75 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 260.229H1031.55L1028.06 254.057L1031.55 247.886H1038.75L1042.35 254.057L1038.75 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 244.8H1031.55L1028.06 238.525L1031.55 232.354H1038.75L1042.35 238.525L1038.75 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 229.268H1031.55L1028.06 223.097L1031.55 216.823H1038.75L1042.35 223.097L1038.75 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 221.451H1018.18L1014.58 215.28L1018.18 209.108H1025.38L1028.88 215.28L1025.38 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 213.737H1004.71L1001.21 207.565L1004.71 201.394H1011.91L1015.51 207.565L1011.91 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 206.023H991.337L987.737 199.749L991.337 193.578H998.537L1002.03 199.749L998.537 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 198.206H977.863L974.366 192.034L977.863 185.863H985.063L988.663 192.034L985.063 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 190.492H964.491L960.891 184.32L964.491 178.046H971.691L975.189 184.32L971.691 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 182.777H951.017L947.52 176.503L951.017 170.332H958.217L961.817 176.503L958.217 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 174.96H937.646L934.046 168.789L937.646 162.617H944.743L948.343 168.789L944.743 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 167.246H924.171L920.674 161.075L924.171 154.8H931.371L934.971 161.075L931.371 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 159.532H910.8L907.2 153.257L910.8 147.086H917.897L921.497 153.257L917.897 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 151.714H897.326L893.829 145.543L897.326 139.371H904.526L908.126 145.543L904.526 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.051 144H883.954L880.354 137.828L883.954 131.554H891.051L894.651 137.828L891.051 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M876.549 134.229H871.714L869.246 130.012L871.714 125.897H876.549L878.914 130.012L876.549 134.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.417 69.2227H765.977L765.257 67.9884L765.977 66.8569H767.417L768.137 67.9884L767.417 69.2227Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M754.663 62.7428H751.783L750.343 60.2742L751.783 57.8057H754.663L756.206 60.2742L754.663 62.7428Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M743.451 58.7314H736.251L732.651 52.5599L736.251 46.2856H743.451L747.051 52.5599L743.451 58.7314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M729.977 51.017H722.88L719.28 44.7427L722.88 38.5713H729.977L733.577 44.7427L729.977 51.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M716.606 43.1998H709.406L705.806 37.0284L709.406 30.8569H716.606L720.103 37.0284L716.606 43.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M593.486 109.029H590.914L589.577 106.766L590.914 104.503H593.486L594.72 106.766L593.486 109.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.937 118.286H576.617L574.354 114.583L576.617 110.777H580.937L583.097 114.583L580.937 118.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.903 128.468H561.806L558.206 122.297L561.806 116.125H568.903L572.4 122.297L568.903 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.429 136.286H548.331L544.731 130.011L548.331 123.84H555.429L559.029 130.011L555.429 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.057 144H534.857L531.36 137.828L534.857 131.657H542.057L545.554 137.828L542.057 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.377 151.303H521.794L518.4 145.543L521.794 139.783H528.377L531.668 145.543L528.377 151.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.8 158.812H508.423L505.234 153.257L508.423 147.703H514.8L518.091 153.257L514.8 158.812Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 167.246H494.64L491.04 161.075L494.64 154.8H501.737L505.337 161.075L501.737 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 174.96H481.166L477.566 168.789L481.166 162.617H488.366L491.966 168.789L488.366 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.069 181.235H468.617L465.943 176.503L468.617 171.875H474.069L476.743 176.503L474.069 181.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.097 213.531H414.206L410.709 207.565L414.206 201.6H421.097L424.594 207.565L421.097 213.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 221.451H400.629L397.029 215.28L400.629 209.108H407.829L411.429 215.28L407.829 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 229.268H387.257L383.657 223.097L387.257 216.823H394.354L397.954 223.097L394.354 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 244.8H387.257L383.657 238.525L387.257 232.354H394.354L397.954 238.525L394.354 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 260.229H387.257L383.657 254.057L387.257 247.886H394.354L397.954 254.057L394.354 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 275.76H387.257L383.657 269.589L387.257 263.314H394.354L397.954 269.589L394.354 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.12 289.028H388.491L386.229 285.017L388.491 281.108H393.12L395.383 285.017L393.12 289.028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.737 476.229H387.874L384.891 471.086L387.874 465.943H393.737L396.72 471.086L393.737 476.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 492.789H387.257L383.657 486.618L387.257 480.343H394.354L397.954 486.618L394.354 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 508.32H387.257L383.657 502.046L387.257 495.875H394.354L397.954 502.046L394.354 508.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 523.749H387.257L383.657 517.577L387.257 511.406H394.354L397.954 517.577L394.354 523.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 539.28H387.257L383.657 533.109L387.257 526.834H394.354L397.954 533.109L394.354 539.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 554.811H387.257L383.657 548.537L387.257 542.366H394.354L397.954 548.537L394.354 554.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 570.24H387.257L383.657 564.068L387.257 557.897H394.354L397.954 564.068L394.354 570.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 585.772H387.257L383.657 579.6L387.257 573.429H394.354L397.954 579.6L394.354 585.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 609.017H373.783L370.183 602.846L373.783 596.674H380.983L384.583 602.846L380.983 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 616.834H387.257L383.657 610.56L387.257 604.389H394.354L397.954 610.56L394.354 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 624.549H400.629L397.029 618.377L400.629 612.103H407.829L411.429 618.377L407.829 624.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 632.263H414.103L410.503 626.092L414.103 619.92H421.2L424.8 626.092L421.2 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 640.08H427.474L423.874 633.806L427.474 627.635H434.674L438.274 633.806L434.674 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 647.794H440.949L437.349 641.623L440.949 635.349H448.046L451.646 641.623L448.046 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.52 655.508H454.32L450.72 649.337L454.32 643.166H461.52L465.12 649.337L461.52 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1049.86 434.469H1047.39L1046.16 432.309L1047.39 430.149H1049.86L1051.1 432.309L1049.86 434.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 423.052H1045.03L1041.43 416.777L1045.03 410.606H1052.23L1055.73 416.777L1052.23 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 407.52H1045.03L1041.43 401.349L1045.03 395.075H1052.23L1055.73 401.349L1052.23 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 391.989H1045.03L1041.43 385.817L1045.03 379.646H1052.23L1055.73 385.817L1052.23 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 376.56H1045.03L1041.43 370.286L1045.03 364.114H1052.23L1055.73 370.286L1052.23 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 361.029H1045.03L1041.43 354.857L1045.03 348.583H1052.23L1055.73 354.857L1052.23 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 345.497H1045.03L1041.43 339.326L1045.03 333.154H1052.23L1055.73 339.326L1052.23 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 329.965H1045.03L1041.43 323.794L1045.03 317.623H1052.23L1055.73 323.794L1052.23 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 314.537H1045.03L1041.43 308.263L1045.03 302.092H1052.23L1055.73 308.263L1052.23 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 299.006H1045.03L1041.43 292.834L1045.03 286.56H1052.23L1055.73 292.834L1052.23 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 283.474H1045.03L1041.43 277.303L1045.03 271.131H1052.23L1055.73 277.303L1052.23 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 268.046H1045.03L1041.43 261.772L1045.03 255.6H1052.23L1055.73 261.772L1052.23 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 252.514H1045.03L1041.43 246.343L1045.03 240.068H1052.23L1055.73 246.343L1052.23 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 236.983H1045.03L1041.43 230.811L1045.03 224.64H1052.23L1055.73 230.811L1052.23 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 221.451H1045.03L1041.43 215.28L1045.03 209.108H1052.23L1055.73 215.28L1052.23 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 213.737H1031.55L1028.06 207.565L1031.55 201.394H1038.75L1042.35 207.565L1038.75 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 206.023H1018.18L1014.58 199.749L1018.18 193.578H1025.38L1028.88 199.749L1025.38 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 198.206H1004.71L1001.21 192.034L1004.71 185.863H1011.91L1015.51 192.034L1011.91 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 190.492H991.337L987.737 184.32L991.337 178.046H998.537L1002.03 184.32L998.537 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 182.777H977.863L974.366 176.503L977.863 170.332H985.063L988.663 176.503L985.063 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 174.96H964.491L960.891 168.789L964.491 162.617H971.691L975.189 168.789L971.691 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 167.246H951.017L947.52 161.075L951.017 154.8H958.217L961.817 161.075L958.217 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 159.532H937.646L934.046 153.257L937.646 147.086H944.743L948.343 153.257L944.743 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 151.714H924.171L920.674 145.543L924.171 139.371H931.371L934.971 145.543L931.371 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 144H910.8L907.2 137.828L910.8 131.554H917.897L921.497 137.828L917.897 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.526 136.286H897.326L893.829 130.011L897.326 123.84H904.526L908.126 130.011L904.526 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.583 124.251H886.423L885.292 122.297L886.423 120.343H888.583L889.714 122.297L888.583 124.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M768.034 54.8231H765.36L764.126 52.5602L765.36 50.2974H768.034L769.269 52.5602L768.034 54.8231Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M755.691 48.9603H750.857L748.491 44.7432L750.857 40.6289H755.691L758.057 44.7432L755.691 48.9603Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M741.6 40.1143H738L736.252 37.0286L738 33.9429H741.6L743.452 37.0286L741.6 40.1143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M727.2 30.5485H725.657L724.937 29.3142L725.657 27.9771H727.2L727.92 29.3142L727.2 30.5485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.646 97.3028H588.754L585.257 91.3371L588.754 85.2686H595.646L599.04 91.3371L595.646 97.3028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M581.143 103.166H576.412L574.046 99.0513L576.412 94.937H581.143L583.509 99.0513L581.143 103.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.08 111.6H562.526L559.749 106.766L562.526 101.932H568.08L570.96 106.766L568.08 111.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.429 120.754H548.331L544.731 114.583L548.331 108.309H555.429L559.029 114.583L555.429 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.057 128.468H534.857L531.36 122.297L534.857 116.125H542.057L545.657 122.297L542.057 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.583 136.286H521.486L517.886 130.011L521.486 123.84H528.583L532.183 130.011L528.583 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.212 144H508.012L504.514 137.828L508.012 131.554H515.212L518.812 137.828L515.212 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 151.714H494.64L491.04 145.543L494.64 139.371H501.737L505.337 145.543L501.737 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 159.532H481.166L477.566 153.257L481.166 147.086H488.366L491.966 153.257L488.366 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.274 166.114H468.411L465.531 161.074L468.411 156.034H474.274L477.154 161.074L474.274 166.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.217 193.063H417.086L416.469 192.035L417.086 191.006H418.217L418.834 192.035L418.217 193.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.314 205.097H401.143L398.057 199.749L401.143 194.503H407.314L410.297 199.749L407.314 205.097Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 213.737H387.257L383.657 207.565L387.257 201.394H394.354L397.954 207.565L394.354 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 221.451H373.783L370.183 215.28L373.783 209.108H380.983L384.583 215.28L380.983 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 236.983H373.783L370.183 230.811L373.783 224.64H380.983L384.583 230.811L380.983 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 252.514H373.783L370.183 246.343L373.783 240.068H380.983L384.583 246.343L380.983 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 268.046H373.783L370.183 261.772L373.783 255.6H380.983L384.583 261.772L380.983 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 283.474H373.783L370.183 277.303L373.783 271.131H380.983L384.583 277.303L380.983 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.029 295.714H375.737L373.989 292.834L375.737 289.852H379.029L380.777 292.834L379.029 295.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.103 309.497H376.663L375.943 308.263L376.663 307.131H378.103L378.823 308.263L378.103 309.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.44 435.908H375.326L373.269 432.308L375.326 428.708H379.44L381.497 432.308L379.44 435.908Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.411 465.017H376.354L375.429 463.371L376.354 461.623H378.411L379.337 463.371L378.411 465.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 485.074H373.783L370.183 478.8L373.783 472.628H380.983L384.583 478.8L380.983 485.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 500.503H373.783L370.183 494.332L373.783 488.16H380.983L384.583 494.332L380.983 500.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 516.035H373.783L370.183 509.863L373.783 503.589H380.983L384.583 509.863L380.983 516.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 531.566H373.783L370.183 525.292L373.783 519.12H380.983L384.583 525.292L380.983 531.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 546.994H373.783L370.183 540.823L373.783 534.651H380.983L384.583 540.823L380.983 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 562.526H373.783L370.183 556.354L373.783 550.08H380.983L384.583 556.354L380.983 562.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 578.057H373.783L370.183 571.783L373.783 565.611H380.983L384.583 571.783L380.983 578.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 593.486H373.783L370.183 587.314L373.783 581.143H380.983L384.583 587.314L380.983 593.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 616.834H360.411L356.811 610.56L360.411 604.389H367.509L371.109 610.56L367.509 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 624.549H373.783L370.183 618.377L373.783 612.103H380.983L384.583 618.377L380.983 624.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 632.263H387.257L383.657 626.092L387.257 619.92H394.354L397.954 626.092L394.354 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 640.08H400.629L397.029 633.806L400.629 627.635H407.829L411.429 633.806L407.829 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 647.794H414.103L410.503 641.623L414.103 635.349H421.2L424.8 641.623L421.2 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 655.508H427.474L423.874 649.337L427.474 643.166H434.674L438.274 649.337L434.674 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 663.326H440.949L437.349 657.051L440.949 650.88H448.046L451.646 657.051L448.046 663.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.52 671.04H454.32L450.72 664.868L454.32 658.594H461.52L465.12 664.868L461.52 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 415.234H1058.5L1054.9 409.063L1058.5 402.892H1065.6L1069.2 409.063L1065.6 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 399.806H1058.5L1054.9 393.532L1058.5 387.36H1065.6L1069.2 393.532L1065.6 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 384.274H1058.5L1054.9 378.103L1058.5 371.829H1065.6L1069.2 378.103L1065.6 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 368.743H1058.5L1054.9 362.571L1058.5 356.4H1065.6L1069.2 362.571L1065.6 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 353.212H1058.5L1054.9 347.04L1058.5 340.869H1065.6L1069.2 347.04L1065.6 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 337.783H1058.5L1054.9 331.611L1058.5 325.337H1065.6L1069.2 331.611L1065.6 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 322.251H1058.5L1054.9 316.08L1058.5 309.908H1065.6L1069.2 316.08L1065.6 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 306.72H1058.5L1054.9 300.549L1058.5 294.377H1065.6L1069.2 300.549L1065.6 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 291.291H1058.5L1054.9 285.017L1058.5 278.846H1065.6L1069.2 285.017L1065.6 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 275.76H1058.5L1054.9 269.589L1058.5 263.314H1065.6L1069.2 269.589L1065.6 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 260.229H1058.5L1054.9 254.057L1058.5 247.886H1065.6L1069.2 254.057L1065.6 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 244.8H1058.5L1054.9 238.525L1058.5 232.354H1065.6L1069.2 238.525L1065.6 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 229.268H1058.5L1054.9 223.097L1058.5 216.823H1065.6L1069.2 223.097L1065.6 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 213.737H1058.5L1054.9 207.565L1058.5 201.394H1065.6L1069.2 207.565L1065.6 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 206.023H1045.03L1041.43 199.749L1045.03 193.578H1052.23L1055.73 199.749L1052.23 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 198.206H1031.55L1028.06 192.034L1031.55 185.863H1038.75L1042.35 192.034L1038.75 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 190.492H1018.18L1014.58 184.32L1018.18 178.046H1025.38L1028.88 184.32L1025.38 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 182.777H1004.71L1001.21 176.503L1004.71 170.332H1011.91L1015.51 176.503L1011.91 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 174.96H991.337L987.737 168.789L991.337 162.617H998.537L1002.03 168.789L998.537 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 167.246H977.863L974.366 161.075L977.863 154.8H985.063L988.663 161.075L985.063 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 159.532H964.491L960.891 153.257L964.491 147.086H971.691L975.189 153.257L971.691 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 151.714H951.017L947.52 145.543L951.017 139.371H958.217L961.817 145.543L958.217 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 144H937.646L934.046 137.828L937.646 131.554H944.743L948.343 137.828L944.743 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M931.371 136.286H924.171L920.674 130.011L924.171 123.84H931.371L934.971 130.011L931.371 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M917.897 128.468H910.8L907.2 122.297L910.8 116.125H917.897L921.497 122.297L917.897 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M901.851 116.228H900L899.074 114.583L900 112.937H901.851L902.88 114.583L901.851 116.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M890.537 112.115H884.469L881.383 106.766L884.469 101.521H890.537L893.623 106.766L890.537 112.115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.211 100.903H872.949L871.92 99.0515L872.949 97.0972H875.211L876.24 99.0515L875.211 100.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M769.68 42.1715H763.714L760.731 37.0286L763.714 31.8857H769.68L772.663 37.0286L769.68 42.1715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M756.309 34.5598H750.24L747.154 29.3141L750.24 24.0684H756.309L759.291 29.3141L756.309 34.5598Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.343 69.3257H604.8L604.08 67.9885L604.8 66.6514H606.343L607.166 67.9885L606.343 69.3257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.749 81.8743H588.652L585.052 75.8057L588.652 69.6343H595.749L599.246 75.8057L595.749 81.8743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.377 89.6915H575.177L571.577 83.5201L575.177 77.3486H582.377L585.874 83.5201L582.377 89.6915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.903 97.5087H561.703L558.206 91.3373L561.703 85.063H568.903L572.503 91.3373L568.903 97.5087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.429 105.223H548.331L544.731 99.0513L548.331 92.8799H555.429L559.029 99.0513L555.429 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.057 113.04H534.857L531.36 106.766L534.857 100.594H542.057L545.657 106.766L542.057 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.583 120.754H521.486L517.886 114.583L521.486 108.309H528.583L532.183 114.583L528.583 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.212 128.468H508.012L504.514 122.297L508.012 116.125H515.212L518.812 122.297L515.212 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 136.286H494.64L491.04 130.011L494.64 123.84H501.737L505.337 130.011L501.737 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 144H481.166L477.566 137.828L481.166 131.554H488.366L491.966 137.828L488.366 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.892 151.714H467.794L464.194 145.543L467.794 139.371H474.892L478.492 145.543L474.892 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M393.943 197.383H387.669L384.583 192.034L387.669 186.686H393.943L397.029 192.034L393.943 197.383Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 206.023H373.783L370.183 199.749L373.783 193.578H380.983L384.583 199.749L380.983 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 213.737H360.411L356.811 207.565L360.411 201.394H367.509L371.109 207.565L367.509 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 229.268H360.411L356.811 223.097L360.411 216.823H367.509L371.109 223.097L367.509 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 244.8H360.411L356.811 238.525L360.411 232.354H367.509L371.109 238.525L367.509 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 260.229H360.411L356.811 254.057L360.411 247.886H367.509L371.109 254.057L367.509 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 275.76H360.411L356.811 269.589L360.411 263.314H367.509L371.109 269.589L367.509 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 291.291H360.411L356.811 285.017L360.411 278.846H367.509L371.109 285.017L367.509 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 306.72H360.411L356.811 300.549L360.411 294.377H367.509L371.109 300.549L367.509 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.04 410.914H362.88L361.851 409.062L362.88 407.211H365.04L366.069 409.062L365.04 410.914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.097 430.045H360.823L357.634 424.594L360.823 419.04H367.097L370.286 424.594L367.097 430.045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 477.257H360.411L356.811 471.085L360.411 464.914H367.509L371.109 471.085L367.509 477.257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 492.789H360.411L356.811 486.618L360.411 480.343H367.509L371.109 486.618L367.509 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 508.32H360.411L356.811 502.046L360.411 495.875H367.509L371.109 502.046L367.509 508.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 523.749H360.411L356.811 517.577L360.411 511.406H367.509L371.109 517.577L367.509 523.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 539.28H360.411L356.811 533.109L360.411 526.834H367.509L371.109 533.109L367.509 539.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 554.811H360.411L356.811 548.537L360.411 542.366H367.509L371.109 548.537L367.509 554.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 570.24H360.411L356.811 564.068L360.411 557.897H367.509L371.109 564.068L367.509 570.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 585.772H360.411L356.811 579.6L360.411 573.429H367.509L371.109 579.6L367.509 585.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 601.303H360.411L356.811 595.132L360.411 588.857H367.509L371.109 595.132L367.509 601.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.097 631.44H360.823L357.737 626.091L360.823 620.743H367.097L370.183 626.091L367.097 631.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 640.08H373.783L370.183 633.806L373.783 627.635H380.983L384.583 633.806L380.983 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 647.794H387.257L383.657 641.623L387.257 635.349H394.354L397.954 641.623L394.354 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 655.508H400.629L397.029 649.337L400.629 643.166H407.829L411.429 649.337L407.829 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 663.326H414.103L410.503 657.051L414.103 650.88H421.2L424.8 657.051L421.2 663.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 671.04H427.474L423.874 664.868L427.474 658.594H434.674L438.274 664.868L434.674 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 678.754H440.949L437.349 672.583L440.949 666.412H448.046L451.646 672.583L448.046 678.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.463 682.971H456.377L454.834 680.297L456.377 677.623H459.463L461.006 680.297L459.463 682.971Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1077.63 420.686H1073.21L1071.05 416.777L1073.21 412.972H1077.63L1079.9 416.777L1077.63 420.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 407.52H1071.87L1068.27 401.349L1071.87 395.075H1079.07L1082.57 401.349L1079.07 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 391.989H1071.87L1068.27 385.817L1071.87 379.646H1079.07L1082.57 385.817L1079.07 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 376.56H1071.87L1068.27 370.286L1071.87 364.114H1079.07L1082.57 370.286L1079.07 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 361.029H1071.87L1068.27 354.857L1071.87 348.583H1079.07L1082.57 354.857L1079.07 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 345.497H1071.87L1068.27 339.326L1071.87 333.154H1079.07L1082.57 339.326L1079.07 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 329.965H1071.87L1068.27 323.794L1071.87 317.623H1079.07L1082.57 323.794L1079.07 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 314.537H1071.87L1068.27 308.263L1071.87 302.092H1079.07L1082.57 308.263L1079.07 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 299.006H1071.87L1068.27 292.834L1071.87 286.56H1079.07L1082.57 292.834L1079.07 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 283.474H1071.87L1068.27 277.303L1071.87 271.131H1079.07L1082.57 277.303L1079.07 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 268.046H1071.87L1068.27 261.772L1071.87 255.6H1079.07L1082.57 261.772L1079.07 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 252.514H1071.87L1068.27 246.343L1071.87 240.068H1079.07L1082.57 246.343L1079.07 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 236.983H1071.87L1068.27 230.811L1071.87 224.64H1079.07L1082.57 230.811L1079.07 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 221.451H1071.87L1068.27 215.28L1071.87 209.108H1079.07L1082.57 215.28L1079.07 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 206.023H1071.87L1068.27 199.749L1071.87 193.578H1079.07L1082.57 199.749L1079.07 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 198.206H1058.5L1054.9 192.034L1058.5 185.863H1065.6L1069.2 192.034L1065.6 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 190.492H1045.03L1041.43 184.32L1045.03 178.046H1052.23L1055.73 184.32L1052.23 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 182.777H1031.55L1028.06 176.503L1031.55 170.332H1038.75L1042.35 176.503L1038.75 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 174.96H1018.18L1014.58 168.789L1018.18 162.617H1025.38L1028.88 168.789L1025.38 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 167.246H1004.71L1001.21 161.075L1004.71 154.8H1011.91L1015.51 161.075L1011.91 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 159.532H991.337L987.737 153.257L991.337 147.086H998.537L1002.03 153.257L998.537 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 151.714H977.863L974.366 145.543L977.863 139.371H985.063L988.663 145.543L985.063 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.691 144H964.491L960.891 137.828L964.491 131.554H971.691L975.189 137.828L971.691 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.217 136.286H951.017L947.52 130.011L951.017 123.84H958.217L961.817 130.011L958.217 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.743 128.468H937.646L934.046 122.297L937.646 116.125H944.743L948.343 122.297L944.743 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M929.417 117.36H926.126L924.48 114.583L926.126 111.703H929.417L931.063 114.583L929.417 117.36Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.92 95.3484H885.189L882.72 91.3369L885.189 87.2227H889.92L892.286 91.3369L889.92 95.3484Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.366 38.4689H792.72L791.897 37.0289L792.72 35.5889H794.366L795.189 37.0289L794.366 38.4689Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783.257 34.766H776.983L773.794 29.3145L776.983 23.7603H783.257L786.446 29.3145L783.257 34.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M767.52 22.9371H765.874L765.052 21.4971L765.874 20.0571H767.52L768.343 21.4971L767.52 22.9371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.651 54.4114H604.491L603.463 52.5599L604.491 50.7085H606.651L607.783 52.5599L606.651 54.4114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.749 66.4459H588.549L585.052 60.2745L588.549 54.103H595.749L599.349 60.2745L595.749 66.4459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.377 74.2631H575.177L571.577 67.9888L575.177 61.8174H582.377L585.874 67.9888L582.377 74.2631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.903 81.9771H561.703L558.206 75.8057L561.703 69.6343H568.903L572.503 75.8057L568.903 81.9771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.429 89.6915H548.331L544.731 83.5201L548.331 77.3486H555.429L559.029 83.5201L555.429 89.6915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.057 97.5087H534.857L531.36 91.3373L534.857 85.063H542.057L545.657 91.3373L542.057 97.5087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.583 105.223H521.486L517.886 99.0513L521.486 92.8799H528.583L532.183 99.0513L528.583 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.212 113.04H508.012L504.514 106.766L508.012 100.594H515.212L518.812 106.766L515.212 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 120.754H494.64L491.04 114.583L494.64 108.309H501.737L505.337 114.583L501.737 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 128.468H481.166L477.566 122.297L481.166 116.125H488.366L491.966 122.297L488.366 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.554 133.92H469.132L466.869 130.011L469.132 126.206H473.554L475.817 130.011L473.554 133.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.526 162.515H416.777L415.954 161.075L416.777 159.635H418.526L419.349 161.075L418.526 162.515Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 174.96H400.629L397.029 168.789L400.629 162.617H407.829L411.429 168.789L407.829 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.194 178.868H389.417L388.08 176.503L389.417 174.24H392.194L393.532 176.503L392.194 178.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 190.492H373.783L370.183 184.32L373.783 178.046H380.983L384.583 184.32L380.983 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 198.206H360.411L356.811 192.034L360.411 185.863H367.509L371.109 192.034L367.509 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.006 219.6H348.069L345.497 215.28L348.069 210.96H353.006L355.577 215.28L353.006 219.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.931 236.674H347.143L343.749 230.812L347.143 224.949H353.931L357.326 230.812L353.931 236.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 252.514H346.937L343.337 246.343L346.937 240.068H354.137L357.737 246.343L354.137 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 268.046H346.937L343.337 261.772L346.937 255.6H354.137L357.737 261.772L354.137 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 283.474H346.937L343.337 277.303L346.937 271.131H354.137L357.737 277.303L354.137 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 299.006H346.937L343.337 292.834L346.937 286.56H354.137L357.737 292.834L354.137 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 314.537H346.937L343.337 308.263L346.937 302.092H354.137L357.737 308.263L354.137 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.034 329.863H347.04L343.543 323.794L347.04 317.829H354.034L357.429 323.794L354.034 329.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.154 340.355H349.92L349.303 339.326L349.92 338.297H351.154L351.771 339.326L351.154 340.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.874 403.611H349.2L347.863 401.349L349.2 398.983H351.874L353.211 401.349L351.874 403.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.463 418.526H349.509L348.583 416.777L349.509 415.131H351.463L352.491 416.777L351.463 418.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.491 435.806H348.583L346.526 432.308L348.583 428.914H352.491L354.549 432.308L352.491 435.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.931 469.234H347.143L343.749 463.371L347.143 457.406H353.931L357.326 463.371L353.931 469.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 485.074H346.937L343.337 478.8L346.937 472.628H354.137L357.737 478.8L354.137 485.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 500.503H346.937L343.337 494.332L346.937 488.16H354.137L357.737 494.332L354.137 500.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 516.035H346.937L343.337 509.863L346.937 503.589H354.137L357.737 509.863L354.137 516.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 531.566H346.937L343.337 525.292L346.937 519.12H354.137L357.737 525.292L354.137 531.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 546.994H346.937L343.337 540.823L346.937 534.651H354.137L357.737 540.823L354.137 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 562.526H346.937L343.337 556.354L346.937 550.08H354.137L357.737 556.354L354.137 562.526Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 578.057H346.937L343.337 571.783L346.937 565.611H354.137L357.737 571.783L354.137 578.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 593.486H346.937L343.337 587.314L346.937 581.143H354.137L357.737 587.314L354.137 593.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 609.017H346.937L343.337 602.846L346.937 596.674H354.137L357.737 602.846L354.137 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.891 646.663H361.028L358.148 641.623L361.028 636.583H366.891L369.771 641.623L366.891 646.663Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 655.508H373.783L370.183 649.337L373.783 643.166H380.983L384.583 649.337L380.983 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 663.326H387.257L383.657 657.051L387.257 650.88H394.354L397.954 657.051L394.354 663.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 671.04H400.629L397.029 664.868L400.629 658.594H407.829L411.429 664.868L407.829 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 678.754H414.103L410.503 672.583L414.103 666.412H421.2L424.8 672.583L421.2 678.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 686.572H427.474L423.874 680.297L427.474 674.126H434.674L438.274 680.297L434.674 686.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 694.183H440.949L437.451 688.114L440.949 681.943H448.046L451.543 688.114L448.046 694.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1091.83 445.268H1085.86L1082.88 440.023L1085.86 434.88H1091.83L1094.81 440.023L1091.83 445.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 430.766H1085.35L1081.75 424.595L1085.35 418.32H1092.45L1096.05 424.595L1092.45 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 415.234H1085.35L1081.75 409.063L1085.35 402.892H1092.45L1096.05 409.063L1092.45 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 399.806H1085.35L1081.75 393.532L1085.35 387.36H1092.45L1096.05 393.532L1092.45 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 384.274H1085.35L1081.75 378.103L1085.35 371.829H1092.45L1096.05 378.103L1092.45 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 368.743H1085.35L1081.75 362.571L1085.35 356.4H1092.45L1096.05 362.571L1092.45 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 353.212H1085.35L1081.75 347.04L1085.35 340.869H1092.45L1096.05 347.04L1092.45 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 337.783H1085.35L1081.75 331.611L1085.35 325.337H1092.45L1096.05 331.611L1092.45 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 322.251H1085.35L1081.75 316.08L1085.35 309.908H1092.45L1096.05 316.08L1092.45 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 306.72H1085.35L1081.75 300.549L1085.35 294.377H1092.45L1096.05 300.549L1092.45 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 291.291H1085.35L1081.75 285.017L1085.35 278.846H1092.45L1096.05 285.017L1092.45 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 275.76H1085.35L1081.75 269.589L1085.35 263.314H1092.45L1096.05 269.589L1092.45 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 260.229H1085.35L1081.75 254.057L1085.35 247.886H1092.45L1096.05 254.057L1092.45 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 244.8H1085.35L1081.75 238.525L1085.35 232.354H1092.45L1096.05 238.525L1092.45 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 229.268H1085.35L1081.75 223.097L1085.35 216.823H1092.45L1096.05 223.097L1092.45 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 213.737H1085.35L1081.75 207.565L1085.35 201.394H1092.45L1096.05 207.565L1092.45 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 198.206H1085.35L1081.75 192.034L1085.35 185.863H1092.45L1096.05 192.034L1092.45 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 190.492H1071.87L1068.27 184.32L1071.87 178.046H1079.07L1082.57 184.32L1079.07 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 182.777H1058.5L1054.9 176.503L1058.5 170.332H1065.6L1069.2 176.503L1065.6 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 174.96H1045.03L1041.43 168.789L1045.03 162.617H1052.23L1055.73 168.789L1052.23 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 167.246H1031.55L1028.06 161.075L1031.55 154.8H1038.75L1042.35 161.075L1038.75 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 159.532H1018.18L1014.58 153.257L1018.18 147.086H1025.38L1028.88 153.257L1025.38 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 151.714H1004.71L1001.21 145.543L1004.71 139.371H1011.91L1015.51 145.543L1011.91 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 144H991.337L987.737 137.828L991.337 131.554H998.537L1002.03 137.828L998.537 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 136.286H977.863L974.366 130.011L977.863 123.84H985.063L988.663 130.011L985.063 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M971.486 128.16H964.697L961.303 122.297L964.697 116.435H971.486L974.777 122.297L971.486 128.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M958.114 120.549H951.223L947.726 114.583L951.223 108.617H958.114L961.509 114.583L958.114 120.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M944.434 112.423H937.954L934.766 106.766L937.954 101.211H944.434L947.726 106.766L944.434 112.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.011 88.7658H897.943L894.857 83.5201L897.943 78.2744H904.011L906.994 83.5201L904.011 88.7658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M888.069 76.8345H886.937L886.32 75.8059L886.937 74.7773H888.069L888.686 75.8059L888.069 76.8345Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.388 35.1772H615.6L612.206 29.3143L615.6 23.3486H622.388L625.886 29.3143L622.388 35.1772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M608.914 42.8912H602.229L598.834 37.0284L602.229 31.1655H608.914L612.308 37.0284L608.914 42.8912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.749 51.017H588.549L585.052 44.7427L588.549 38.5713H595.749L599.349 44.7427L595.749 51.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.377 58.7314H575.177L571.577 52.5599L575.177 46.2856H582.377L585.874 52.5599L582.377 58.7314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.903 66.4459H561.703L558.206 60.2745L561.703 54.103H568.903L572.503 60.2745L568.903 66.4459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.429 74.2631H548.331L544.731 67.9888L548.331 61.8174H555.429L559.029 67.9888L555.429 74.2631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.057 81.9771H534.857L531.36 75.8057L534.857 69.6343H542.057L545.657 75.8057L542.057 81.9771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.583 89.6915H521.486L517.886 83.5201L521.486 77.3486H528.583L532.183 83.5201L528.583 89.6915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.212 97.5087H508.012L504.514 91.3373L508.012 85.063H515.212L518.812 91.3373L515.212 97.5087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 105.223H494.64L491.04 99.0513L494.64 92.8799H501.737L505.337 99.0513L501.737 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 113.04H481.166L477.566 106.766L481.166 100.594H488.366L491.966 106.766L488.366 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.583 120.137H468.103L464.914 114.583L468.103 108.926H474.583L477.771 114.583L474.583 120.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.131 141.223H429.017L427.063 137.829L429.017 134.332H433.131L435.086 137.829L433.131 141.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 151.714H414.103L410.503 145.543L414.103 139.371H421.2L424.8 145.543L421.2 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 159.532H400.629L397.029 153.257L400.629 147.086H407.829L411.429 153.257L407.829 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 167.246H387.257L383.657 161.074L387.257 154.903H394.354L397.954 161.074L394.354 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 182.674H360.411L356.914 176.503L360.411 170.434H367.509L371.006 176.503L367.509 182.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.429 227.109H334.8L332.434 223.097L334.8 218.983H339.429L341.794 223.097L339.429 227.109Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.56 244.492H333.669L330.274 238.526L333.669 232.663H340.56L343.954 238.526L340.56 244.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 260.229H333.566L329.966 254.057L333.566 247.886H340.663L344.263 254.057L340.663 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 275.76H333.566L329.966 269.589L333.566 263.314H340.663L344.263 269.589L340.663 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 291.291H333.566L329.966 285.017L333.566 278.846H340.663L344.263 285.017L340.663 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 306.72H333.566L329.966 300.549L333.566 294.377H340.663L344.263 300.549L340.663 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 322.251H333.566L329.966 316.08L333.566 309.908H340.663L344.263 316.08L340.663 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 337.783H333.566L329.966 331.611L333.566 325.337H340.663L344.263 331.611L340.663 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.046 352.08H334.183L331.303 347.04L334.183 342H340.046L342.926 347.04L340.046 352.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.606 411.635H335.623L334.183 409.063L335.623 406.492H338.606L340.046 409.063L338.606 411.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.4 426.754H335.829L334.594 424.594L335.829 422.332H338.4L339.634 424.594L338.4 426.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.943 476.023H334.286L331.406 471.086L334.286 466.148H339.943L342.823 471.086L339.943 476.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 492.789H333.566L329.966 486.618L333.566 480.343H340.663L344.263 486.618L340.663 492.789Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 508.32H333.566L329.966 502.046L333.566 495.875H340.663L344.263 502.046L340.663 508.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 523.749H333.566L329.966 517.577L333.566 511.406H340.663L344.263 517.577L340.663 523.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 539.28H333.566L329.966 533.109L333.566 526.834H340.663L344.263 533.109L340.663 539.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 554.811H333.566L329.966 548.537L333.566 542.366H340.663L344.263 548.537L340.663 554.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 570.24H333.566L329.966 564.068L333.566 557.897H340.663L344.263 564.068L340.663 570.24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 585.669H333.566L330.069 579.6L333.566 573.429H340.663L344.16 579.6L340.663 585.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.223 598.732H335.006L332.846 595.132L335.006 591.429H339.223L341.28 595.132L339.223 598.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.583 661.68H361.234L358.663 657.051L361.234 652.423H366.583L369.257 657.051L366.583 661.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 671.04H373.783L370.183 664.868L373.783 658.594H380.983L384.583 664.868L380.983 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 678.754H387.257L383.657 672.583L387.257 666.412H394.354L397.954 672.583L394.354 678.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 686.572H400.629L397.029 680.297L400.629 674.126H407.829L411.429 680.297L407.829 686.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 694.286H414.103L410.503 688.114L414.103 681.943H421.2L424.8 688.114L421.2 694.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M434.674 702H427.474L423.977 695.829L427.474 689.657H434.674L438.171 695.829L434.674 702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.89 514.286H1099.75L1097.18 509.863L1099.75 505.44H1104.89L1107.46 509.863L1104.89 514.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1104.48 498.035H1100.16L1098 494.332L1100.16 490.629H1104.48L1106.54 494.332L1104.48 498.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.3 452.983H1099.34L1096.35 447.84L1099.34 442.594H1105.3L1108.29 447.84L1105.3 452.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 438.48H1098.72L1095.12 432.308L1098.72 426.137H1105.92L1109.42 432.308L1105.92 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 423.052H1098.72L1095.12 416.777L1098.72 410.606H1105.92L1109.42 416.777L1105.92 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 407.52H1098.72L1095.12 401.349L1098.72 395.075H1105.92L1109.42 401.349L1105.92 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 391.989H1098.72L1095.12 385.817L1098.72 379.646H1105.92L1109.42 385.817L1105.92 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 376.56H1098.72L1095.12 370.286L1098.72 364.114H1105.92L1109.42 370.286L1105.92 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 361.029H1098.72L1095.12 354.857L1098.72 348.583H1105.92L1109.42 354.857L1105.92 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 345.497H1098.72L1095.12 339.326L1098.72 333.154H1105.92L1109.42 339.326L1105.92 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 329.965H1098.72L1095.12 323.794L1098.72 317.623H1105.92L1109.42 323.794L1105.92 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 314.537H1098.72L1095.12 308.263L1098.72 302.092H1105.92L1109.42 308.263L1105.92 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 299.006H1098.72L1095.12 292.834L1098.72 286.56H1105.92L1109.42 292.834L1105.92 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 283.474H1098.72L1095.12 277.303L1098.72 271.131H1105.92L1109.42 277.303L1105.92 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 268.046H1098.72L1095.12 261.772L1098.72 255.6H1105.92L1109.42 261.772L1105.92 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 252.514H1098.72L1095.12 246.343L1098.72 240.068H1105.92L1109.42 246.343L1105.92 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 236.983H1098.72L1095.12 230.811L1098.72 224.64H1105.92L1109.42 230.811L1105.92 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 221.451H1098.72L1095.12 215.28L1098.72 209.108H1105.92L1109.42 215.28L1105.92 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 206.023H1098.72L1095.12 199.749L1098.72 193.578H1105.92L1109.42 199.749L1105.92 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 190.492H1098.72L1095.12 184.32L1098.72 178.046H1105.92L1109.42 184.32L1105.92 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 182.777H1085.35L1081.75 176.503L1085.35 170.332H1092.45L1096.05 176.503L1092.45 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 174.96H1071.87L1068.27 168.789L1071.87 162.617H1079.07L1082.57 168.789L1079.07 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 167.246H1058.5L1054.9 161.075L1058.5 154.8H1065.6L1069.2 161.075L1065.6 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 159.532H1045.03L1041.43 153.257L1045.03 147.086H1052.23L1055.73 153.257L1052.23 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 151.714H1031.55L1028.06 145.543L1031.55 139.371H1038.75L1042.35 145.543L1038.75 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 144H1018.18L1014.58 137.828L1018.18 131.554H1025.38L1028.88 137.828L1025.38 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 136.286H1004.71L1001.21 130.011L1004.71 123.84H1011.91L1015.51 130.011L1011.91 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.537 128.468H991.337L987.737 122.297L991.337 116.125H998.537L1002.03 122.297L998.537 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M985.063 120.754H977.863L974.366 114.583L977.863 108.309H985.063L988.663 114.583L985.063 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M970.046 110.16H966.137L964.183 106.766L966.137 103.475H970.046L971.897 106.766L970.046 110.16Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M955.543 100.491H953.794L952.971 99.0512L953.794 97.5083H955.543L956.366 99.0512L955.543 100.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M916.869 80.023H911.931L909.463 75.8058L911.931 71.4858H916.869L919.234 75.8058L916.869 80.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.989 25.7142H603.257L600.789 21.4971L603.257 17.3828H607.989L610.354 21.4971L607.989 25.7142Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.749 35.4858H588.549L585.052 29.3143L588.549 23.04H595.749L599.349 29.3143L595.749 35.4858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.377 43.1998H575.177L571.577 37.0284L575.177 30.8569H582.377L585.874 37.0284L582.377 43.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.903 51.017H561.703L558.206 44.7427L561.703 38.5713H568.903L572.503 44.7427L568.903 51.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.429 58.7314H548.331L544.731 52.5599L548.331 46.2856H555.429L559.029 52.5599L555.429 58.7314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.057 66.4459H534.857L531.36 60.2745L534.857 54.103H542.057L545.657 60.2745L542.057 66.4459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.583 74.2631H521.486L517.886 67.9888L521.486 61.8174H528.583L532.183 67.9888L528.583 74.2631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.212 81.9771H508.012L504.514 75.8057L508.012 69.6343H515.212L518.812 75.8057L515.212 81.9771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 89.6915H494.64L491.04 83.5201L494.64 77.3486H501.737L505.337 83.5201L501.737 89.6915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 97.5087H481.166L477.566 91.3373L481.166 85.063H488.366L491.966 91.3373L488.366 97.5087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.891 105.12H467.794L464.297 99.0513L467.794 92.8799H474.891L478.389 99.0513L474.891 105.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.743 108.103H457.097L456.377 106.766L457.097 105.429H458.743L459.463 106.766L458.743 108.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.863 133.817H415.44L413.28 130.011L415.44 126.206H419.863L422.023 130.011L419.863 133.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 144H400.629L397.029 137.828L400.629 131.554H407.829L411.429 137.828L407.829 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 151.714H387.257L383.657 145.543L387.257 139.371H394.354L397.954 145.543L394.354 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.88 159.429H373.783L370.286 153.258L373.783 147.189H380.88L384.48 153.258L380.88 159.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.731 162.412H363.189L362.366 161.075L363.189 159.635H364.731L365.554 161.075L364.731 162.412Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.183 171.668H348.891L347.246 168.788L348.891 165.908H352.183L353.828 168.788L352.183 171.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.72 217.131H322.56L321.531 215.28L322.56 213.428H324.72L325.851 215.28L324.72 217.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.291 236.983H320.091L316.491 230.811L320.091 224.64H327.291L330.789 230.811L327.291 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.291 252.514H320.091L316.491 246.343L320.091 240.068H327.291L330.789 246.343L327.291 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.291 268.046H320.091L316.491 261.772L320.091 255.6H327.291L330.789 261.772L327.291 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.291 283.474H320.091L316.491 277.303L320.091 271.131H327.291L330.789 277.303L327.291 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.291 299.006H320.091L316.491 292.834L320.091 286.56H327.291L330.789 292.834L327.291 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.291 314.537H320.091L316.491 308.263L320.091 302.092H327.291L330.789 308.263L327.291 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.291 329.965H320.091L316.491 323.794L320.091 317.623H327.291L330.789 323.794L327.291 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.291 345.497H320.091L316.491 339.326L320.091 333.154H327.291L330.789 339.326L327.291 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.189 360.823H320.194L316.697 354.857L320.194 348.789H327.189L330.686 354.857L327.189 360.823Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.823 372.343H322.56L321.326 370.286L322.56 368.332H324.823L325.954 370.286L324.823 372.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.674 391.063H320.709L317.623 385.817L320.709 380.571H326.674L329.657 385.817L326.674 391.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.617 418.423H322.766L321.737 416.777L322.766 415.131H324.617L325.543 416.777L324.617 418.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.086 484.765H320.297L316.903 478.799L320.297 472.937H327.086L330.48 478.799L327.086 484.765Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.72 496.08H322.663L321.634 494.332L322.663 492.583H324.72L325.749 494.332L324.72 496.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.851 513.566H321.531L319.371 509.863L321.531 506.057H325.851L328.011 509.863L325.851 513.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.291 531.566H320.091L316.491 525.292L320.091 519.12H327.291L330.789 525.292L327.291 531.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.189 546.994H320.092L316.594 540.823L320.092 534.651H327.189L330.789 540.823L327.189 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.131 558.72H322.251L320.914 556.354L322.251 553.886H325.131L326.469 556.354L325.131 558.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.777 577.235H320.503L317.417 571.783L320.503 566.435H326.777L329.966 571.783L326.777 577.235Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.966 676.08H361.954L359.897 672.583L361.954 669.086H365.966L368.023 672.583L365.966 676.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 686.572H373.783L370.183 680.297L373.783 674.126H380.983L384.583 680.297L380.983 686.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 694.286H387.257L383.657 688.114L387.257 681.943H394.354L397.954 688.114L394.354 694.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 702H400.629L397.029 695.829L400.629 689.657H407.829L411.429 695.829L407.829 702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 709.817H414.103L410.503 703.543L414.103 697.372H421.2L424.8 703.543L421.2 709.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.926 714.549H429.223L427.371 711.36L429.223 708.171H432.926L434.777 711.36L432.926 714.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1118.06 537.12H1113.43L1111.06 533.108L1113.43 528.994H1118.06L1120.42 533.108L1118.06 537.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.09 523.44H1112.4L1109.01 517.577L1112.4 511.714H1119.09L1122.48 517.577L1119.09 523.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.82 504H1114.66L1113.53 502.045L1114.66 500.194H1116.82L1117.95 502.045L1116.82 504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.19 492.479H1112.3L1108.9 486.617L1112.3 480.651H1119.19L1122.58 486.617L1119.19 492.479Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1116.82 472.937H1114.66L1113.53 471.086L1114.66 469.234H1116.82L1117.85 471.086L1116.82 472.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.09 461.417H1112.3L1109.01 455.554L1112.3 449.691H1119.09L1122.48 455.554L1119.09 461.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 446.297H1112.19L1108.59 440.023L1112.19 433.852H1119.29L1122.89 440.023L1119.29 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 430.766H1112.19L1108.59 424.595L1112.19 418.32H1119.29L1122.89 424.595L1119.29 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 415.234H1112.19L1108.59 409.063L1112.19 402.892H1119.29L1122.89 409.063L1119.29 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 399.806H1112.19L1108.59 393.532L1112.19 387.36H1119.29L1122.89 393.532L1119.29 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 384.274H1112.19L1108.59 378.103L1112.19 371.829H1119.29L1122.89 378.103L1119.29 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 368.743H1112.19L1108.59 362.571L1112.19 356.4H1119.29L1122.89 362.571L1119.29 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 353.212H1112.19L1108.59 347.04L1112.19 340.869H1119.29L1122.89 347.04L1119.29 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 337.783H1112.19L1108.59 331.611L1112.19 325.337H1119.29L1122.89 331.611L1119.29 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 322.251H1112.19L1108.59 316.08L1112.19 309.908H1119.29L1122.89 316.08L1119.29 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 306.72H1112.19L1108.59 300.549L1112.19 294.377H1119.29L1122.89 300.549L1119.29 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 291.291H1112.19L1108.59 285.017L1112.19 278.846H1119.29L1122.89 285.017L1119.29 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 275.76H1112.19L1108.59 269.589L1112.19 263.314H1119.29L1122.89 269.589L1119.29 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 260.229H1112.19L1108.59 254.057L1112.19 247.886H1119.29L1122.89 254.057L1119.29 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 244.8H1112.19L1108.59 238.525L1112.19 232.354H1119.29L1122.89 238.525L1119.29 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 229.268H1112.19L1108.59 223.097L1112.19 216.823H1119.29L1122.89 223.097L1119.29 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 213.737H1112.19L1108.59 207.565L1112.19 201.394H1119.29L1122.89 207.565L1119.29 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 198.206H1112.19L1108.59 192.034L1112.19 185.863H1119.29L1122.89 192.034L1119.29 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 182.777H1112.19L1108.59 176.503L1112.19 170.332H1119.29L1122.89 176.503L1119.29 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 174.96H1098.72L1095.12 168.789L1098.72 162.617H1105.92L1109.42 168.789L1105.92 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 167.246H1085.35L1081.75 161.075L1085.35 154.8H1092.45L1096.05 161.075L1092.45 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 159.532H1071.87L1068.27 153.257L1071.87 147.086H1079.07L1082.57 153.257L1079.07 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 151.714H1058.5L1054.9 145.543L1058.5 139.371H1065.6L1069.2 145.543L1065.6 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 144H1045.03L1041.43 137.828L1045.03 131.554H1052.23L1055.73 137.828L1052.23 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 136.286H1031.55L1028.06 130.011L1031.55 123.84H1038.75L1042.35 130.011L1038.75 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 128.468H1018.18L1014.58 122.297L1018.18 116.125H1025.38L1028.88 122.297L1025.38 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 120.754H1004.71L1001.21 114.583L1004.71 108.309H1011.91L1015.51 114.583L1011.91 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M998.331 112.834H991.44L987.943 106.766L991.44 100.8H998.331L1001.83 106.766L998.331 112.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M983.212 101.931H979.817L978.069 99.0514L979.817 96.1714H983.212L984.857 99.0514L983.212 101.931Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M930.96 73.4396H924.686L921.497 67.9882L924.686 62.6396H930.96L934.046 67.9882L930.96 73.4396Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.989 10.2857H603.154L600.686 6.06854L603.154 1.74854H607.989L610.457 6.06854L607.989 10.2857Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.44 19.4398H588.96L585.669 13.7826L588.96 8.12549H595.44L598.629 13.7826L595.44 19.4398Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M580.32 24.2745H577.131L575.589 21.4974L577.131 18.7202H580.32L581.966 21.4974L580.32 24.2745Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.903 35.4858H561.703L558.206 29.3143L561.703 23.04H568.903L572.503 29.3143L568.903 35.4858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.429 43.1998H548.331L544.731 37.0284L548.331 30.8569H555.429L559.029 37.0284L555.429 43.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.057 51.017H534.857L531.36 44.7427L534.857 38.5713H542.057L545.657 44.7427L542.057 51.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.583 58.7314H521.486L517.886 52.5599L521.486 46.2856H528.583L532.183 52.5599L528.583 58.7314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.212 66.4459H508.012L504.514 60.2745L508.012 54.103H515.212L518.812 60.2745L515.212 66.4459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 74.2631H494.64L491.04 67.9888L494.64 61.8174H501.737L505.337 67.9888L501.737 74.2631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 81.9771H481.166L477.566 75.8057L481.166 69.6343H488.366L491.966 75.8057L488.366 81.9771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.892 89.6915H467.794L464.194 83.5201L467.794 77.3486H474.892L478.492 83.5201L474.892 89.6915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459.257 93.5998H456.583L455.246 91.3369L456.583 88.9712H459.257L460.594 91.3369L459.257 93.5998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 128.468H400.629L397.029 122.297L400.629 116.125H407.829L411.429 122.297L407.829 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.149 135.875H387.463L384.069 130.012L387.463 124.149H394.149L397.543 130.012L394.149 135.875Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.84 165.806H334.389L331.611 161.074L334.389 156.343H339.84L342.617 161.074L339.84 165.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.76 179.177H308.777L307.234 176.503L308.777 173.932H311.76L313.303 176.503L311.76 179.177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.349 209.417H309.189L308.057 207.566L309.189 205.611H311.349L312.48 207.566L311.349 209.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.817 229.268H306.72L303.12 223.097L306.72 216.823H313.817L317.417 223.097L313.817 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.817 244.8H306.72L303.12 238.525L306.72 232.354H313.817L317.417 238.525L313.817 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.817 260.229H306.72L303.12 254.057L306.72 247.886H313.817L317.417 254.057L313.817 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.817 275.76H306.72L303.12 269.589L306.72 263.314H313.817L317.417 269.589L313.817 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.817 291.291H306.72L303.12 285.017L306.72 278.846H313.817L317.417 285.017L313.817 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.817 306.72H306.72L303.12 300.549L306.72 294.377H313.817L317.417 300.549L313.817 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.817 322.251H306.72L303.12 316.08L306.72 309.908H313.817L317.417 316.08L313.817 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.817 337.783H306.72L303.12 331.611L306.72 325.337H313.817L317.417 331.611L313.817 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.817 353.212H306.72L303.12 347.04L306.72 340.869H313.817L317.417 347.04L313.817 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.817 368.743H306.72L303.12 362.571L306.72 356.4H313.817L317.417 362.571L313.817 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.554 380.365H308.88L307.543 378.103L308.88 375.737H311.554L312.994 378.103L311.554 380.365Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.406 414.514H307.131L304.046 409.063L307.131 403.714H313.406L316.491 409.063L313.406 414.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.04 456.994H309.394L308.571 455.554L309.394 454.114H311.04L311.863 455.554L311.04 456.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.349 472.938H309.189L308.057 471.086L309.189 469.132H311.349L312.48 471.086L311.349 472.938Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.76 489.086H308.777L307.337 486.617L308.777 484.046H311.76L313.2 486.617L311.76 489.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.097 693.566H360.72L357.531 688.114L360.72 682.56H367.097L370.286 688.114L367.097 693.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 702H373.783L370.183 695.829L373.783 689.657H380.983L384.583 695.829L380.983 702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 709.817H387.257L383.657 703.543L387.257 697.372H394.354L397.954 703.543L394.354 709.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 717.532H400.629L397.029 711.36L400.629 705.189H407.829L411.429 711.36L407.829 717.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 725.246H414.103L410.503 719.075L414.103 712.903H421.2L424.8 719.075L421.2 725.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.56 546.686H1125.77L1122.38 540.823L1125.77 534.96H1132.56L1135.85 540.823L1132.56 546.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.46 531.051H1125.87L1122.58 525.291L1125.87 519.634H1132.46L1135.75 525.291L1132.46 531.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.71 512.434H1127.62L1126.08 509.863L1127.62 507.188H1130.71L1132.25 509.863L1130.71 512.434Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.91 497.417H1127.42L1125.67 494.331L1127.42 491.246H1130.91L1132.66 494.331L1130.91 497.417Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 469.543H1125.57L1121.97 463.371L1125.57 457.097H1132.77L1136.37 463.371L1132.77 469.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 454.011H1125.57L1121.97 447.84L1125.57 441.668H1132.77L1136.37 447.84L1132.77 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 438.48H1125.57L1121.97 432.308L1125.57 426.137H1132.77L1136.37 432.308L1132.77 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 423.052H1125.57L1121.97 416.777L1125.57 410.606H1132.77L1136.37 416.777L1132.77 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 407.52H1125.57L1121.97 401.349L1125.57 395.075H1132.77L1136.37 401.349L1132.77 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 391.989H1125.57L1121.97 385.817L1125.57 379.646H1132.77L1136.37 385.817L1132.77 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 376.56H1125.57L1121.97 370.286L1125.57 364.114H1132.77L1136.37 370.286L1132.77 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 361.029H1125.57L1121.97 354.857L1125.57 348.583H1132.77L1136.37 354.857L1132.77 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 345.497H1125.57L1121.97 339.326L1125.57 333.154H1132.77L1136.37 339.326L1132.77 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 329.965H1125.57L1121.97 323.794L1125.57 317.623H1132.77L1136.37 323.794L1132.77 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 314.537H1125.57L1121.97 308.263L1125.57 302.092H1132.77L1136.37 308.263L1132.77 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 299.006H1125.57L1121.97 292.834L1125.57 286.56H1132.77L1136.37 292.834L1132.77 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 283.474H1125.57L1121.97 277.303L1125.57 271.131H1132.77L1136.37 277.303L1132.77 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 268.046H1125.57L1121.97 261.772L1125.57 255.6H1132.77L1136.37 261.772L1132.77 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 252.514H1125.57L1121.97 246.343L1125.57 240.068H1132.77L1136.37 246.343L1132.77 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 236.983H1125.57L1121.97 230.811L1125.57 224.64H1132.77L1136.37 230.811L1132.77 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 221.451H1125.57L1121.97 215.28L1125.57 209.108H1132.77L1136.37 215.28L1132.77 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 206.023H1125.57L1121.97 199.749L1125.57 193.578H1132.77L1136.37 199.749L1132.77 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 190.492H1125.57L1121.97 184.32L1125.57 178.046H1132.77L1136.37 184.32L1132.77 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 174.96H1125.57L1121.97 168.789L1125.57 162.617H1132.77L1136.37 168.789L1132.77 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 167.246H1112.19L1108.59 161.075L1112.19 154.8H1119.29L1122.89 161.075L1119.29 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 159.532H1098.72L1095.12 153.257L1098.72 147.086H1105.92L1109.42 153.257L1105.92 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 151.714H1085.35L1081.75 145.543L1085.35 139.371H1092.45L1096.05 145.543L1092.45 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 144H1071.87L1068.27 137.828L1071.87 131.554H1079.07L1082.57 137.828L1079.07 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 136.286H1058.5L1054.9 130.011L1058.5 123.84H1065.6L1069.2 130.011L1065.6 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 128.468H1045.03L1041.43 122.297L1045.03 116.125H1052.23L1055.73 122.297L1052.23 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 120.754H1031.55L1028.06 114.583L1031.55 108.309H1038.75L1042.35 114.583L1038.75 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 113.04H1018.18L1014.58 106.766L1018.18 100.594H1025.38L1028.88 106.766L1025.38 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.91 105.223H1004.71L1001.21 99.0513L1004.71 92.8799H1011.91L1015.51 99.0513L1011.91 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.509 95.7601H992.366L989.794 91.3372L992.366 86.8115H997.509L1000.08 91.3372L997.509 95.7601Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M902.263 39.2909H899.589L898.354 37.028L899.589 34.7651H902.263L903.6 37.028L902.263 39.2909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M582.172 12.0343H575.28L571.783 6.06857L575.28 0H582.172L585.669 6.06857L582.172 12.0343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M568.697 19.6461H561.909L558.514 13.7833L561.909 7.92041H568.697L572.092 13.7833L568.697 19.6461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.429 27.7714H548.331L544.731 21.4971L548.331 15.3257H555.429L559.029 21.4971L555.429 27.7714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.057 35.4858H534.857L531.36 29.3143L534.857 23.04H542.057L545.657 29.3143L542.057 35.4858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.583 43.1998H521.486L517.886 37.0284L521.486 30.8569H528.583L532.183 37.0284L528.583 43.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.212 51.017H508.012L504.514 44.7427L508.012 38.5713H515.212L518.812 44.7427L515.212 51.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 58.7314H494.64L491.04 52.5599L494.64 46.2856H501.737L505.337 52.5599L501.737 58.7314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 66.4459H481.166L477.566 60.2745L481.166 54.103H488.366L491.966 60.2745L488.366 66.4459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.892 74.2631H467.794L464.194 67.9888L467.794 61.8174H474.892L478.492 67.9888L474.892 74.2631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.417 81.7711H454.423L451.029 75.8054L454.423 69.7368H461.417L464.811 75.8054L461.417 81.7711Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.286 110.366H402.171L400.011 106.766L402.171 103.166H406.286L408.446 106.766L406.286 110.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 120.754H387.257L383.657 114.583L387.257 108.309H394.354L397.954 114.583L394.354 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.057 126.926H374.709L372.034 122.297L374.709 117.668H380.057L382.731 122.297L380.057 126.926Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 144H346.937L343.337 137.828L346.937 131.554H354.137L357.737 137.828L354.137 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.56 151.405H333.669L330.274 145.543L333.669 139.68H340.56L343.954 145.543L340.56 151.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.291 159.532H320.091L316.491 153.257L320.091 147.086H327.291L330.789 153.257L327.291 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.817 167.246H306.72L303.12 161.075L306.72 154.8H313.817L317.417 161.075L313.817 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 174.96H293.246L289.646 168.789L293.246 162.617H300.446L303.943 168.789L300.446 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.24 190.285H293.349L289.954 184.32L293.349 178.354H300.24L303.737 184.32L300.24 190.285Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.034 205.303H293.657L290.469 199.749L293.657 194.297H300.034L303.12 199.749L300.034 205.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 221.451H293.246L289.646 215.28L293.246 209.108H300.446L303.943 215.28L300.446 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 236.983H293.246L289.646 230.811L293.246 224.64H300.446L303.943 230.811L300.446 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 252.514H293.246L289.646 246.343L293.246 240.068H300.446L303.943 246.343L300.446 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 268.046H293.246L289.646 261.772L293.246 255.6H300.446L303.943 261.772L300.446 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 283.474H293.246L289.646 277.303L293.246 271.131H300.446L303.943 277.303L300.446 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 299.006H293.246L289.646 292.834L293.246 286.56H300.446L303.943 292.834L300.446 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 314.537H293.246L289.646 308.263L293.246 302.092H300.446L303.943 308.263L300.446 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 329.965H293.246L289.646 323.794L293.246 317.623H300.446L303.943 323.794L300.446 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 345.497H293.246L289.646 339.326L293.246 333.154H300.446L303.943 339.326L300.446 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 361.029H293.246L289.646 354.857L293.246 348.583H300.446L303.943 354.857L300.446 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.24 376.252H293.349L289.954 370.286L293.349 364.32H300.24L303.737 370.286L300.24 376.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 454.011H293.246L289.646 447.84L293.246 441.668H300.446L303.943 447.84L300.446 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 469.543H293.246L289.646 463.371L293.246 457.097H300.446L303.943 463.371L300.446 469.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.36 479.829H296.229L295.714 478.8L296.229 477.875H297.36L297.977 478.8L297.36 479.829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 709.817H360.411L356.811 703.543L360.411 697.372H367.509L371.109 703.543L367.509 709.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 717.532H373.783L370.183 711.36L373.783 705.189H380.983L384.583 711.36L380.983 717.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 725.246H387.257L383.657 719.075L387.257 712.903H394.354L397.954 719.075L394.354 725.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.828 732.96H400.628L397.131 726.892L400.628 720.72H407.828L411.326 726.892L407.828 732.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1144.39 551.623H1140.79L1139.04 548.537L1140.79 545.554H1144.39L1146.14 548.537L1144.39 551.623Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1145.93 476.743H1139.25L1135.95 471.086L1139.25 465.326H1145.93L1149.22 471.086L1145.93 476.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 461.726H1139.04L1135.44 455.554L1139.04 449.383H1146.14L1149.74 455.554L1146.14 461.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 446.297H1139.04L1135.44 440.023L1139.04 433.852H1146.14L1149.74 440.023L1146.14 446.297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1143.98 426.96H1141.2L1139.86 424.594L1141.2 422.229H1143.98L1145.31 424.594L1143.98 426.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 415.234H1139.04L1135.44 409.063L1139.04 402.892H1146.14L1149.74 409.063L1146.14 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 399.806H1139.04L1135.44 393.532L1139.04 387.36H1146.14L1149.74 393.532L1146.14 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 384.274H1139.04L1135.44 378.103L1139.04 371.829H1146.14L1149.74 378.103L1146.14 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 368.743H1139.04L1135.44 362.571L1139.04 356.4H1146.14L1149.74 362.571L1146.14 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 353.212H1139.04L1135.44 347.04L1139.04 340.869H1146.14L1149.74 347.04L1146.14 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 337.783H1139.04L1135.44 331.611L1139.04 325.337H1146.14L1149.74 331.611L1146.14 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 322.251H1139.04L1135.44 316.08L1139.04 309.908H1146.14L1149.74 316.08L1146.14 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 306.72H1139.04L1135.44 300.549L1139.04 294.377H1146.14L1149.74 300.549L1146.14 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 291.291H1139.04L1135.44 285.017L1139.04 278.846H1146.14L1149.74 285.017L1146.14 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 275.76H1139.04L1135.44 269.589L1139.04 263.314H1146.14L1149.74 269.589L1146.14 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 260.229H1139.04L1135.44 254.057L1139.04 247.886H1146.14L1149.74 254.057L1146.14 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 244.8H1139.04L1135.44 238.525L1139.04 232.354H1146.14L1149.74 238.525L1146.14 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 229.268H1139.04L1135.44 223.097L1139.04 216.823H1146.14L1149.74 223.097L1146.14 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 213.737H1139.04L1135.44 207.565L1139.04 201.394H1146.14L1149.74 207.565L1146.14 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 198.206H1139.04L1135.44 192.034L1139.04 185.863H1146.14L1149.74 192.034L1146.14 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 182.777H1139.04L1135.44 176.503L1139.04 170.332H1146.14L1149.74 176.503L1146.14 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 167.246H1139.04L1135.44 161.075L1139.04 154.8H1146.14L1149.74 161.075L1146.14 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 159.532H1125.57L1121.97 153.257L1125.57 147.086H1132.77L1136.37 153.257L1132.77 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 151.714H1112.19L1108.59 145.543L1112.19 139.371H1119.29L1122.89 145.543L1119.29 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 144H1098.72L1095.12 137.828L1098.72 131.554H1105.92L1109.42 137.828L1105.92 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 136.286H1085.35L1081.75 130.011L1085.35 123.84H1092.45L1096.05 130.011L1092.45 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 128.468H1071.87L1068.27 122.297L1071.87 116.125H1079.07L1082.57 122.297L1079.07 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 120.754H1058.5L1054.9 114.583L1058.5 108.309H1065.6L1069.2 114.583L1065.6 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 113.04H1045.03L1041.43 106.766L1045.03 100.594H1052.23L1055.73 106.766L1052.23 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 105.223H1031.55L1028.06 99.0513L1031.55 92.8799H1038.75L1042.35 99.0513L1038.75 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1025.38 97.5087H1018.18L1014.58 91.3373L1018.18 85.063H1025.38L1028.88 91.3373L1025.38 97.5087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1011.81 89.5885H1004.81L1001.42 83.5199L1004.81 77.5542H1011.81L1015.3 83.5199L1011.81 89.5885Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.429 12.0343H548.434L544.937 6.06857L548.434 0H555.429L558.823 6.06857L555.429 12.0343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M542.057 19.9542H534.857L531.36 13.7828L534.857 7.61133H542.057L545.657 13.7828L542.057 19.9542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M528.583 27.7714H521.486L517.886 21.4971L521.486 15.3257H528.583L532.183 21.4971L528.583 27.7714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M515.212 35.4858H508.012L504.514 29.3143L508.012 23.04H515.212L518.812 29.3143L515.212 35.4858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.737 43.1998H494.64L491.04 37.0284L494.64 30.8569H501.737L505.337 37.0284L501.737 43.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 51.017H481.166L477.566 44.7427L481.166 38.5713H488.366L491.966 44.7427L488.366 51.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.892 58.7314H467.794L464.194 52.5599L467.794 46.2856H474.892L478.492 52.5599L474.892 58.7314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.52 66.4459H454.32L450.72 60.2745L454.32 54.103H461.52L465.12 60.2745L461.52 66.4459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 74.2631H440.949L437.349 67.9888L440.949 61.8174H448.046L451.646 67.9888L448.046 74.2631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.411 78.1714H429.737L428.4 75.8057L429.737 73.4399H432.411L433.748 75.8057L432.411 78.1714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.474 100.183H390.137L389.417 99.0517L390.137 97.8174H391.474L392.194 99.0517L391.474 100.183Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 113.04H373.783L370.183 106.766L373.783 100.594H380.983L384.583 106.766L380.983 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 120.754H360.411L356.811 114.583L360.411 108.309H367.509L371.109 114.583L367.509 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.314 127.131H347.76L344.88 122.297L347.76 117.463H353.314L356.194 122.297L353.314 127.131Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.12 133.611H335.006L332.948 130.011L335.006 126.514H339.12L341.28 130.011L339.12 133.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.291 144H320.091L316.491 137.828L320.091 131.554H327.291L330.789 137.828L327.291 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.817 151.714H306.72L303.12 145.543L306.72 139.371H313.817L317.417 145.543L313.817 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 159.532H293.246L289.646 153.257L293.246 147.086H300.446L303.943 153.257L300.446 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 167.246H279.874L276.274 161.075L279.874 154.8H286.971L290.571 161.075L286.971 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 182.777H279.874L276.274 176.503L279.874 170.332H286.971L290.571 176.503L286.971 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 198.206H279.874L276.274 192.034L279.874 185.863H286.971L290.571 192.034L286.971 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 213.737H279.874L276.274 207.565L279.874 201.394H286.971L290.571 207.565L286.971 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 229.268H279.874L276.274 223.097L279.874 216.823H286.971L290.571 223.097L286.971 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 244.8H279.874L276.274 238.525L279.874 232.354H286.971L290.571 238.525L286.971 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 260.229H279.874L276.274 254.057L279.874 247.886H286.971L290.571 254.057L286.971 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 275.76H279.874L276.274 269.589L279.874 263.314H286.971L290.571 269.589L286.971 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 291.291H279.874L276.274 285.017L279.874 278.846H286.971L290.571 285.017L286.971 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 306.72H279.874L276.274 300.549L279.874 294.377H286.971L290.571 300.549L286.971 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 322.251H279.874L276.274 316.08L279.874 309.908H286.971L290.571 316.08L286.971 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 337.783H279.874L276.274 331.611L279.874 325.337H286.971L290.571 331.611L286.971 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 353.212H279.874L276.274 347.04L279.874 340.869H286.971L290.571 347.04L286.971 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 368.743H279.874L276.274 362.571L279.874 356.4H286.971L290.571 362.571L286.971 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.84 382.217H281.006L278.537 378.103L281.006 373.886H285.84L288.206 378.103L285.84 382.217Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 430.766H279.874L276.274 424.595L279.874 418.32H286.971L290.571 424.595L286.971 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.663 445.68H280.183L276.891 440.023L280.183 434.469H286.663L289.851 440.023L286.663 445.68Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 461.726H279.874L276.274 455.554L279.874 449.383H286.971L290.571 455.554L286.971 461.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.406 725.04H360.514L357.12 719.074L360.514 713.108H367.406L370.8 719.074L367.406 725.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 733.063H373.783L370.183 726.892L373.783 720.617H380.983L384.583 726.892L380.983 733.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 740.777H387.257L383.657 734.606L387.257 728.435H394.354L397.954 734.606L394.354 740.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.257 744.068H403.2L402.171 742.32L403.2 740.571H405.257L406.286 742.32L405.257 744.068Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.41 562.32H1152.62L1149.12 556.354L1152.62 550.389H1159.41L1162.9 556.354L1159.41 562.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.48 529.612H1153.54L1151.07 525.292L1153.54 521.075H1158.48L1160.95 525.292L1158.48 529.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1156.73 464.708H1155.19L1154.47 463.371L1155.19 462.034H1156.73L1157.55 463.371L1156.73 464.708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1157.25 450H1154.78L1153.44 447.84L1154.78 445.577H1157.25L1158.58 447.84L1157.25 450Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1158.69 436.937H1153.34L1150.66 432.308L1153.34 427.68H1158.69L1161.36 432.308L1158.69 436.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.41 422.743H1152.62L1149.22 416.777L1152.62 410.914H1159.41L1162.8 416.777L1159.41 422.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 407.52H1152.41L1148.81 401.349L1152.41 395.075H1159.61L1163.21 401.349L1159.61 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 391.989H1152.41L1148.81 385.817L1152.41 379.646H1159.61L1163.21 385.817L1159.61 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 376.56H1152.41L1148.81 370.286L1152.41 364.114H1159.61L1163.21 370.286L1159.61 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 361.029H1152.41L1148.81 354.857L1152.41 348.583H1159.61L1163.21 354.857L1159.61 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 345.497H1152.41L1148.81 339.326L1152.41 333.154H1159.61L1163.21 339.326L1159.61 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 329.965H1152.41L1148.81 323.794L1152.41 317.623H1159.61L1163.21 323.794L1159.61 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 314.537H1152.41L1148.81 308.263L1152.41 302.092H1159.61L1163.21 308.263L1159.61 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 299.006H1152.41L1148.81 292.834L1152.41 286.56H1159.61L1163.21 292.834L1159.61 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 283.474H1152.41L1148.81 277.303L1152.41 271.131H1159.61L1163.21 277.303L1159.61 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 268.046H1152.41L1148.81 261.772L1152.41 255.6H1159.61L1163.21 261.772L1159.61 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 252.514H1152.41L1148.81 246.343L1152.41 240.068H1159.61L1163.21 246.343L1159.61 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 236.983H1152.41L1148.81 230.811L1152.41 224.64H1159.61L1163.21 230.811L1159.61 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 221.451H1152.41L1148.81 215.28L1152.41 209.108H1159.61L1163.21 215.28L1159.61 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 206.023H1152.41L1148.81 199.749L1152.41 193.578H1159.61L1163.21 199.749L1159.61 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 190.492H1152.41L1148.81 184.32L1152.41 178.046H1159.61L1163.21 184.32L1159.61 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 174.96H1152.41L1148.81 168.789L1152.41 162.617H1159.61L1163.21 168.789L1159.61 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 159.532H1152.41L1148.81 153.257L1152.41 147.086H1159.61L1163.21 153.257L1159.61 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 151.714H1139.04L1135.44 145.543L1139.04 139.371H1146.14L1149.74 145.543L1146.14 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 144H1125.57L1121.97 137.828L1125.57 131.554H1132.77L1136.37 137.828L1132.77 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 136.286H1112.19L1108.59 130.011L1112.19 123.84H1119.29L1122.89 130.011L1119.29 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 128.468H1098.72L1095.12 122.297L1098.72 116.125H1105.92L1109.42 122.297L1105.92 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 120.754H1085.35L1081.75 114.583L1085.35 108.309H1092.45L1096.05 114.583L1092.45 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 113.04H1071.87L1068.27 106.766L1071.87 100.594H1079.07L1082.57 106.766L1079.07 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 105.223H1058.5L1054.9 99.0513L1058.5 92.8799H1065.6L1069.2 99.0513L1065.6 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.23 97.5087H1045.03L1041.43 91.3373L1045.03 85.063H1052.23L1055.73 91.3373L1052.23 97.5087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1038.75 89.6915H1031.55L1028.06 83.5201L1031.55 77.3486H1038.75L1042.35 83.5201L1038.75 89.6915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1023.63 78.9942H1019.83L1017.98 75.8056L1019.83 72.5142H1023.63L1025.49 75.8056L1023.63 78.9942Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M527.966 11.0055H522.206L519.326 6.06832L522.206 1.02832H527.966L530.846 6.06832L527.966 11.0055Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.492 18.7205H508.834L505.954 13.7833L508.834 8.84619H514.492L517.269 13.7833L514.492 18.7205Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M500.914 26.3313H495.463L492.686 21.4971L495.463 16.7656H500.914L503.692 21.4971L500.914 26.3313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.366 35.4858H481.166L477.566 29.3143L481.166 23.04H488.366L491.966 29.3143L488.366 35.4858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.892 43.1998H467.794L464.194 37.0284L467.794 30.8569H474.892L478.492 37.0284L474.892 43.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.52 51.017H454.32L450.72 44.7427L454.32 38.5713H461.52L465.12 44.7427L461.52 51.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 58.7314H440.949L437.349 52.5599L440.949 46.2856H448.046L451.646 52.5599L448.046 58.7314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.72 63.1542H429.429L427.783 60.2742L429.429 57.4971H432.72L434.366 60.2742L432.72 63.1542Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.994 73.8514H414.309L410.914 67.9885L414.309 62.2285H420.994L424.389 67.9885L420.994 73.8514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.406 105.017H360.514L357.12 99.0512L360.514 93.0854H367.406L370.8 99.0512L367.406 105.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.137 113.04H346.937L343.337 106.766L346.937 100.594H354.137L357.737 106.766L354.137 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 120.754H333.566L329.966 114.583L333.566 108.309H340.663L344.263 114.583L340.663 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M327.292 128.468H320.092L316.594 122.297L320.092 116.125H327.292L330.789 122.297L327.292 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.509 135.566H307.029L303.84 130.011L307.029 124.457H313.509L316.697 130.011L313.509 135.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 144H293.246L289.646 137.828L293.246 131.554H300.446L303.943 137.828L300.446 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.971 151.714H279.874L276.274 145.543L279.874 139.371H286.971L290.571 145.543L286.971 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 159.532H266.4L262.8 153.257L266.4 147.086H273.6L277.097 153.257L273.6 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 174.96H266.4L262.8 168.789L266.4 162.617H273.6L277.097 168.789L273.6 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 190.492H266.4L262.8 184.32L266.4 178.046H273.6L277.097 184.32L273.6 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 206.023H266.4L262.8 199.749L266.4 193.578H273.6L277.097 199.749L273.6 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 221.451H266.4L262.8 215.28L266.4 209.108H273.6L277.097 215.28L273.6 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 236.983H266.4L262.8 230.811L266.4 224.64H273.6L277.097 230.811L273.6 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 252.514H266.4L262.8 246.343L266.4 240.068H273.6L277.097 246.343L273.6 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 268.046H266.4L262.8 261.772L266.4 255.6H273.6L277.097 261.772L273.6 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 283.474H266.4L262.8 277.303L266.4 271.131H273.6L277.097 277.303L273.6 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 299.006H266.4L262.8 292.834L266.4 286.56H273.6L277.097 292.834L273.6 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 314.537H266.4L262.8 308.263L266.4 302.092H273.6L277.097 308.263L273.6 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 329.965H266.4L262.8 323.794L266.4 317.623H273.6L277.097 323.794L273.6 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 345.497H266.4L262.8 339.326L266.4 333.154H273.6L277.097 339.326L273.6 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 361.029H266.4L262.8 354.857L266.4 348.583H273.6L277.097 354.857L273.6 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.394 376.252H266.503L263.109 370.286L266.503 364.32H273.394L276.892 370.286L273.394 376.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.926 418.423H269.074L268.149 416.778L269.074 415.235H270.926L271.851 416.778L270.926 418.423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.497 438.48H266.4L262.903 432.308L266.4 426.137H273.497L277.097 432.308L273.497 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.497 454.011H266.4L262.8 447.84L266.4 441.668H273.497L277.097 447.84L273.497 454.011Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.2 740.264H360.72L357.429 734.606L360.72 728.949H367.2L370.389 734.606L367.2 740.264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 748.595H373.783L370.183 742.32L373.783 736.149H380.983L384.583 742.32L380.983 748.595Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 756.309H387.257L383.657 750.138L387.257 743.863H394.354L397.954 750.138L394.354 756.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.78 678.343H1166.09L1162.8 672.583L1166.09 666.926H1172.78L1176.07 672.583L1172.78 678.343Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 663.222H1165.89L1162.39 657.051L1165.89 650.982H1172.98L1176.48 657.051L1172.98 663.222Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.13 644.502H1167.74L1166.09 641.622L1167.74 638.64H1171.13L1172.78 641.622L1171.13 644.502Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.37 569.212H1166.5L1163.52 564.069L1166.5 559.029H1172.37L1175.35 564.069L1172.37 569.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 539.28H1165.89L1162.29 533.109L1165.89 526.834H1172.98L1176.58 533.109L1172.98 539.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 523.749H1165.89L1162.29 517.577L1165.89 511.406H1172.98L1176.58 517.577L1172.98 523.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.31 503.486H1168.56L1167.74 502.046L1168.56 500.606H1170.31L1171.13 502.046L1170.31 503.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 415.234H1165.89L1162.29 409.063L1165.89 402.892H1172.98L1176.58 409.063L1172.98 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 399.806H1165.89L1162.29 393.532L1165.89 387.36H1172.98L1176.58 393.532L1172.98 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 384.274H1165.89L1162.29 378.103L1165.89 371.829H1172.98L1176.58 378.103L1172.98 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 368.743H1165.89L1162.29 362.571L1165.89 356.4H1172.98L1176.58 362.571L1172.98 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 353.212H1165.89L1162.29 347.04L1165.89 340.869H1172.98L1176.58 347.04L1172.98 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 337.783H1165.89L1162.29 331.611L1165.89 325.337H1172.98L1176.58 331.611L1172.98 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 322.251H1165.89L1162.29 316.08L1165.89 309.908H1172.98L1176.58 316.08L1172.98 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 306.72H1165.89L1162.29 300.549L1165.89 294.377H1172.98L1176.58 300.549L1172.98 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 291.291H1165.89L1162.29 285.017L1165.89 278.846H1172.98L1176.58 285.017L1172.98 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 275.76H1165.89L1162.29 269.589L1165.89 263.314H1172.98L1176.58 269.589L1172.98 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 260.229H1165.89L1162.29 254.057L1165.89 247.886H1172.98L1176.58 254.057L1172.98 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 244.8H1165.89L1162.29 238.525L1165.89 232.354H1172.98L1176.58 238.525L1172.98 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 229.268H1165.89L1162.29 223.097L1165.89 216.823H1172.98L1176.58 223.097L1172.98 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 213.737H1165.89L1162.29 207.565L1165.89 201.394H1172.98L1176.58 207.565L1172.98 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 198.206H1165.89L1162.29 192.034L1165.89 185.863H1172.98L1176.58 192.034L1172.98 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 182.777H1165.89L1162.29 176.503L1165.89 170.332H1172.98L1176.58 176.503L1172.98 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 167.246H1165.89L1162.29 161.075L1165.89 154.8H1172.98L1176.58 161.075L1172.98 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 151.714H1165.89L1162.29 145.543L1165.89 139.371H1172.98L1176.58 145.543L1172.98 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 144H1152.41L1148.81 137.828L1152.41 131.554H1159.61L1163.21 137.828L1159.61 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 136.286H1139.04L1135.44 130.011L1139.04 123.84H1146.14L1149.74 130.011L1146.14 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 128.468H1125.57L1121.97 122.297L1125.57 116.125H1132.77L1136.37 122.297L1132.77 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 120.754H1112.19L1108.59 114.583L1112.19 108.309H1119.29L1122.89 114.583L1119.29 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.92 113.04H1098.72L1095.12 106.766L1098.72 100.594H1105.92L1109.42 106.766L1105.92 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 105.223H1085.35L1081.75 99.0513L1085.35 92.8799H1092.45L1096.05 99.0513L1092.45 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 97.5087H1071.87L1068.27 91.3373L1071.87 85.063H1079.07L1082.57 91.3373L1079.07 97.5087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 89.6915H1058.5L1054.9 83.5201L1058.5 77.3486H1065.6L1069.2 83.5201L1065.6 89.6915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1052.13 81.8743H1045.03L1041.53 75.8057L1045.03 69.6343H1052.13L1055.73 75.8057L1052.13 81.8743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.18 69.7374H1034.13L1033.2 67.9888L1034.13 66.2402H1036.18L1037.21 67.9888L1036.18 69.7374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M473.966 26.0228H468.823L466.251 21.4971L468.823 17.0742H473.966L476.537 21.4971L473.966 26.0228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.314 35.1769H454.526L451.131 29.314L454.526 23.4512H461.314L464.709 29.314L461.314 35.1769Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.046 43.1998H440.949L437.349 37.0284L440.949 30.8569H448.046L451.646 37.0284L448.046 43.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M432.206 46.8H429.943L428.811 44.7429L429.943 42.7886H432.206L433.337 44.7429L432.206 46.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.171 56.9824H415.131L412.56 52.5596L415.131 48.1367H420.171L422.743 52.5596L420.171 56.9824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.16 80.5369H374.606L371.829 75.8055L374.606 70.9712H380.16L382.834 75.8055L380.16 80.5369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.097 88.8685H360.823L357.737 83.52L360.823 78.1714H367.097L370.183 83.52L367.097 88.8685Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.697 95.143H348.274L346.114 91.3373L348.274 87.4287H352.697L354.96 91.3373L352.697 95.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.56 105.017H333.669L330.171 99.0512L333.669 93.0854H340.56L344.057 99.0512L340.56 105.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.714 120.549H306.823L303.326 114.583L306.823 108.617H313.714L317.109 114.583L313.714 120.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.503 131.863H282.343L281.314 130.012L282.343 128.263H284.503L285.531 130.012L284.503 131.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 144H266.4L262.8 137.828L266.4 131.554H273.6L277.097 137.828L273.6 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 151.714H252.926L249.428 145.543L252.926 139.371H260.126L263.726 145.543L260.126 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 167.246H252.926L249.428 161.075L252.926 154.8H260.126L263.726 161.075L260.126 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 182.777H252.926L249.428 176.503L252.926 170.332H260.126L263.726 176.503L260.126 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 198.206H252.926L249.428 192.034L252.926 185.863H260.126L263.726 192.034L260.126 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 213.737H252.926L249.428 207.565L252.926 201.394H260.126L263.726 207.565L260.126 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 229.268H252.926L249.428 223.097L252.926 216.823H260.126L263.726 223.097L260.126 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 244.8H252.926L249.428 238.525L252.926 232.354H260.126L263.726 238.525L260.126 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 260.229H252.926L249.428 254.057L252.926 247.886H260.126L263.726 254.057L260.126 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 275.76H252.926L249.428 269.589L252.926 263.314H260.126L263.726 269.589L260.126 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 291.291H252.926L249.428 285.017L252.926 278.846H260.126L263.726 285.017L260.126 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 306.72H252.926L249.428 300.549L252.926 294.377H260.126L263.726 300.549L260.126 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 322.251H252.926L249.428 316.08L252.926 309.908H260.126L263.726 316.08L260.126 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 337.783H252.926L249.428 331.611L252.926 325.337H260.126L263.726 331.611L260.126 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 353.212H252.926L249.428 347.04L252.926 340.869H260.126L263.726 347.04L260.126 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 368.743H252.926L249.428 362.571L252.926 356.4H260.126L263.726 362.571L260.126 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.2 382.732H253.851L251.177 378.103L253.851 373.372H259.2L261.874 378.103L259.2 382.732Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.451 426.137H255.703L254.777 424.594L255.703 423.051H257.451L258.274 424.594L257.451 426.137Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 446.194H253.028L249.428 440.023L253.028 433.954H260.126L263.623 440.023L260.126 446.194Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 756.309H360.411L356.811 750.138L360.411 743.863H367.509L371.109 750.138L367.509 756.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 764.023H373.783L370.183 757.851L373.783 751.68H380.983L384.583 757.851L380.983 764.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 771.737H387.257L383.657 765.566L387.257 759.395H394.354L397.954 765.566L394.354 771.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.23 691.2H1167.63L1165.78 688.114L1167.63 684.925H1171.23L1173.09 688.114L1171.23 691.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 686.572H1179.26L1175.66 680.297L1179.26 674.126H1186.46L1190.06 680.297L1186.46 686.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 671.04H1179.26L1175.66 664.868L1179.26 658.594H1186.46L1190.06 664.868L1186.46 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 655.508H1179.26L1175.66 649.337L1179.26 643.166H1186.46L1190.06 649.337L1186.46 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.43 638.331H1180.29L1177.71 633.806L1180.29 629.383H1185.43L1188 633.806L1185.43 638.331Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.25 546.686H1179.46L1176.07 540.823L1179.46 534.96H1186.25L1189.65 540.823L1186.25 546.686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 531.566H1179.26L1175.66 525.292L1179.26 519.12H1186.46L1190.06 525.292L1186.46 531.566Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 516.035H1179.26L1175.66 509.863L1179.26 503.589H1186.46L1190.06 509.863L1186.46 516.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1185.84 499.474H1179.87L1176.99 494.331L1179.87 489.188H1185.84L1188.72 494.331L1185.84 499.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.15 406.903H1179.57L1176.38 401.349L1179.57 395.692H1186.15L1189.34 401.349L1186.15 406.903Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 391.989H1179.26L1175.66 385.817L1179.26 379.646H1186.46L1190.06 385.817L1186.46 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 376.56H1179.26L1175.66 370.286L1179.26 364.114H1186.46L1190.06 370.286L1186.46 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 361.029H1179.26L1175.66 354.857L1179.26 348.583H1186.46L1190.06 354.857L1186.46 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 345.497H1179.26L1175.66 339.326L1179.26 333.154H1186.46L1190.06 339.326L1186.46 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1184.81 327.189H1180.9L1178.95 323.794L1180.9 320.503H1184.81L1186.77 323.794L1184.81 327.189Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 314.537H1179.26L1175.66 308.263L1179.26 302.092H1186.46L1190.06 308.263L1186.46 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 299.006H1179.26L1175.66 292.834L1179.26 286.56H1186.46L1190.06 292.834L1186.46 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 283.474H1179.26L1175.66 277.303L1179.26 271.131H1186.46L1190.06 277.303L1186.46 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 268.046H1179.26L1175.66 261.772L1179.26 255.6H1186.46L1190.06 261.772L1186.46 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 252.514H1179.26L1175.66 246.343L1179.26 240.068H1186.46L1190.06 246.343L1186.46 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 236.983H1179.26L1175.66 230.811L1179.26 224.64H1186.46L1190.06 230.811L1186.46 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 221.451H1179.26L1175.66 215.28L1179.26 209.108H1186.46L1190.06 215.28L1186.46 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 206.023H1179.26L1175.66 199.749L1179.26 193.578H1186.46L1190.06 199.749L1186.46 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 190.492H1179.26L1175.66 184.32L1179.26 178.046H1186.46L1190.06 184.32L1186.46 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 174.96H1179.26L1175.66 168.789L1179.26 162.617H1186.46L1190.06 168.789L1186.46 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 159.532H1179.26L1175.66 153.257L1179.26 147.086H1186.46L1190.06 153.257L1186.46 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 144H1179.26L1175.66 137.828L1179.26 131.554H1186.46L1190.06 137.828L1186.46 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 136.286H1165.89L1162.29 130.011L1165.89 123.84H1172.98L1176.58 130.011L1172.98 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 128.468H1152.41L1148.81 122.297L1152.41 116.125H1159.61L1163.21 122.297L1159.61 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 120.754H1139.04L1135.44 114.583L1139.04 108.309H1146.14L1149.74 114.583L1146.14 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1132.77 113.04H1125.57L1121.97 106.766L1125.57 100.594H1132.77L1136.37 106.766L1132.77 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1119.29 105.223H1112.19L1108.59 99.0513L1112.19 92.8799H1119.29L1122.89 99.0513L1119.29 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1105.82 97.405H1098.82L1095.33 91.3365L1098.82 85.165H1105.82L1109.31 91.3365L1105.82 97.405Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 89.6912H1085.35L1081.85 83.5197L1085.35 77.4512H1092.45L1095.94 83.5197L1092.45 89.6912Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1079.07 81.9771H1071.87L1068.27 75.8057L1071.87 69.6343H1079.07L1082.57 75.8057L1079.07 81.9771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065.6 74.2631H1058.5L1054.9 67.9888L1058.5 61.8174H1065.6L1069.2 67.9888L1065.6 74.2631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1024.35 49.2687H1019.11L1016.54 44.743L1019.11 40.2173H1024.35L1027.03 44.743L1024.35 49.2687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1010.06 39.9084H1006.66L1004.91 37.0284L1006.66 34.1484H1010.06L1011.7 37.0284L1010.06 39.9084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.017 25.8169H442.08L439.509 21.4969L442.08 17.2798H447.017L449.486 21.4969L447.017 25.8169Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.029 32.7083H429.12L427.166 29.314L429.12 25.8169H433.029L435.086 29.314L433.029 32.7083Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.789 42.48H414.514L411.326 37.0286L414.514 31.5771H420.789L423.977 37.0286L420.789 42.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.389 48.4454H402.069L400.011 44.7426L402.069 41.1426H406.389L408.446 44.7426L406.389 48.4454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.252 58.4223H387.36L383.966 52.5595L387.36 46.5938H394.252L397.646 52.5595L394.252 58.4223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 66.4459H373.783L370.183 60.2745L373.783 54.103H380.983L384.583 60.2745L380.983 66.4459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 74.2631H360.411L356.811 67.9888L360.411 61.8174H367.509L371.109 67.9888L367.509 74.2631Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.08 78.3772H348.994L347.554 75.8058L348.994 73.2344H352.08L353.52 75.8058L352.08 78.3772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.811 86.5028H335.314L333.669 83.52L335.314 80.5371H338.811L340.56 83.52L338.811 86.5028Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.492 109.749H295.097L293.452 106.766L295.097 103.886H298.492L300.24 106.766L298.492 109.749Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.532 118.286H281.212L279.052 114.583L281.212 110.777H285.532L287.692 114.583L285.532 118.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.16 126.103H267.737L265.577 122.297L267.737 118.491H272.16L274.423 122.297L272.16 126.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.554 131.76H255.497L254.571 130.012L255.497 128.263H257.554L258.583 130.012L257.554 131.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 144H239.554L235.954 137.828L239.554 131.554H246.754L250.251 137.828L246.754 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 159.532H239.554L235.954 153.257L239.554 147.086H246.754L250.251 153.257L246.754 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 174.96H239.554L235.954 168.789L239.554 162.617H246.754L250.251 168.789L246.754 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 190.492H239.554L235.954 184.32L239.554 178.046H246.754L250.251 184.32L246.754 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 206.023H239.554L235.954 199.749L239.554 193.578H246.754L250.251 199.749L246.754 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 221.451H239.554L235.954 215.28L239.554 209.108H246.754L250.251 215.28L246.754 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 236.983H239.554L235.954 230.811L239.554 224.64H246.754L250.251 230.811L246.754 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 252.514H239.554L235.954 246.343L239.554 240.068H246.754L250.251 246.343L246.754 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 268.046H239.554L235.954 261.772L239.554 255.6H246.754L250.251 261.772L246.754 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 283.474H239.554L235.954 277.303L239.554 271.131H246.754L250.251 277.303L246.754 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 299.006H239.554L235.954 292.834L239.554 286.56H246.754L250.251 292.834L246.754 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 314.537H239.554L235.954 308.263L239.554 302.092H246.754L250.251 308.263L246.754 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 329.965H239.554L235.954 323.794L239.554 317.623H246.754L250.251 323.794L246.754 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 345.497H239.554L235.954 339.326L239.554 333.154H246.754L250.251 339.326L246.754 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 361.029H239.554L235.954 354.857L239.554 348.583H246.754L250.251 354.857L246.754 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 376.56H239.554L235.954 370.286L239.554 364.114H246.754L250.251 370.286L246.754 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 391.989H239.554L235.954 385.817L239.554 379.646H246.754L250.251 385.817L246.754 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 407.52H239.554L235.954 401.349L239.554 395.075H246.754L250.251 401.349L246.754 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 423.052H239.554L235.954 416.777L239.554 410.606H246.754L250.251 416.777L246.754 423.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 438.48H239.554L235.954 432.308L239.554 426.137H246.754L250.251 432.308L246.754 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M243.874 449.177H242.331L241.611 447.84L242.331 446.503H243.874L244.697 447.84L243.874 449.177Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 771.737H360.411L356.811 765.566L360.411 759.395H367.509L371.109 765.566L367.509 771.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 779.554H373.783L370.183 773.383L373.783 767.108H380.983L384.583 773.383L380.983 779.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 787.165H387.257L383.76 781.097L387.257 775.028H394.354L397.851 781.097L394.354 787.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1170.62 705.6H1168.25L1167.12 703.543L1168.25 701.588H1170.62L1171.75 703.543L1170.62 705.6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 702H1179.26L1175.66 695.829L1179.26 689.657H1186.46L1190.06 695.829L1186.46 702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 694.286H1192.73L1189.13 688.114L1192.73 681.943H1199.83L1203.43 688.114L1199.83 694.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 678.754H1192.73L1189.13 672.583L1192.73 666.412H1199.83L1203.43 672.583L1199.83 678.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 663.326H1192.73L1189.13 657.051L1192.73 650.88H1199.83L1203.43 657.051L1199.83 663.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 647.794H1192.73L1189.13 641.623L1192.73 635.349H1199.83L1203.43 641.623L1199.83 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.73 632.057H1192.83L1189.44 626.091L1192.83 620.125H1199.73L1203.12 626.091L1199.73 632.057Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.95 611.691H1195.61L1194.99 610.56L1195.61 609.531H1196.95L1197.57 610.56L1196.95 611.691Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.49 536.914H1194.07L1191.91 533.108L1194.07 529.303H1198.49L1200.65 533.108L1198.49 536.914Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.46 519.532H1195.1L1193.97 517.577L1195.1 515.623H1197.46L1198.59 517.577L1197.46 519.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.49 505.851H1194.07L1191.91 502.045L1194.07 498.24H1198.49L1200.65 502.045L1198.49 505.851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.08 412.149H1194.48L1192.73 409.063L1194.48 405.978H1198.08L1199.83 409.063L1198.08 412.149Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.36 395.485H1195.2L1194.07 393.531L1195.2 391.68H1197.36L1198.49 393.531L1197.36 395.485Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.52 383.657H1193.04L1189.75 378.103L1193.04 372.446H1199.52L1202.81 378.103L1199.52 383.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.73 368.537H1192.83L1189.34 362.572L1192.83 356.606H1199.73L1203.22 362.572L1199.73 368.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1196.85 348.069H1195.71L1195.1 347.04L1195.71 346.012H1196.85L1197.46 347.04L1196.85 348.069Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1197.77 334.08H1194.79L1193.35 331.611L1194.79 329.04H1197.77L1199.21 331.611L1197.77 334.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.42 321.531H1193.14L1190.06 316.08L1193.14 310.628H1199.42L1202.5 316.08L1199.42 321.531Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 306.72H1192.73L1189.13 300.549L1192.73 294.377H1199.83L1203.43 300.549L1199.83 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 291.291H1192.73L1189.13 285.017L1192.73 278.846H1199.83L1203.43 285.017L1199.83 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 275.76H1192.73L1189.13 269.589L1192.73 263.314H1199.83L1203.43 269.589L1199.83 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 260.229H1192.73L1189.13 254.057L1192.73 247.886H1199.83L1203.43 254.057L1199.83 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 244.8H1192.73L1189.13 238.525L1192.73 232.354H1199.83L1203.43 238.525L1199.83 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 229.268H1192.73L1189.13 223.097L1192.73 216.823H1199.83L1203.43 223.097L1199.83 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 213.737H1192.73L1189.13 207.565L1192.73 201.394H1199.83L1203.43 207.565L1199.83 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 198.206H1192.73L1189.13 192.034L1192.73 185.863H1199.83L1203.43 192.034L1199.83 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 182.777H1192.73L1189.13 176.503L1192.73 170.332H1199.83L1203.43 176.503L1199.83 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 167.246H1192.73L1189.13 161.075L1192.73 154.8H1199.83L1203.43 161.075L1199.83 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 151.714H1192.73L1189.13 145.543L1192.73 139.371H1199.83L1203.43 145.543L1199.83 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 136.286H1192.73L1189.13 130.011L1192.73 123.84H1199.83L1203.43 130.011L1199.83 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 128.468H1179.26L1175.66 122.297L1179.26 116.125H1186.46L1190.06 122.297L1186.46 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1172.98 120.754H1165.89L1162.29 114.583L1165.89 108.309H1172.98L1176.58 114.583L1172.98 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1159.61 113.04H1152.41L1148.81 106.766L1152.41 100.594H1159.61L1163.21 106.766L1159.61 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1146.14 105.223H1139.04L1135.44 99.0513L1139.04 92.8799H1146.14L1149.63 99.0513L1146.14 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1130.71 94.0115H1127.52L1125.98 91.3372L1127.52 88.5601H1130.71L1132.35 91.3372L1130.71 94.0115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1103.97 78.5824H1100.67L1099.03 75.8053L1100.67 72.9253H1103.97L1105.61 75.8053L1103.97 78.5824Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1092.45 74.1604H1085.35L1081.75 67.989L1085.35 61.9204H1092.45L1095.94 67.989L1092.45 74.1604Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1036.9 39.9084H1033.51L1031.86 37.0284L1033.51 34.1484H1036.9L1038.55 37.0284L1036.9 39.9084Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.543 18.1034H428.606L426.034 13.7834L428.606 9.46338H433.543L436.114 13.7834L433.543 18.1034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.2 27.7714H414.103L410.503 21.4971L414.103 15.3257H421.2L424.8 21.4971L421.2 27.7714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.829 35.4858H400.629L397.029 29.3143L400.629 23.04H407.829L411.429 29.3143L407.829 35.4858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 43.1998H387.257L383.657 37.0284L387.257 30.8569H394.354L397.954 37.0284L394.354 43.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 51.017H373.783L370.183 44.7427L373.783 38.5713H380.983L384.583 44.7427L380.983 51.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 58.7314H360.411L356.811 52.5599L360.411 46.2856H367.509L371.109 52.5599L367.509 58.7314Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.623 65.6224H347.451L344.366 60.2739L347.451 54.9253H353.623L356.709 60.2739L353.623 65.6224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.943 73.0284H334.286L331.406 67.9884L334.286 63.0513H339.943L342.823 67.9884L339.943 73.0284Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.617 77.3489H322.766L321.84 75.806L322.766 74.2632H324.617L325.44 75.806L324.617 77.3489Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.446 97.5087H293.246L289.646 91.3373L293.246 85.063H300.446L303.943 91.3373L300.446 97.5087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.606 101.006H282.24L281.109 99.0513L282.24 96.9941H284.606L285.737 99.0513L284.606 101.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.6 113.04H266.4L262.8 106.766L266.4 100.594H273.6L277.097 106.766L273.6 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 120.754H252.926L249.428 114.583L252.926 108.309H260.126L263.726 114.583L260.126 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.24 127.543H240.069L236.983 122.297L240.069 116.949H246.24L249.223 122.297L246.24 127.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.971 135.669H226.491L223.2 130.012L226.491 124.354H232.971L236.263 130.012L232.971 135.669Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 151.714H226.08L222.583 145.543L226.08 139.371H233.28L236.88 145.543L233.28 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 167.246H226.08L222.583 161.075L226.08 154.8H233.28L236.88 161.075L233.28 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 182.777H226.08L222.583 176.503L226.08 170.332H233.28L236.88 176.503L233.28 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 198.206H226.08L222.583 192.034L226.08 185.863H233.28L236.88 192.034L233.28 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 213.737H226.08L222.583 207.565L226.08 201.394H233.28L236.88 207.565L233.28 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 229.268H226.08L222.583 223.097L226.08 216.823H233.28L236.88 223.097L233.28 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 244.8H226.08L222.583 238.525L226.08 232.354H233.28L236.88 238.525L233.28 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 260.229H226.08L222.583 254.057L226.08 247.886H233.28L236.88 254.057L233.28 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 275.76H226.08L222.583 269.589L226.08 263.314H233.28L236.88 269.589L233.28 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 291.291H226.08L222.583 285.017L226.08 278.846H233.28L236.88 285.017L233.28 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 306.72H226.08L222.583 300.549L226.08 294.377H233.28L236.88 300.549L233.28 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 322.251H226.08L222.583 316.08L226.08 309.908H233.28L236.88 316.08L233.28 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 337.783H226.08L222.583 331.611L226.08 325.337H233.28L236.88 331.611L233.28 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 353.212H226.08L222.583 347.04L226.08 340.869H233.28L236.88 347.04L233.28 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 368.743H226.08L222.583 362.571L226.08 356.4H233.28L236.88 362.571L233.28 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 384.274H226.08L222.583 378.103L226.08 371.829H233.28L236.88 378.103L233.28 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 399.806H226.08L222.583 393.532L226.08 387.36H233.28L236.88 393.532L233.28 399.806Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 415.234H226.08L222.583 409.063L226.08 402.892H233.28L236.88 409.063L233.28 415.234Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 430.766H226.08L222.583 424.595L226.08 418.32H233.28L236.88 424.595L233.28 430.766Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.429 443.006H228.034L226.286 440.023L228.034 437.143H231.429L233.074 440.023L231.429 443.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.097 786.446H360.823L357.737 781.097L360.823 775.749H367.097L370.183 781.097L367.097 786.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 795.086H373.783L370.183 788.812L373.783 782.64H380.983L384.583 788.812L380.983 795.086Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.886 798.377H389.726L388.697 796.629L389.726 794.777H391.886L392.914 796.629L391.886 798.377Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.45 698.915H1207.95L1206.1 695.829L1207.95 692.743H1211.45L1213.3 695.829L1211.45 698.915Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 686.572H1206.1L1202.5 680.297L1206.1 674.126H1213.3L1216.9 680.297L1213.3 686.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 671.04H1206.1L1202.5 664.868L1206.1 658.594H1213.3L1216.9 664.868L1213.3 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 655.508H1206.1L1202.5 649.337L1206.1 643.166H1213.3L1216.9 649.337L1213.3 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 640.08H1206.1L1202.5 633.806L1206.1 627.635H1213.3L1216.9 633.806L1213.3 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 624.549H1206.1L1202.5 618.377L1206.1 612.103H1213.3L1216.9 618.377L1213.3 624.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.14 543.394H1208.26L1206.82 540.822L1208.26 538.251H1211.14L1212.58 540.822L1211.14 543.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.99 531.155H1206.41L1203.02 525.292L1206.41 519.532H1212.99L1216.39 525.292L1212.99 531.155Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 438.48H1206.1L1202.5 432.308L1206.1 426.137H1213.3L1216.9 432.308L1213.3 438.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.17 328.114H1207.23L1204.77 323.794L1207.23 319.577H1212.17L1214.64 323.794L1212.17 328.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 314.537H1206.1L1202.5 308.263L1206.1 302.092H1213.3L1216.9 308.263L1213.3 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 299.006H1206.1L1202.5 292.834L1206.1 286.56H1213.3L1216.9 292.834L1213.3 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 283.474H1206.1L1202.5 277.303L1206.1 271.131H1213.3L1216.9 277.303L1213.3 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 268.046H1206.1L1202.5 261.772L1206.1 255.6H1213.3L1216.9 261.772L1213.3 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 252.514H1206.1L1202.5 246.343L1206.1 240.068H1213.3L1216.9 246.343L1213.3 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 236.983H1206.1L1202.5 230.811L1206.1 224.64H1213.3L1216.9 230.811L1213.3 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 221.451H1206.1L1202.5 215.28L1206.1 209.108H1213.3L1216.9 215.28L1213.3 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 206.023H1206.1L1202.5 199.749L1206.1 193.578H1213.3L1216.9 199.749L1213.3 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 190.492H1206.1L1202.5 184.32L1206.1 178.046H1213.3L1216.9 184.32L1213.3 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 174.96H1206.1L1202.5 168.789L1206.1 162.617H1213.3L1216.9 168.789L1213.3 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 159.532H1206.1L1202.5 153.257L1206.1 147.086H1213.3L1216.9 153.257L1213.3 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 144H1206.1L1202.5 137.828L1206.1 131.554H1213.3L1216.9 137.828L1213.3 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 128.468H1206.1L1202.5 122.297L1206.1 116.125H1213.3L1216.9 122.297L1213.3 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.83 120.754H1192.73L1189.13 114.583L1192.73 108.309H1199.83L1203.43 114.583L1199.83 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1186.46 113.04H1179.26L1175.66 106.766L1179.26 100.594H1186.46L1190.06 106.766L1186.46 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1171.44 102.446H1167.43L1165.47 99.0515L1167.43 95.6572H1171.44L1173.39 99.0515L1171.44 102.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.006 18.6173H401.451L398.571 13.783L401.451 8.94873H407.006L409.886 13.783L407.006 18.6173Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.354 27.7714H387.257L383.657 21.4971L387.257 15.3257H394.354L397.954 21.4971L394.354 27.7714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 35.4858H373.783L370.183 29.3143L373.783 23.04H380.983L384.583 29.3143L380.983 35.4858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 43.1998H360.411L356.811 37.0284L360.411 30.8569H367.509L371.109 37.0284L367.509 43.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.697 48.4454H348.377L346.32 44.7426L348.377 41.1426H352.697L354.754 44.7426L352.697 48.4454Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.943 57.4968H334.286L331.406 52.5597L334.286 47.6226H339.943L342.823 52.5597L339.943 57.4968Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.246 69.7371H309.292L308.366 67.9885L309.292 66.3428H311.246L312.172 67.9885L311.246 69.7371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.829 80.9486H293.863L290.777 75.8058L293.863 70.5601H299.829L302.811 75.8058L299.829 80.9486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.914 86.0916H281.932L280.389 83.5202L281.932 80.9487H284.914L286.457 83.5202L284.914 86.0916Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.983 96.5831H266.914L263.931 91.3373L266.914 85.9888H272.983L276.069 91.3373L272.983 96.5831Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.126 105.223H253.028L249.428 99.0513L253.028 92.8799H260.126L263.623 99.0513L260.126 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.754 113.04H239.554L235.954 106.766L239.554 100.594H246.754L250.251 106.766L246.754 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.868 120.035H226.491L223.406 114.583L226.491 109.029H232.868L236.057 114.583L232.868 120.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.131 123.737H215.486L214.663 122.297L215.486 120.857H217.131L217.954 122.297L217.131 123.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 144H212.709L209.109 137.828L212.709 131.554H219.909L223.406 137.828L219.909 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 159.532H212.709L209.109 153.257L212.709 147.086H219.909L223.406 153.257L219.909 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 174.96H212.709L209.109 168.789L212.709 162.617H219.909L223.406 168.789L219.909 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 190.492H212.709L209.109 184.32L212.709 178.046H219.909L223.406 184.32L219.909 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 206.023H212.709L209.109 199.749L212.709 193.578H219.909L223.406 199.749L219.909 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 221.451H212.709L209.109 215.28L212.709 209.108H219.909L223.406 215.28L219.909 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 236.983H212.709L209.109 230.811L212.709 224.64H219.909L223.406 230.811L219.909 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 252.514H212.709L209.109 246.343L212.709 240.068H219.909L223.406 246.343L219.909 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 268.046H212.709L209.109 261.772L212.709 255.6H219.909L223.406 261.772L219.909 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 283.474H212.709L209.109 277.303L212.709 271.131H219.909L223.406 277.303L219.909 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 299.006H212.709L209.109 292.834L212.709 286.56H219.909L223.406 292.834L219.909 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 314.537H212.709L209.109 308.263L212.709 302.092H219.909L223.406 308.263L219.909 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 329.965H212.709L209.109 323.794L212.709 317.623H219.909L223.406 323.794L219.909 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 345.497H212.709L209.109 339.326L212.709 333.154H219.909L223.406 339.326L219.909 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 361.029H212.709L209.109 354.857L212.709 348.583H219.909L223.406 354.857L219.909 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 376.56H212.709L209.109 370.286L212.709 364.114H219.909L223.406 370.286L219.909 376.56Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 391.989H212.709L209.109 385.817L212.709 379.646H219.909L223.406 385.817L219.909 391.989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 407.52H212.709L209.109 401.349L212.709 395.075H219.909L223.406 401.349L219.909 407.52Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.806 422.948H212.709L209.211 416.777L212.709 410.708H219.806L223.303 416.777L219.806 422.948Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.749 434.88H214.869L213.326 432.308L214.869 429.84H217.749L219.189 432.308L217.749 434.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.863 800.023H361.954L360 796.629L361.954 793.234H365.863L367.817 796.629L365.863 800.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.983 810.514H373.783L370.183 804.343L373.783 798.171H380.983L384.583 804.343L380.983 810.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.85 692.846H1220.4L1217.62 688.114L1220.4 683.383H1225.85L1228.63 688.114L1225.85 692.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 678.754H1219.58L1215.98 672.583L1219.58 666.412H1226.67L1230.27 672.583L1226.67 678.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 663.326H1219.58L1215.98 657.051L1219.58 650.88H1226.67L1230.27 657.051L1226.67 663.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 647.794H1219.58L1215.98 641.623L1219.58 635.349H1226.67L1230.27 641.623L1226.67 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 632.263H1219.58L1215.98 626.092L1219.58 619.92H1226.67L1230.27 626.092L1226.67 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 616.834H1219.58L1215.98 610.56L1219.58 604.389H1226.67L1230.27 610.56L1226.67 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.75 599.657H1220.5L1217.83 595.132L1220.5 590.503H1225.75L1228.42 595.132L1225.75 599.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.51 473.452H1221.74L1220.4 471.086L1221.74 468.72H1224.51L1225.85 471.086L1224.51 473.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1224.21 457.509H1222.05L1220.91 455.554L1222.05 453.6H1224.21L1225.34 455.554L1224.21 457.509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.57 337.474H1219.78L1216.29 331.611L1219.78 325.646H1226.57L1229.97 331.611L1226.57 337.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1225.75 320.605H1220.5L1217.83 316.08L1220.5 311.451H1225.75L1228.42 316.08L1225.75 320.605Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 306.72H1219.58L1215.98 300.549L1219.58 294.377H1226.67L1230.27 300.549L1226.67 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 291.291H1219.58L1215.98 285.017L1219.58 278.846H1226.67L1230.27 285.017L1226.67 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 275.76H1219.58L1215.98 269.589L1219.58 263.314H1226.67L1230.27 269.589L1226.67 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 260.229H1219.58L1215.98 254.057L1219.58 247.886H1226.67L1230.27 254.057L1226.67 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 244.8H1219.58L1215.98 238.525L1219.58 232.354H1226.67L1230.27 238.525L1226.67 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 229.268H1219.58L1215.98 223.097L1219.58 216.823H1226.67L1230.27 223.097L1226.67 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 213.737H1219.58L1215.98 207.565L1219.58 201.394H1226.67L1230.27 207.565L1226.67 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 198.206H1219.58L1215.98 192.034L1219.58 185.863H1226.67L1230.27 192.034L1226.67 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 182.777H1219.58L1215.98 176.503L1219.58 170.332H1226.67L1230.27 176.503L1226.67 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 167.246H1219.58L1215.98 161.075L1219.58 154.8H1226.67L1230.27 161.075L1226.67 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 151.714H1219.58L1215.98 145.543L1219.58 139.371H1226.67L1230.27 145.543L1226.67 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 136.286H1219.58L1215.98 130.011L1219.58 123.84H1226.67L1230.27 130.011L1226.67 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 120.754H1219.58L1215.98 114.583L1219.58 108.309H1226.67L1230.27 114.583L1226.67 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1213.3 113.04H1206.1L1202.5 106.766L1206.1 100.594H1213.3L1216.9 106.766L1213.3 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1198.29 102.446H1194.27L1192.32 99.0515L1194.27 95.6572H1198.29L1200.24 99.0515L1198.29 102.446Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.543 17.4853H375.223L373.063 13.7824L375.223 10.0796H379.543L381.703 13.7824L379.543 17.4853Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.509 27.7714H360.411L356.811 21.4971L360.411 15.3257H367.509L371.109 21.4971L367.509 27.7714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.109 33.7371H347.966L345.291 29.3143L347.966 24.7886H353.109L355.68 29.3143L353.109 33.7371Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.663 43.1998H333.566L329.966 37.0284L333.566 30.8569H340.663L344.263 37.0284L340.663 43.1998Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.503 70.0461H282.24L281.109 67.989L282.24 66.0347H284.503L285.634 67.989L284.503 70.0461Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.394 81.6686H266.606L263.211 75.8057L266.606 69.9429H273.394L276.686 75.8057L273.394 81.6686Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.097 87.8402H254.057L251.589 83.5202L254.057 79.2002H259.097L261.566 83.5202L259.097 87.8402Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.651 97.5087H239.554L235.954 91.3373L239.554 85.063H246.651L250.251 91.3373L246.651 97.5087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.28 105.223H226.08L222.583 99.0513L226.08 92.8799H233.28L236.88 99.0513L233.28 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.131 108.308H215.383L214.457 106.766L215.383 105.223H217.131L218.057 106.766L217.131 108.308Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 136.286H199.234L195.737 130.011L199.234 123.84H206.434L210.034 130.011L206.434 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 151.714H199.234L195.737 145.543L199.234 139.371H206.434L210.034 145.543L206.434 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 167.246H199.234L195.737 161.075L199.234 154.8H206.434L210.034 161.075L206.434 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 182.777H199.234L195.737 176.503L199.234 170.332H206.434L210.034 176.503L206.434 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 198.206H199.234L195.737 192.034L199.234 185.863H206.434L210.034 192.034L206.434 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 213.737H199.234L195.737 207.565L199.234 201.394H206.434L210.034 207.565L206.434 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 229.268H199.234L195.737 223.097L199.234 216.823H206.434L210.034 223.097L206.434 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 244.8H199.234L195.737 238.525L199.234 232.354H206.434L210.034 238.525L206.434 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 260.229H199.234L195.737 254.057L199.234 247.886H206.434L210.034 254.057L206.434 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 275.76H199.234L195.737 269.589L199.234 263.314H206.434L210.034 269.589L206.434 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 291.291H199.234L195.737 285.017L199.234 278.846H206.434L210.034 285.017L206.434 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 306.72H199.234L195.737 300.549L199.234 294.377H206.434L210.034 300.549L206.434 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 322.251H199.234L195.737 316.08L199.234 309.908H206.434L210.034 316.08L206.434 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 337.783H199.234L195.737 331.611L199.234 325.337H206.434L210.034 331.611L206.434 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 353.212H199.234L195.737 347.04L199.234 340.869H206.434L210.034 347.04L206.434 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 368.743H199.234L195.737 362.571L199.234 356.4H206.434L210.034 362.571L206.434 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 384.274H199.234L195.737 378.103L199.234 371.829H206.434L210.034 378.103L206.434 384.274Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.229 399.394H199.543L196.149 393.531L199.543 387.771H206.229L209.52 393.531L206.229 399.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 686.572H1232.95L1229.35 680.297L1232.95 674.126H1240.15L1243.75 680.297L1240.15 686.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 671.04H1232.95L1229.35 664.868L1232.95 658.594H1240.15L1243.75 664.868L1240.15 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 655.508H1232.95L1229.35 649.337L1232.95 643.166H1240.15L1243.75 649.337L1240.15 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 640.08H1232.95L1229.35 633.806L1232.95 627.635H1240.15L1243.75 633.806L1240.15 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 624.549H1232.95L1229.35 618.377L1232.95 612.103H1240.15L1243.75 618.377L1240.15 624.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 609.017H1232.95L1229.35 602.846L1232.95 596.674H1240.15L1243.75 602.846L1240.15 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.58 589.166H1235.52L1234.39 587.314L1235.52 585.463H1237.58L1238.71 587.314L1237.58 589.166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.05 469.337H1233.05L1229.66 463.372L1233.05 457.303H1240.05L1243.44 463.372L1240.05 469.337Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.22 359.486H1233.87L1231.2 354.857L1233.87 350.126H1239.22L1241.9 354.857L1239.22 359.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1237.06 340.251H1236.03L1235.42 339.326L1236.03 338.4H1237.06L1237.68 339.326L1237.06 340.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1239.94 298.697H1233.15L1229.76 292.835L1233.15 286.972H1239.94L1243.34 292.835L1239.94 298.697Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 283.474H1232.95L1229.35 277.303L1232.95 271.131H1240.15L1243.75 277.303L1240.15 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 268.046H1232.95L1229.35 261.772L1232.95 255.6H1240.15L1243.75 261.772L1240.15 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 252.514H1232.95L1229.35 246.343L1232.95 240.068H1240.15L1243.75 246.343L1240.15 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.05 236.88H1233.05L1229.55 230.812L1233.05 224.743H1240.05L1243.54 230.812L1240.05 236.88Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1238.91 219.394H1234.18L1231.82 215.28L1234.18 211.269H1238.91L1241.28 215.28L1238.91 219.394Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 206.023H1232.95L1229.35 199.749L1232.95 193.578H1240.15L1243.75 199.749L1240.15 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 190.492H1232.95L1229.35 184.32L1232.95 178.046H1240.15L1243.75 184.32L1240.15 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 174.96H1232.95L1229.35 168.789L1232.95 162.617H1240.15L1243.75 168.789L1240.15 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 159.532H1232.95L1229.35 153.257L1232.95 147.086H1240.15L1243.75 153.257L1240.15 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 144H1232.95L1229.35 137.828L1232.95 131.554H1240.15L1243.75 137.828L1240.15 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 128.468H1232.95L1229.35 122.297L1232.95 116.125H1240.15L1243.75 122.297L1240.15 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1240.15 113.04H1232.95L1229.35 106.766L1232.95 100.594H1240.15L1243.75 106.766L1240.15 113.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1226.67 105.223H1219.58L1215.98 99.0513L1219.58 92.8799H1226.67L1230.27 99.0513L1226.67 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1211.45 94.3195H1207.95L1206.21 91.3367L1207.95 88.251H1211.45L1213.2 91.3367L1211.45 94.3195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.154 14.8115H349.92L349.303 13.783L349.92 12.7544H351.154L351.771 13.783L351.154 14.8115Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.68 22.6288H336.549L335.931 21.4973L336.549 20.4688H337.68L338.297 21.4973L337.68 22.6288Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.337 62.6401H268.663L267.223 60.2744L268.663 57.9087H271.337L272.674 60.2744L271.337 62.6401Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.451 69.5312H255.703L254.777 67.9883L255.703 66.5483H257.451L258.274 67.9883L257.451 69.5312Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.697 78.4799H241.611L239.966 75.8056L241.611 73.1313H244.697L246.24 75.8056L244.697 78.4799Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.177 89.4856H226.286L222.891 83.5199L226.286 77.5542H233.177L236.571 83.5199L233.177 89.4856Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.909 97.5087H212.709L209.109 91.3373L212.709 85.063H219.909L223.406 91.3373L219.909 97.5087Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.434 105.223H199.234L195.737 99.0513L199.234 92.8799H206.434L210.034 99.0513L206.434 105.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.52 125.897H187.406L185.246 122.297L187.406 118.697H191.52L193.577 122.297L191.52 125.897Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 144H185.863L182.263 137.828L185.863 131.554H193.063L196.56 137.828L193.063 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 159.532H185.863L182.263 153.257L185.863 147.086H193.063L196.56 153.257L193.063 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 174.96H185.863L182.263 168.789L185.863 162.617H193.063L196.56 168.789L193.063 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 190.492H185.863L182.263 184.32L185.863 178.046H193.063L196.56 184.32L193.063 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 206.023H185.863L182.263 199.749L185.863 193.578H193.063L196.56 199.749L193.063 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 221.451H185.863L182.263 215.28L185.863 209.108H193.063L196.56 215.28L193.063 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 236.983H185.863L182.263 230.811L185.863 224.64H193.063L196.56 230.811L193.063 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 252.514H185.863L182.263 246.343L185.863 240.068H193.063L196.56 246.343L193.063 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 268.046H185.863L182.263 261.772L185.863 255.6H193.063L196.56 261.772L193.063 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 283.474H185.863L182.263 277.303L185.863 271.131H193.063L196.56 277.303L193.063 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 299.006H185.863L182.263 292.834L185.863 286.56H193.063L196.56 292.834L193.063 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 314.537H185.863L182.263 308.263L185.863 302.092H193.063L196.56 308.263L193.063 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 329.965H185.863L182.263 323.794L185.863 317.623H193.063L196.56 323.794L193.063 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 345.497H185.863L182.263 339.326L185.863 333.154H193.063L196.56 339.326L193.063 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.063 361.029H185.863L182.263 354.857L185.863 348.583H193.063L196.56 354.857L193.063 361.029Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.96 376.354H185.966L182.469 370.285L185.966 364.217H192.96L196.457 370.285L192.96 376.354Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.549 391.165H186.377L183.291 385.817L186.377 380.468H192.549L195.531 385.817L192.549 391.165Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.034 405.874H186.789L184.114 401.349L186.789 396.72H192.034L194.709 401.349L192.034 405.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.36 706.012H1248.58L1247.25 703.543L1248.58 701.177H1251.36L1252.7 703.543L1251.36 706.012Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 694.286H1246.42L1242.82 688.114L1246.42 681.943H1253.52L1257.12 688.114L1253.52 694.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 678.754H1246.42L1242.82 672.583L1246.42 666.412H1253.52L1257.12 672.583L1253.52 678.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 663.326H1246.42L1242.82 657.051L1246.42 650.88H1253.52L1257.12 657.051L1253.52 663.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 647.794H1246.42L1242.82 641.623L1246.42 635.349H1253.52L1257.12 641.623L1253.52 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 632.263H1246.42L1242.82 626.092L1246.42 619.92H1253.52L1257.12 626.092L1253.52 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 616.834H1246.42L1242.82 610.56L1246.42 604.389H1253.52L1257.12 610.56L1253.52 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 601.303H1246.42L1242.82 595.132L1246.42 588.857H1253.52L1257.12 595.132L1253.52 601.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.67 582.48H1248.27L1246.63 579.6L1248.27 576.72H1251.67L1253.31 579.6L1251.67 582.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.98 536.503H1247.97L1246.01 533.108L1247.97 529.611H1251.98L1253.93 533.108L1251.98 536.503Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.42 523.44H1246.53L1243.13 517.577L1246.53 511.714H1253.42L1256.81 517.577L1253.42 523.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.31 352.8H1246.63L1243.34 347.04L1246.63 341.28H1253.31L1256.61 347.04L1253.31 352.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1250.64 286.251H1249.3L1248.58 285.017L1249.3 283.886H1250.64L1251.36 285.017L1250.64 286.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 275.657H1246.42L1242.93 269.588L1246.42 263.417H1253.52L1257.12 269.588L1253.52 275.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 260.229H1246.42L1242.82 254.057L1246.42 247.886H1253.52L1257.12 254.057L1253.52 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 244.698H1246.42L1242.93 238.526L1246.42 232.458H1253.52L1257.02 238.526L1253.52 244.698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1251.46 225.668H1248.48L1246.94 223.097L1248.48 220.422H1251.46L1253.01 223.097L1251.46 225.668Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.42 198H1246.53L1243.03 192.034L1246.53 186.068H1253.42L1256.91 192.034L1253.42 198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 182.777H1246.42L1242.82 176.503L1246.42 170.332H1253.52L1257.12 176.503L1253.52 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 167.246H1246.42L1242.82 161.075L1246.42 154.8H1253.52L1257.12 161.075L1253.52 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 151.714H1246.42L1242.82 145.543L1246.42 139.371H1253.52L1257.12 145.543L1253.52 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 136.286H1246.42L1242.82 130.011L1246.42 123.84H1253.52L1257.12 130.011L1253.52 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1253.52 120.754H1246.42L1242.82 114.583L1246.42 108.309H1253.52L1257.12 114.583L1253.52 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1212.89 81.2572H1206.51L1203.33 75.8057L1206.51 70.2515H1212.89L1216.08 75.8057L1212.89 81.2572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1199.11 72.9257H1193.45L1190.57 67.9886L1193.45 63.1543H1199.11L1201.99 67.9886L1199.11 72.9257Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.543 77.9658H214.971L213.737 75.8058L214.971 73.543H217.543L218.88 75.8058L217.543 77.9658Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.686 86.606H201.086L199.234 83.5203L201.086 80.4346H204.686L206.434 83.5203L204.686 86.606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 136.286H172.389L168.891 130.011L172.389 123.84H179.589L183.189 130.011L179.589 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 151.714H172.389L168.891 145.543L172.389 139.371H179.589L183.189 145.543L179.589 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 167.246H172.389L168.891 161.075L172.389 154.8H179.589L183.189 161.075L179.589 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 182.777H172.389L168.891 176.503L172.389 170.332H179.589L183.189 176.503L179.589 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 198.206H172.389L168.891 192.034L172.389 185.863H179.589L183.189 192.034L179.589 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 213.737H172.389L168.891 207.565L172.389 201.394H179.589L183.189 207.565L179.589 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 229.268H172.389L168.891 223.097L172.389 216.823H179.589L183.189 223.097L179.589 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 244.8H172.389L168.891 238.525L172.389 232.354H179.589L183.189 238.525L179.589 244.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 260.229H172.389L168.891 254.057L172.389 247.886H179.589L183.189 254.057L179.589 260.229Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 275.76H172.389L168.891 269.589L172.389 263.314H179.589L183.189 269.589L179.589 275.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 291.291H172.389L168.891 285.017L172.389 278.846H179.589L183.189 285.017L179.589 291.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 306.72H172.389L168.891 300.549L172.389 294.377H179.589L183.189 300.549L179.589 306.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 322.251H172.389L168.891 316.08L172.389 309.908H179.589L183.189 316.08L179.589 322.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 337.783H172.389L168.891 331.611L172.389 325.337H179.589L183.189 331.611L179.589 337.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 353.212H172.389L168.891 347.04L172.389 340.869H179.589L183.189 347.04L179.589 353.212Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.589 368.743H172.389L168.891 362.571L172.389 356.4H179.589L183.189 362.571L179.589 368.743Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.383 383.863H172.697L169.303 378.103L172.697 372.24H179.383L182.674 378.103L179.383 383.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.42 713.108H1262.37L1261.44 711.36L1262.37 709.611H1264.42L1265.35 711.36L1264.42 713.108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 702H1259.79L1256.19 695.829L1259.79 689.657H1266.99L1270.59 695.829L1266.99 702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 686.572H1259.79L1256.19 680.297L1259.79 674.126H1266.99L1270.59 680.297L1266.99 686.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 671.04H1259.79L1256.19 664.868L1259.79 658.594H1266.99L1270.59 664.868L1266.99 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 655.508H1259.79L1256.19 649.337L1259.79 643.166H1266.99L1270.59 649.337L1266.99 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 640.08H1259.79L1256.19 633.806L1259.79 627.635H1266.99L1270.59 633.806L1266.99 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 624.549H1259.79L1256.19 618.377L1259.79 612.103H1266.99L1270.59 618.377L1266.99 624.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 609.017H1259.79L1256.19 602.846L1259.79 596.674H1266.99L1270.59 602.846L1266.99 609.017Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 593.486H1259.79L1256.19 587.314L1259.79 581.143H1266.99L1270.59 587.314L1266.99 593.486Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 345.497H1259.79L1256.19 339.326L1259.79 333.154H1266.99L1270.59 339.326L1266.99 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.25 296.023H1261.54L1259.69 292.834L1261.54 289.543H1265.25L1267.1 292.834L1265.25 296.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.53 263.726H1262.26L1261.13 261.772L1262.26 259.817H1264.53L1265.66 261.772L1264.53 263.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1265.66 250.251H1261.13L1258.77 246.342L1261.13 242.331H1265.66L1268.02 246.342L1265.66 250.251Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.07 235.543H1260.72L1257.94 230.811L1260.72 226.08H1266.07L1268.85 230.811L1266.07 235.543Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 190.492H1259.79L1256.19 184.32L1259.79 178.046H1266.99L1270.59 184.32L1266.99 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 174.96H1259.79L1256.19 168.789L1259.79 162.617H1266.99L1270.59 168.789L1266.99 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 159.532H1259.79L1256.19 153.257L1259.79 147.086H1266.99L1270.59 153.257L1266.99 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 144H1259.79L1256.19 137.828L1259.79 131.554H1266.99L1270.59 137.828L1266.99 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1266.99 128.468H1259.79L1256.19 122.297L1259.79 116.125H1266.99L1270.59 122.297L1266.99 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1264.32 108.411H1262.47L1261.54 106.766L1262.47 105.223H1264.32L1265.25 106.766L1264.32 108.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.88 126.309H160.251L157.989 122.297L160.251 118.286H164.88L167.246 122.297L164.88 126.309Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 144H159.017L155.417 137.828L159.017 131.554H166.114L169.714 137.828L166.114 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 159.532H159.017L155.417 153.257L159.017 147.086H166.114L169.714 153.257L166.114 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 174.96H159.017L155.417 168.789L159.017 162.617H166.114L169.714 168.789L166.114 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 190.492H159.017L155.417 184.32L159.017 178.046H166.114L169.714 184.32L166.114 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 206.023H159.017L155.417 199.749L159.017 193.578H166.114L169.714 199.749L166.114 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 221.451H159.017L155.417 215.28L159.017 209.108H166.114L169.714 215.28L166.114 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 236.983H159.017L155.417 230.811L159.017 224.64H166.114L169.714 230.811L166.114 236.983Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 252.514H159.017L155.417 246.343L159.017 240.068H166.114L169.714 246.343L166.114 252.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 268.046H159.017L155.417 261.772L159.017 255.6H166.114L169.714 261.772L166.114 268.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 283.474H159.017L155.417 277.303L159.017 271.131H166.114L169.714 277.303L166.114 283.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 299.006H159.017L155.417 292.834L159.017 286.56H166.114L169.714 292.834L166.114 299.006Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 314.537H159.017L155.417 308.263L159.017 302.092H166.114L169.714 308.263L166.114 314.537Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 329.965H159.017L155.417 323.794L159.017 317.623H166.114L169.714 323.794L166.114 329.965Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.114 345.497H159.017L155.417 339.326L159.017 333.154H166.114L169.714 339.326L166.114 345.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.646 356.709H161.486L160.354 354.857L161.486 352.903H163.646L164.777 354.857L163.646 356.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.03 738.514H1274.61L1272.34 734.606L1274.61 730.697H1279.03L1281.29 734.606L1279.03 738.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 725.246H1273.27L1269.67 719.075L1273.27 712.903H1280.37L1283.97 719.075L1280.37 725.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 709.817H1273.27L1269.67 703.543L1273.27 697.372H1280.37L1283.97 703.543L1280.37 709.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 694.286H1273.27L1269.67 688.114L1273.27 681.943H1280.37L1283.97 688.114L1280.37 694.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 678.754H1273.27L1269.67 672.583L1273.27 666.412H1280.37L1283.97 672.583L1280.37 678.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 663.326H1273.27L1269.67 657.051L1273.27 650.88H1280.37L1283.97 657.051L1280.37 663.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 647.794H1273.27L1269.67 641.623L1273.27 635.349H1280.37L1283.97 641.623L1280.37 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 632.263H1273.27L1269.67 626.092L1273.27 619.92H1280.37L1283.97 626.092L1280.37 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 616.834H1273.27L1269.67 610.56L1273.27 604.389H1280.37L1283.97 610.56L1280.37 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1277.69 550.08H1275.94L1275.12 548.537L1275.94 547.097H1277.69L1278.51 548.537L1277.69 550.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 539.28H1273.27L1269.67 533.109L1273.27 526.834H1280.37L1283.97 533.109L1280.37 539.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1279.95 337.063H1273.68L1270.49 331.611L1273.68 326.057H1279.95L1283.14 331.611L1279.95 337.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.93 319.679H1274.71L1272.65 316.079L1274.71 312.479H1278.93L1280.98 316.079L1278.93 319.679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.1 302.709H1275.63L1274.4 300.549L1275.63 298.389H1278.1L1279.34 300.549L1278.1 302.709Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.06 290.674H1273.58L1270.39 285.017L1273.58 279.463H1280.06L1283.25 285.017L1280.06 290.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1278.31 256.629H1275.33L1273.89 254.057L1275.33 251.486H1278.31L1279.75 254.057L1278.31 256.629Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.26 198H1273.37L1269.87 192.034L1273.37 186.068H1280.26L1283.76 192.034L1280.26 198Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 182.777H1273.27L1269.67 176.503L1273.27 170.332H1280.37L1283.97 176.503L1280.37 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 167.246H1273.27L1269.67 161.075L1273.27 154.8H1280.37L1283.97 161.075L1280.37 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 151.714H1273.27L1269.67 145.543L1273.27 139.371H1280.37L1283.97 145.543L1280.37 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 136.286H1273.27L1269.67 130.011L1273.27 123.84H1280.37L1283.97 130.011L1280.37 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1280.37 120.754H1273.27L1269.67 114.583L1273.27 108.309H1280.37L1283.97 114.583L1280.37 120.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.743 136.286H145.543L142.046 130.011L145.543 123.84H152.743L156.343 130.011L152.743 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.743 151.714H145.543L142.046 145.543L145.543 139.371H152.743L156.343 145.543L152.743 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.743 167.246H145.543L142.046 161.075L145.543 154.8H152.743L156.343 161.075L152.743 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.743 182.777H145.543L142.046 176.503L145.543 170.332H152.743L156.343 176.503L152.743 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.743 198.206H145.543L142.046 192.034L145.543 185.863H152.743L156.343 192.034L152.743 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.743 213.737H145.543L142.046 207.565L145.543 201.394H152.743L156.343 207.565L152.743 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.537 228.96H145.749L142.354 223.097L145.749 217.131H152.537L155.931 223.097L152.537 228.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.817 243.051H146.572L143.897 238.526L146.572 234H151.817L154.389 238.526L151.817 243.051Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 256.32H147.909L146.571 254.057L147.909 251.794H150.48L151.714 254.057L150.48 256.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.966 270.925H148.423L147.6 269.588L148.423 268.251H149.966L150.686 269.588L149.966 270.925Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.274 287.074H148.011L146.777 285.017L148.011 283.063H150.274L151.509 285.017L150.274 287.074Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 302.811H147.909L146.571 300.549L147.909 298.286H150.48L151.714 300.549L150.48 302.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.714 320.606H146.571L144 316.08L146.571 311.554H151.714L154.389 316.08L151.714 320.606Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.48 333.771H147.909L146.571 331.611L147.909 329.349H150.48L151.714 331.611L150.48 333.771Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 748.492H1286.64L1283.14 742.32L1286.64 736.149H1293.84L1297.34 742.32L1293.84 748.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.99 729.874H1288.49L1286.74 726.891L1288.49 723.806H1291.99L1293.74 726.891L1291.99 729.874Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 717.532H1286.64L1283.14 711.36L1286.64 705.189H1293.84L1297.44 711.36L1293.84 717.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 702H1286.64L1283.14 695.829L1286.64 689.657H1293.84L1297.44 695.829L1293.84 702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 686.572H1286.64L1283.14 680.297L1286.64 674.126H1293.84L1297.44 680.297L1293.84 686.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 671.04H1286.64L1283.14 664.868L1286.64 658.594H1293.84L1297.44 664.868L1293.84 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 655.508H1286.64L1283.14 649.337L1286.64 643.166H1293.84L1297.44 649.337L1293.84 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 640.08H1286.64L1283.14 633.806L1286.64 627.635H1293.84L1297.44 633.806L1293.84 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 624.549H1286.64L1283.14 618.377L1286.64 612.103H1293.84L1297.44 618.377L1293.84 624.549Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.68 605.315H1288.8L1287.46 602.846L1288.8 600.377H1291.68L1293.12 602.846L1291.68 605.315Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.74 562.32H1286.74L1283.35 556.355L1286.74 550.286H1293.74L1297.23 556.355L1293.74 562.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 546.994H1286.64L1283.14 540.823L1286.64 534.651H1293.84L1297.44 540.823L1293.84 546.994Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1291.06 526.834H1289.42L1288.49 525.291L1289.42 523.851H1291.06L1291.99 525.291L1291.06 526.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1292.5 203.76H1287.98L1285.71 199.749L1287.98 195.84H1292.5L1294.77 199.749L1292.5 203.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 190.492H1286.64L1283.14 184.32L1286.64 178.046H1293.84L1297.44 184.32L1293.84 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 174.96H1286.64L1283.14 168.789L1286.64 162.617H1293.84L1297.44 168.789L1293.84 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 159.532H1286.64L1283.14 153.257L1286.64 147.086H1293.84L1297.44 153.257L1293.84 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.84 144H1286.64L1283.14 137.828L1286.64 131.554H1293.84L1297.44 137.828L1293.84 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1293.74 128.366H1286.74L1283.25 122.297L1286.74 116.229H1293.74L1297.23 122.297L1293.74 128.366Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.343 126.72H133.2L130.629 122.297L133.2 117.874H138.343L140.914 122.297L138.343 126.72Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.269 144H132.171L128.571 137.828L132.171 131.554H139.269L142.869 137.828L139.269 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.269 159.532H132.171L128.571 153.257L132.171 147.086H139.269L142.869 153.257L139.269 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.269 174.96H132.171L128.571 168.789L132.171 162.617H139.269L142.869 168.789L139.269 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.269 190.492H132.171L128.571 184.32L132.171 178.046H139.269L142.869 184.32L139.269 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.269 206.023H132.171L128.571 199.749L132.171 193.578H139.269L142.869 199.749L139.269 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.549 220.114H132.892L130.114 215.28L132.892 210.446H138.549L141.326 215.28L138.549 220.114Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.54 736.046H1302.89L1302.07 734.606L1302.89 733.166H1304.54L1305.36 734.606L1304.54 736.046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.11 724.937H1300.32L1296.93 719.074L1300.32 713.211H1307.11L1310.4 719.074L1307.11 724.937Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.21 709.817H1300.11L1296.51 703.543L1300.11 697.372H1307.21L1310.81 703.543L1307.21 709.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.21 694.286H1300.11L1296.51 688.114L1300.11 681.943H1307.21L1310.81 688.114L1307.21 694.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.21 678.754H1300.11L1296.51 672.583L1300.11 666.412H1307.21L1310.81 672.583L1307.21 678.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.21 663.326H1300.11L1296.51 657.051L1300.11 650.88H1307.21L1310.81 657.051L1307.21 663.326Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.21 647.794H1300.11L1296.51 641.623L1300.11 635.349H1307.21L1310.81 641.623L1307.21 647.794Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.21 632.263H1300.11L1296.51 626.092L1300.11 619.92H1307.21L1310.81 626.092L1307.21 632.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.21 616.834H1300.11L1296.51 610.56L1300.11 604.389H1307.21L1310.81 610.56L1307.21 616.834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1306.9 600.583H1300.53L1297.23 595.131L1300.53 589.577H1306.9L1310.09 595.131L1306.9 600.583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1304.85 581.554H1302.48L1301.35 579.6L1302.48 577.542H1304.85L1305.98 579.6L1304.85 581.554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.01 569.828H1300.42L1297.03 564.068L1300.42 558.411H1307.01L1310.3 564.068L1307.01 569.828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.21 554.811H1300.11L1296.51 548.537L1300.11 542.366H1307.21L1310.81 548.537L1307.21 554.811Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.21 182.674H1300.11L1296.51 176.503L1300.11 170.332H1307.21L1310.81 176.503L1307.21 182.674Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.21 167.246H1300.11L1296.51 161.075L1300.11 154.8H1307.21L1310.81 161.075L1307.21 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.21 151.714H1300.11L1296.51 145.543L1300.11 139.371H1307.21L1310.81 145.543L1307.21 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1307.21 136.286H1300.11L1296.51 130.011L1300.11 123.84H1307.21L1310.81 130.011L1307.21 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.017 115.714H121.68L120.96 114.583L121.68 113.349H123.017L123.634 114.583L123.017 115.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.897 136.286H118.697L115.2 130.011L118.697 123.84H125.897L129.497 130.011L125.897 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.897 151.714H118.697L115.2 145.543L118.697 139.371H125.897L129.497 145.543L125.897 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.897 167.246H118.697L115.2 161.075L118.697 154.8H125.897L129.497 161.075L125.897 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.897 182.777H118.697L115.2 176.503L118.697 170.332H125.897L129.497 176.503L125.897 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.897 198.206H118.697L115.2 192.034L118.697 185.863H125.897L129.497 192.034L125.897 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.869 211.988H119.726L117.154 207.565L119.726 203.143H124.869L127.44 207.565L124.869 211.988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1319.25 715.063H1314.93L1312.77 711.36L1314.93 707.657H1319.25L1321.41 711.36L1319.25 715.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.69 702H1313.49L1309.99 695.829L1313.49 689.657H1320.69L1324.29 695.829L1320.69 702Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.69 686.572H1313.49L1309.99 680.297L1313.49 674.126H1320.69L1324.29 680.297L1320.69 686.572Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.69 671.04H1313.49L1309.99 664.868L1313.49 658.594H1320.69L1324.29 664.868L1320.69 671.04Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.69 655.508H1313.49L1309.99 649.337L1313.49 643.166H1320.69L1324.29 649.337L1320.69 655.508Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.69 640.08H1313.49L1309.99 633.806L1313.49 627.635H1320.69L1324.29 633.806L1320.69 640.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.17 623.726H1314L1310.91 618.377L1314 612.926H1320.17L1323.26 618.377L1320.17 623.726Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.58 562.32H1313.59L1310.09 556.355L1313.59 550.286H1320.58L1324.08 556.355L1320.58 562.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1317.81 247.474H1316.47L1315.75 246.343L1316.47 245.108H1317.81L1318.42 246.343L1317.81 247.474Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.38 236.571H1313.79L1310.4 230.811L1313.79 225.051H1320.38L1323.77 230.811L1320.38 236.571Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.69 221.451H1313.49L1309.99 215.28L1313.49 209.108H1320.69L1324.29 215.28L1320.69 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.58 205.817H1313.59L1310.19 199.748L1313.59 193.783H1320.58L1324.08 199.748L1320.58 205.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1318.83 187.303H1315.34L1313.69 184.32L1315.34 181.337H1318.83L1320.58 184.32L1318.83 187.303Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.69 174.96H1313.49L1309.99 168.789L1313.49 162.617H1320.69L1324.29 168.789L1320.69 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.69 159.532H1313.49L1309.99 153.257L1313.49 147.086H1320.69L1324.29 153.257L1320.69 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.69 144H1313.49L1309.99 137.828L1313.49 131.554H1320.69L1324.29 137.828L1320.69 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1320.58 128.263H1313.69L1310.19 122.297L1313.69 116.332H1320.58L1323.98 122.297L1320.58 128.263Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.423 128.468H105.326L101.726 122.297L105.326 116.125H112.423L116.023 122.297L112.423 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.423 144H105.326L101.726 137.828L105.326 131.554H112.423L116.023 137.828L112.423 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.423 159.532H105.326L101.726 153.257L105.326 147.086H112.423L116.023 153.257L112.423 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.423 174.96H105.326L101.726 168.789L105.326 162.617H112.423L116.023 168.789L112.423 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.423 190.492H105.326L101.726 184.32L105.326 178.046H112.423L116.023 184.32L112.423 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.851 201.395H108L107.074 199.749L108 198.206H109.851L110.777 199.749L109.851 201.395Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.23 692.846H1327.78L1325.11 688.114L1327.78 683.383H1333.23L1336.01 688.114L1333.23 692.846Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.06 678.754H1326.96L1323.36 672.583L1326.96 666.412H1334.06L1337.66 672.583L1334.06 678.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.06 663.12H1327.06L1323.46 657.051L1327.06 650.982H1334.06L1337.55 657.051L1334.06 663.12Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.93 645.635H1328.19L1325.83 641.623L1328.19 637.509H1332.93L1335.29 641.623L1332.93 645.635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1331.9 566.435H1329.12L1327.78 564.069L1329.12 561.703H1331.9L1333.23 564.069L1331.9 566.435Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1333.95 228.96H1327.17L1323.77 223.097L1327.17 217.131H1333.95L1337.35 223.097L1333.95 228.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.06 213.634H1327.06L1323.57 207.566L1327.06 201.497H1334.06L1337.55 207.566L1334.06 213.634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.06 198.206H1326.96L1323.46 192.034L1326.96 185.966H1334.06L1337.55 192.034L1334.06 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.06 182.777H1326.96L1323.36 176.503L1326.96 170.332H1334.06L1337.66 176.503L1334.06 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.06 167.246H1326.96L1323.36 161.075L1326.96 154.8H1334.06L1337.66 161.075L1334.06 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.06 151.714H1326.96L1323.36 145.543L1326.96 139.371H1334.06L1337.66 145.543L1334.06 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1334.06 136.286H1326.96L1323.36 130.011L1326.96 123.84H1334.06L1337.66 130.011L1334.06 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1332.1 117.258H1328.91L1327.37 114.583L1328.91 111.806H1332.1L1333.65 114.583L1332.1 117.258Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.3028 117.772H93.6L91.7485 114.583L93.6 111.292H97.3028L99.2571 114.583L97.3028 117.772Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0516 136.286H91.8516L88.2516 130.011L91.8516 123.84H99.0516L102.652 130.011L99.0516 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0516 151.714H91.8516L88.2516 145.543L91.8516 139.371H99.0516L102.652 145.543L99.0516 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0516 167.246H91.8516L88.2516 161.075L91.8516 154.8H99.0516L102.652 161.075L99.0516 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0516 182.777H91.8516L88.2516 176.503L91.8516 170.332H99.0516L102.652 176.503L99.0516 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.0516 198.206H91.8516L88.2516 192.034L91.8516 185.863H99.0516L102.652 192.034L99.0516 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1345.27 636.172H1342.59L1341.36 633.806L1342.59 631.543H1345.27L1346.61 633.806L1345.27 636.172Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1344.86 619.92H1343.01L1342.08 618.377L1343.01 616.731H1344.86L1345.78 618.377L1344.86 619.92Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.53 190.491H1340.43L1336.83 184.32L1340.43 178.148H1347.53L1351.13 184.32L1347.53 190.491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.53 174.96H1340.33L1336.83 168.789L1340.33 162.617H1347.53L1351.13 168.789L1347.53 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.53 159.532H1340.33L1336.83 153.257L1340.33 147.086H1347.53L1351.13 153.257L1347.53 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.53 144H1340.33L1336.83 137.828L1340.33 131.554H1347.53L1351.13 137.828L1347.53 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1347.53 128.468H1340.43L1336.83 122.297L1340.43 116.125H1347.53L1351.13 122.297L1347.53 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9028 108.206H81.2571L80.3314 106.766L81.2571 105.326H82.9028L83.7257 106.766L82.9028 108.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5773 128.468H78.4801L74.8801 122.297L78.4801 116.125H85.5773L89.1773 122.297L85.5773 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5773 144H78.4801L74.8801 137.828L78.4801 131.554H85.5773L89.1773 137.828L85.5773 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5773 159.532H78.4801L74.8801 153.257L78.4801 147.086H85.5773L89.1773 153.257L85.5773 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5773 174.96H78.4801L74.8801 168.789L78.4801 162.617H85.5773L89.1773 168.789L85.5773 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5773 190.492H78.4801L74.8801 184.32L78.4801 178.046H85.5773L89.1773 184.32L85.5773 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5773 206.023H78.4801L74.8801 199.749L78.4801 193.578H85.5773L89.1773 199.749L85.5773 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5773 221.451H78.4801L74.8801 215.28L78.4801 209.108H85.5773L89.1773 215.28L85.5773 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1358.43 193.886H1356.38L1355.35 192.034L1356.38 190.286H1358.43L1359.46 192.034L1358.43 193.886Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.01 182.777H1353.81L1350.21 176.503L1353.81 170.332H1361.01L1364.5 176.503L1361.01 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.01 167.246H1353.81L1350.21 161.075L1353.81 154.8H1361.01L1364.5 161.075L1361.01 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.01 151.714H1353.81L1350.21 145.543L1353.81 139.371H1361.01L1364.5 145.543L1361.01 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1361.01 136.286H1353.81L1350.21 130.011L1353.81 123.84H1361.01L1364.5 130.011L1361.01 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.6915 119.829H65.5201L62.5372 114.583L65.5201 109.235H71.6915L74.6744 114.583L71.6915 119.829Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2056 136.286H65.0056L61.4056 130.011L65.0056 123.84H72.2056L75.8056 130.011L72.2056 136.286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2056 151.714H65.0056L61.4056 145.543L65.0056 139.371H72.2056L75.8056 145.543L72.2056 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2056 167.246H65.0056L61.4056 161.075L65.0056 154.8H72.2056L75.8056 161.075L72.2056 167.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2056 182.777H65.0056L61.4056 176.503L65.0056 170.332H72.2056L75.8056 176.503L72.2056 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.2056 198.206H65.0056L61.4056 192.034L65.0056 185.863H72.2056L75.8056 192.034L72.2056 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.103 213.634H65.1087L61.5087 207.565L65.1087 201.394H72.103L75.703 207.565L72.103 213.634Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.8971 228.754H65.3143L62.0228 223.097L65.3143 217.337H71.8971L75.1885 223.097L71.8971 228.754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.39 774.514H1370.16L1369.54 773.383L1370.16 772.251H1371.39L1372.11 773.383L1371.39 774.514Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.38 174.96H1367.18L1363.68 168.789L1367.18 162.617H1374.38L1377.98 168.789L1374.38 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.38 159.532H1367.18L1363.68 153.257L1367.18 147.086H1374.38L1377.98 153.257L1374.38 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1374.38 144H1367.18L1363.68 137.828L1367.18 131.554H1374.38L1377.98 137.828L1374.38 144Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1371.6 123.737H1369.95L1369.13 122.297L1369.95 120.857H1371.6L1372.42 122.297L1371.6 123.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7313 128.468H51.6342L48.0342 122.297L51.6342 116.125H58.7313L62.3313 122.297L58.7313 128.468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3199 143.28H52.0456L48.8571 137.829L52.0456 132.377H58.3199L61.5085 137.829L58.3199 143.28Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7313 159.532H51.6342L48.0342 153.257L51.6342 147.086H58.7313L62.3313 153.257L58.7313 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7313 174.96H51.6342L48.0342 168.789L51.6342 162.617H58.7313L62.3313 168.789L58.7313 174.96Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7313 190.492H51.6342L48.0342 184.32L51.6342 178.046H58.7313L62.3313 184.32L58.7313 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7313 206.023H51.6342L48.0342 199.749L51.6342 193.578H58.7313L62.3313 199.749L58.7313 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.7313 221.451H51.6342L48.0342 215.28L51.6342 209.108H58.7313L62.3313 215.28L58.7313 221.451Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.65 771.532H1380.75L1377.36 765.566L1380.75 759.6H1387.65L1391.14 765.566L1387.65 771.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.38 752.091H1383.02L1381.89 750.137L1383.02 748.08H1385.38L1386.62 750.137L1385.38 752.091Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1385.28 178.252H1383.22L1382.19 176.503L1383.22 174.754H1385.28L1386.21 176.503L1385.28 178.252Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1386.41 164.777H1382.09L1379.83 161.074L1382.09 157.269H1386.41L1388.57 161.074L1386.41 164.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.85 151.714H1380.65L1377.05 145.543L1380.65 139.371H1387.85L1391.35 145.543L1387.85 151.714Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1387.13 135.052H1381.27L1378.39 130.012L1381.27 124.972H1387.13L1390.01 130.012L1387.13 135.052Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3771 115.611H41.1428L40.5256 114.583L41.1428 113.451H42.3771L42.9942 114.583L42.3771 115.611Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.4058 132.891H40.1143L38.4686 130.011L40.1143 127.131H43.4058L45.1543 130.011L43.4058 132.891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.2573 151.612H38.263L34.7659 145.543L38.263 139.475H45.2573L48.8573 145.543L45.2573 151.612Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5371 165.909H38.9828L36.1028 161.074L38.9828 156.137H44.5371L47.4171 161.074L44.5371 165.909Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3599 182.777H38.1599L34.5599 176.503L38.1599 170.332H45.3599L48.9599 176.503L45.3599 182.777Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3599 198.206H38.1599L34.5599 192.034L38.1599 185.863H45.3599L48.9599 192.034L45.3599 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.3599 213.737H38.1599L34.5599 207.565L38.1599 201.394H45.3599L48.9599 207.565L45.3599 213.737Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.36 229.268H38.16L34.6628 223.097L38.16 216.823H45.36L48.8571 223.097L45.36 229.268Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.78 761.555H1395.57L1393.41 757.852L1395.57 754.149H1399.78L1401.84 757.852L1399.78 761.555Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.91 748.08H1394.33L1391.04 742.32L1394.33 736.663H1400.91L1404.21 742.32L1400.91 748.08Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1400.09 157.577H1395.15L1392.69 153.257L1395.15 149.04H1400.09L1402.66 153.257L1400.09 157.577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1399.99 141.84H1395.36L1392.99 137.829L1395.36 133.817H1399.99L1402.25 137.829L1399.99 141.84Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5201 139.783H27.1544L26.0229 137.829L27.1544 135.771H29.5201L30.6515 137.829L29.5201 139.783Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8856 159.532H24.7885L21.1885 153.257L24.7885 147.086H31.8856L35.4856 153.257L31.8856 159.532Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9029 169.817H27.7714L27.1543 168.789L27.7714 167.76H28.9029L29.52 168.789L28.9029 169.817Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8856 190.492H24.7885L21.1885 184.32L24.7885 178.046H31.8856L35.4856 184.32L31.8856 190.492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.8856 206.023H24.7885L21.1885 199.749L24.7885 193.578H31.8856L35.4856 199.749L31.8856 206.023Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9315 218.058H26.7429L25.0972 215.281L26.7429 212.503H29.9315L31.5772 215.281L29.9315 218.058Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3428 234.206H26.3314L24.3771 230.812L26.3314 227.417H30.3428L32.2971 230.812L30.3428 234.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1657 251.281H25.5085L22.6285 246.343L25.5085 241.406H31.1657L34.0457 246.343L31.1657 251.281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1411.82 751.372H1410.38L1409.66 750.138L1410.38 748.903H1411.82L1412.54 750.138L1411.82 751.372Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.26 738.411H1408.83L1406.67 734.606L1408.83 730.8H1413.26L1415.52 734.606L1413.26 738.411Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1412.23 721.132H1409.86L1408.73 719.074L1409.86 717.12H1412.23L1413.36 719.074L1412.23 721.132Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.05 164.469H1409.14L1407.09 161.074L1409.14 157.577H1413.05L1415.01 161.074L1413.05 164.469Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1413.15 149.143H1409.04L1406.88 145.543L1409.04 141.943H1413.15L1415.21 145.543L1413.15 149.143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1771 149.452H12.6514L10.3885 145.543L12.6514 141.635H17.1771L19.44 145.543L17.1771 149.452Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6914 181.44H12.1371L9.25708 176.503L12.1371 171.668H17.6914L20.5714 176.503L17.6914 181.44Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5142 198.206H11.3142L7.71423 192.034L11.3142 185.863H18.5142L22.1142 192.034L18.5142 198.206Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6914 212.4H12.1371L9.25708 207.566L12.1371 202.731H17.6914L20.5714 207.566L17.6914 212.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7371 239.966H14.0914L13.2686 238.526L14.0914 237.188H15.7371L16.56 238.526L15.7371 239.966Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0744 257.76H12.7544L10.5944 254.057L12.7544 250.354H17.0744L19.2344 254.057L17.0744 257.76Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1427.45 732.035H1421.49L1418.5 726.892L1421.49 721.646H1427.45L1430.54 726.892L1427.45 732.035Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1428.07 717.429H1420.97L1417.47 711.36L1420.97 705.189H1428.07L1431.57 711.36L1428.07 717.429Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1425.19 697.063H1423.75L1423.13 695.829L1423.75 694.594H1425.19L1425.91 695.829L1425.19 697.063Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26286 185.554H0.72L0 184.32L0.72 182.982H2.26286L2.98286 184.32L2.26286 185.554Z",
    fill: "#EBECF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.26286 247.577H0.72L0 246.343L0.72 245.006H2.26286L2.98286 246.343L2.26286 247.577Z",
    fill: "#EBECF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15993 263.006H0.822783L0.102783 261.772L0.822783 260.64H2.15993L2.87993 261.772L2.15993 263.006Z",
    fill: "#EBECF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1438.97 705.394H1436.91L1435.89 703.543L1436.91 701.794H1438.97L1440 703.543L1438.97 705.394Z",
    fill: "#EBECF7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_7475_8215",
    x: -82.2857,
    y: -12.5556,
    width: 1604.57,
    height: 1039.79,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 36.9
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.7278
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.209938 0 0 0 0 0.141163 0 0 0 0 0.720833 0 0 0 0.0469633 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7475_8215"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 122.4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 41.1429
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.220859 0 0 0 0 0.148507 0 0 0 0 0.758333 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_7475_8215",
    result: "effect2_dropShadow_7475_8215"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_7475_8215",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoginBackground);
export default __webpack_public_path__ + "static/media/loginBackground.1d5ec3230941543ffb6b5b673162f235.svg";
export { ForwardRef as ReactComponent };